import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Button, Checkbox, ConfigProvider, Dropdown, Empty, Input, message, Select, Spin, Tooltip,Popover,} from "antd";
import {
    IconAddToFavor,
    IconCloseBlack,
    IconCopyLink,
    IconDropdownSelected,
    IconHomeSearch,
    IconIndicatorBlue, IconMenuChecked, IconMenuChecked1, IconMenuExportItem,
    IconNote, IconRemoveFavor, IconTransparent
} from "../../Icon";
import {Grid} from 'react-virtualized';
import {
    base64ToBlob, checkIfAbsolute, containsAllEvery,
    createCopyLink,
    createCopyLinkByLibraryItem,
    createEmptyProject,
    createFileElementHtml, decodeDeeplink,
    firstLetterUpper, formatDate,
    generateRandomPageKey,
    generateUUID2, getAudioFilterExt,
    getBase64ImageSize,
    getFileName,
    getFileNameExt,
    getFileNameWithoutExt, getImageExt, getImagePath,
    getImagePathWithTheme, getImagePathWithThemeSvg,
    getItem, getJournalName, getLocalFilePath,
    getPdfImageThumb, getSafeFloat, getTimeText,
    getVideoImageThumb,
    getVideoScale,
    hasBeyondFreeLimit, hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix, isAnnoElement, isAnnoType,
    isArray,
    isAudio, isAudioAnnoElement,
    isAudioFileElement, isCardAnnoElement,
    isCardEmpty,
    isDarkMode, isDeepLink,
    isFileElement,
    isFileVideoElement,
    isImage, isInDraw, isInJournal, isInPageCard, isInPageLibrary, isMarkdown, isNoteElement, isObject,
    isOtherFileElement,
    isPdf,
    isPdfAnnoElement,
    isPdfFileElement, isShortcuts,
    isStringNullOrEmpty,
    isVideo, isVideoAnnoElement,
    removeHtmlTags
} from "../../utils";
import style from './PageLibrary.module.less'
import {t} from "i18next";
import {
    BUTTON_PADDING,
    DELETE_STATUS_FOR_HIDDEN_FOREVER,
    EVENT_BOARD_CHANGED, EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_PDF_ON_SLIDER_RIGHT,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_LIBRARY_TAG_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_RENAME_LIBRARY_ITEM,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    EVENT_SWITCH_HOME_LIST_MENU,
    EVENT_UPDATE_NOTE,
    FILTER_NO_TAGS_NO_TAGS_______,
    FILTER_TAG_NO_TAGS,
    FROM_ADD,
    FROM_DIALOG,
    FROM_HOME_LIBRARY,
    FROM_LIBRARY, FROM_RIGHT_SIDE, FROM_TAG, GET_ARRAY_LIBRARY_TYPES,
    getNoteElementBackgroundColor,
    getNoteElementStrokeColor,
    HEADER_HEIGHT, HOME_LEFT_MENU_WIDTH, IMPORT_FILE_MODE_IMPORTMODE,
    KEY_ANNO_TYPES,
    KEY_CARD_ORDER_BY,
    KEY_CARD_SORT_TYPE,
    KEY_CARD_VIEW_STYLE,
    KEY_FILE_DIR,
    KEY_FILTER_CUSTOM_FILTER,
    KEY_FILTER_SELECT_PROJECT,
    KEY_FILTER_SELECT_TAG,
    KEY_LIBRARY_SELECTED_TYPES,
    KEY_SHOW_HIDIN_CARDS, KEY_TYPE_SWITCHER,
    LEFT_MENU_WIDTH,
    MENU_SEPARATOR,
    PAGE_TITLE_MARGIN_TOP,
    SEARCH_WIDTH,
    VIEW_STYLE, WIDTH_3, WIDTH_4, WIDTH_5
} from "@/Const";
import {CheckOutlined} from "@ant-design/icons";
import {openEditor} from "@/state";
import Global from "@/global";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
    deleteEmptyCards,
    getCardById, getCardByIds, getCardCount,
    getCardDoc,
    getCardList, getCardListByLibraryId, getEmptyCardCount, getLibraryCount, getSourceByAnnoType,
    isCardExistInDb,
    renameCard,
    updateCard, updateChangeSource, updateChangeSourcePdfAudio20260126, updateChangeSourceVideo
} from "@model/card";
import Note from "@/views/Note/NoteItem/NoteItemIndex";
import CardItem from "@/views/Library/CardItem";
import {
    deleteAllCardFromRefProject,
    getNoteById,
    getNoteDoc, getNoteJsonDoc,
    getNoteList, getPublishProjectList,
    updateNote,
    updateNoteDoc
} from "@model/note";
import {getTagList} from "@model/tag";
import DialogTagManager from "@/views/Dialog/DialogTagManager";
import DialogMessageBox from "@/common/DialogMessageBox";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import DialogCommonInput from "@/common/DialogCommonInput";
import {editDoc} from "@model/doc";
import DialogChooseProject from "@/views/Dialog/DialogChooseProject";
import DialogAllTagManager from "@/views/Library/DialogAllTagManager";
import {MIME_TYPES, ROUNDNESS} from "../../../@excalidraw/packages/excalidraw/constants";
import {APP_WEB_WWW, isWeb, isWebApp} from "@/electron_interactive";
import {uploadS3File} from "@/api/AwsUpload";
import {resizeImageFile} from "../../../@excalidraw/packages/excalidraw/data/blob";
import {fileToBase64, ImagePaste} from "@/components/EditorV2/ImagePaste";
import {useEditor} from "@tiptap/react";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import {FontFamily} from "@tiptap/extension-font-family";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import DialogChooseImage from "@/views/Draw/DialogChooseImage";
import {isZh} from "@/language";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import global from "@/global";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {
    beyondFreePdfLimit,
    beyondFreeVideoLimit,
    createBreadcrumb, getCardPath, getCardTitle,
    getDrawPath, getFavorChildrenMenu,
    getScheme,
    getSearchWidth, insertDeeplinkToCard, isGlobalRightSlider, isMac, updateFavorToFolder
} from "@/Utility";
import {useAtom} from "jotai";
import {atomSliderWidth} from "@/App";
import {dbGetHighlight, dbGetHighlightByLibraryId, updateHighlight} from "@model/highlight";
import {
    isEmbedableBookmarkElement,
    isEmbeddableElement,
    isImageElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import dayjs from "dayjs";
import {videoCache} from "../../../@excalidraw/packages/excalidraw/components/App";
import {saveElementVideoNotesAsJSON} from "../../../@excalidraw/packages/excalidraw/data/json";
import {exportCurrentElementVideoNotes, getCurrentElementVideoNotes, onImportHighlights} from "@/VideoHighlightUtils";
import {atomCardItemPointerEvent} from "@/views/Home/HomeIndex";
import clipboard from "clipboardy";
import {getCustomFilterList, updateCustomFilter} from "@model/customFilter";
import {offset} from "../../../@excalidraw/packages/excalidraw/ga";
import {useLocation} from "react-use";
import UniqueID from "@tiptap-pro/extension-unique-id";
import {json} from "express";
import {debugLog} from "@/LogUtils";
import {getCardTitle0} from "@/Utility0";
import {loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {getHeadingExtend} from "@/components/EditorV2/EditorExtensions/HeadingExtend";
import {copyTextToSystemClipboard} from "../../../@excalidraw/packages/excalidraw/clipboard";
import {measureTitleHeight, shareCardData} from "../Utils/CardUtils";
import {downloadImageAsBlob, serializeProseMirrorToMarkdown} from "@/components/EditorV2/markdownSerializer";
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import LibraryTab from "@/views/Library/LibraryTab";
import {getPublishNoteById} from "@model/publishNote";

let mSortTypeDesc = "Last viewed";
let mViewStyle:any = VIEW_STYLE.VIEW_STYLE_GRID;
// let mIsQuerying:boolean = false;
let mArrayProjects:any = [];
let mArrayTags:any = [];
let mSelectType:any;


let mSelectProjectId:string='all';
let mProjectInfo:string;
let mMapIdCheck:any={};

// let mIsLoadingMore = false;

const FILTER_PROJECT_ID_ALL = "all";
const FILTER_PROJECT_ID_ALL_IN_PROJECT = "allInProject";
const FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL = "notInProject";
const FILTER_PROJECT_CURRENT_PROJECT = "currentProject";
const FILTER_PROJECT_CURRENT_BOARD = "currentBoard";
const CHECK_ALL = "checkAll";


// 是否需要(允许)处理鼠标的移动事件,默认识不处理
var select = false;
// 定义移动元素div
var rect:any = null;
// 记录鼠标按下时的坐标
var downX = 0;
var downY = 0;
// 记录鼠标抬起时候的坐标
var mouseX2=downX;
var mouseY2=downY;
var mMouseDownTime:any = 0;
let mHandleTime = 0;


const PageLibrary = forwardRef((props:{from:string,subFromPage?:string,type:string,onItemSelectedCallback?:any,isInsertNewLibrary?:boolean,pointerEvent?:any,szContainerId?:any,searchKey?:any,source?:any,extra?:any,onPasteCallback?:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onSearchEvent:onSearchEvent,
        onSliderEvent:onSliderEvent,
        onUpdateType:(szType:any)=>{
            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                const item = ARRAY_LIBRARY_TYPES[i];
                if (item.value == szType){
                    mSelectType = item;
                    setSelectType(item);
                    mPageNum.current = 0;
                    updateList();
                    break;
                }
            }
        },
    }))

    const ARRAY_CARD_EXPORT = [
        {
            value:'exportPdf',
            label:t("ExportPDF"),
        },
        {
            value:'exportMarkdown',
            label:t("ExportMarkdown"),
        }]

    const ARRAY_DEFAULT_TYPE_SWITCHER = ()=>{
        return [
            {
                value:'all',
                label:t("All"),
                isSelected:true
            },
            {
                value:'card',
                label:t("Card"),
                buttonLabel:t("New card"),
                icon:'library_type_card'
            },
            {
                value:'journal',
                label:t("Journal"),
                buttonLabel:t("New journal"),
                icon:'library_type_journal'
            },
            {
                value:'pdf',
                label:t("PDF"),
                buttonLabel:t("New PDF"),
                ext:'.pdf',
                icon:'library_type_pdf'
            },
            {
                value:'image',
                label:t("Image"),
                buttonLabel:t("New image"),
                ext:'.jpg,.jpeg,.bmp,.png',
                icon:'library_type_image'
            },
            {
                value:'video',
                label:t("Video"),
                buttonLabel:t("New video"),
                ext:'.mp4,.mov',
                icon:'library_type_video'
            },
        ]
    }

    const ARRAY_LIBRARY_TYPES = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card.svg'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf.svg'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal.svg'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image.svg'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video.svg'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video.svg'
        },
        // {
        //     value:'image',
        //     label:t("Image"),
        //     buttonLabel:t("New image"),
        //     ext:'.jpg,.jpeg,.bmp,.png'
        // },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio.svg'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file.svg'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink.svg'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno.svg'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno.svg'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno.svg'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno.svg'
        },
        // {
        //     value:'project',
        //     label:t("Project"),
        //     buttonLabel:t("Audio"),
        //     ext:'.mp3',
        //     icon:'library_type_project.svg'
        // },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*',
            icon:'library_type_all.svg'
        }
    ]

    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color:'white',fontSize:'0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    /**
     * 更多菜单
     */
    const getLibraryMoreMenu = ()=>{
        return [
            getItem(t("Delete empty cards"), 'deleteEmptyCards', (localStorage.getItem(KEY_SHOW_HIDIN_CARDS)=='true')?<IconTransparent/>:null, undefined, undefined, () => {
                getEmptyCardCount().then(res=>{
                    window.showMessageBox(t("Delete empty cards"),t("SureToDeleteEmptyCard").replace("{0}",`${res}`),t("Cancel"),t("Delete"),null,()=>{
                        deleteEmptyCards().then(res=>{
                            mPageNum.current = 0;
                            updateList();
                            message.success(t("Has deleted"));
                        });
                    })
                })
            }),
            getItem(t("Show all hide cards"), 'showAllHideCards',(localStorage.getItem(KEY_SHOW_HIDIN_CARDS)=='true')?<IconMenuChecked1/>:null, undefined, undefined, () => {
                showOrHiddenCards();
            }),
        ]
    }

    const [searchKey,setSearchKey] = useState('');
    const [sortMenuOpen, setSortMenuOpen] = useState(false);
    const [sortTypeDesc,setSortTypeDesc] = useState(mSortTypeDesc);
    const [viewStyle, setViewStyle] = useState<VIEW_STYLE>(mViewStyle);
    const [arrayCardList,setArrayCardList] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const [isOpenProjectType,setIsOpenProjectType] = useState(false);
    const [isOpenProjectSelect,setIsOpenProjectSelect] = useState(false);
    const [isOpenTagSelect,setIsOpenTagSelect] = useState(false);
    const [isOpenFilter,setIsOpenFilter] = useState(false);
    const [isOpenSource,setIsOpenSource] = useState(false);
    const [selectCustomFilter,setSelectCustomFilter] = useState(null);
    const [arrayProjects,setArrayProjects] = useState([]);
    const [arrayTags,setArrayTags] = useState([]);
    const [arrayFilters,setArrayFilters] = useState([]);
    const [selectProjectValue,setSelectProjectValue] = useState(mSelectProjectId);
    const [selectTagValue,setSelectTagValue] = useState(t("Tags"));
    const [selectSourceValue,setSelectSourceValue] = useState(t("Source"))
    const [selectType,setSelectType] = useState(ARRAY_LIBRARY_TYPES[0]);
    const [newButtonText,setNewButtonText] = useState(t("New card"));
    const [leftTitle,setLeftTitle] = useState(t("Card"));
    const [isShowChecked,setIsShowChecked] = useState(false);
    const [showCheckedTitle,setShowCheckedTitle] = useState('');
    const [tipsInfo,setTipsInfo] = useState('');
    const [isClearFilterVisible,setIsClearFilterVisible] = useState(false);
    const [isNewCardHover,setIsNewCardHover] = useState(false);
    const [gridColumns,setGridColumns] = useState('repeat(2,auto)');
    const [exportValue,setExportValue] = useState(t('Export'))
    const [isShowSearch,setIsShowSearch] = useState(false);
    const [isShowDialogChooseImage,setIsShowDialogChooseImage] = useState(false);
    const [isEmptyData,setIsEmptyData] = useState(false);
    // const [pageNum,setPageNum] = useState(0);

    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_LIBRARY_TYPES);
    const [libraryMoreMenu,setLibraryMoreMenu] = useState(getLibraryMoreMenu());
    const [cardItemSize,setCardItemSize] = useState({width:0,height:0});
    const [isSearching,setIsSearching] = useState(false);
    const [searchWidth,setSearchWidth] = useState(SEARCH_WIDTH);
    const [libraryCount,setLibraryCount] = useState<any>(0)
    const [arrayCustomFilterMore,setArrayCustomFilterMore] = useState([]);
    const [isCustomItemMoreOpened,setIsCustomItemMoreOpened] = useState(false);
    const [arrayTypeSwitcher,setArrayTypeSwitcher] = useState<any>([]);
    const [isShowHiddenCard,setIsShowHiddenCard] = useState(localStorage.getItem(KEY_SHOW_HIDIN_CARDS) == 'true');
    const [activeTabItem,setActiveTabItem] = useState(null);


    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);
    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    const dialogTagManagerRef = useRef(null);
    const dialogMessageRef = useRef(null);
    const fileSelectRef = useRef(null);
    const dialogCommonInputRef = useRef(null);
    const dialogAllTagManagerRef = useRef(null);
    const dialogChooseProjectRef = useRef(null);
    const dialogChooseImageRef = useRef(null);
    const mIsQuerying = useRef(false);
    const [acceptExt,setAcceptExt] = useState<any>('*')
    const mLastSearchInputTime = useRef(0);
    const mLastSearchTimeoutId = useRef<any>(0);
    const mSelectCustomFilter = useRef(null);
    const mSliderRightWidth = useRef(0);
    const mLastSelectedIds = useRef<any>({});
    const mCurrentHoveredCustomFilter = useRef(null);
    const mIsCustomFilterChildrenClicked = useRef(false);
    const mArraySelectedTypes= useRef<any>([]);
    const mSearchKey = useRef<any>('');
    const mThisID = useRef<any>(crypto.randomUUID());
    const mSelectTag = useRef(t("Tags"));
    const [arrayAnnoSource,setArrayAnnoSource] = useState([]);
    const mArrayAnnoSource = useRef<any>(null);
    const [onlyAnno,setOnlyAnno] = useState(false);
    const mOnlyAnno = useRef(false);//因为这种让人很不爽的刷新机制问题，每一个state最好配一个引用!!!!
    const mSelectAnnoSource = useRef<any>('');

    const [visibleRange, setVisibleRange] = useState({ start: 0, end: 0 });
    const [arrayVisibleData,setArrayVisibleData] = useState([]);

    const divPageLibraryContainerRef = useRef(null);
    const gridRef = useRef(null);
    const mIsLoadingMore = useRef(false);
    const mColumnCount = useRef(4);
    const mPageNum = useRef(0);
    const divGridContainerRef = useRef(null);
    const mArrayDbTags = useRef(null);
    const mSearchCallback = useRef<any>(null);
    const mActiveTabItemRef = useRef<any>(null);
    const mLibraryTabRef = useRef(null);
    const mEnterTime = useRef(Date.now());//进入的时间。。。。

    const localParams = useLocation();

    /**
     * 大小更改
     * @param event
     */
    function resizeEvent(e){

    }

    /**
     * 窗口大小调整
     * @param event
     */
    function onWindowResize(event:any){
        if (props.from == FROM_HOME_LIBRARY || props.from == FROM_ADD || props.subFromPage == FROM_DIALOG || props.from == 'card'){
            const divContainer = document.getElementById(props.szContainerId || 'divPageLibaryContainer');
            if (divContainer){
                onSliderEvent(divContainer.clientWidth);//左右边距

                //这里自动调整search的宽度...
                // 1200:160
                if (mSliderRightWidth.current > 0){
                    const nNewWidth = divContainer.clientWidth*SEARCH_WIDTH/1600;
                    setSearchWidth(nNewWidth);
                }else{
                    setSearchWidth(SEARCH_WIDTH);
                }
            }
        }
    }

    /**
     * 计算要显示的可见部分的条目.
     */
    const calculateVisibleRange = () => {
        const columns = 3;
        // 计算行数
        const rows = Math.ceil(arrayCardList.length / columns);
        if (!divPageLibraryContainerRef.current) return;

        const rowHeight = props.from == FROM_LIBRARY?(cardItemSize.width*0.77):cardItemSize.width*0.77

        const { scrollTop, clientHeight } = divPageLibraryContainerRef.current;
        const startRow = Math.floor(scrollTop / rowHeight);
        const endRow = Math.min(
            rows - 1,
            startRow + Math.ceil(clientHeight / rowHeight) + 1
        );

        let newVisibleRange = {
            start: Math.max(0, startRow - 6), // 预加载2行
            end: Math.min(rows - 1, endRow + 6) // 预加载2行
        }

        setVisibleRange(newVisibleRange);

        const visibleData:any = [];
        for (let i = newVisibleRange.start * columns;
             i < Math.min(arrayCardList.length, (newVisibleRange.end + 1) * columns);
             i++) {
            visibleData.push(arrayCardList[i]);
        }
        setArrayVisibleData(visibleData);
    };


    /**
     * 粘贴
     * @param event
     */
    function onPaste(event:any){
        // event.preventDefault();
        // if (global.g_dialogName == 'card'){
        //     //当前是笔记的编辑，不处理
        //     return;
        // }

        //这里很多地方的判断。。。有些能粘贴有些不能。
        if (global.g_isDialogLink && props.source != 'dialogLink') {
            return;
        };


        if (document.activeElement?.className?.includes('tiptap') || document.activeElement?.className?.includes('excalidraw')){
            return;
        }

        if (isInDraw() && !global.g_isDialogLink){
            return;
        }

        if (global.g_showDialogs['chooseImage']){
            //在库里面添加图片又点击了添加图片---
            return;
        }

        if (window.getDialogCardsCount() > 0 && props.source != 'dialogLink'){
            return;
        }


        if ((Date.now() - mHandleTime) < 200)return;
        // if (props.from == FROM_LIBRARY)return;
        mHandleTime = Date.now();
        onHandleLastPaste(event);
    }

    const onHandleLastPaste = async (event)=>{
        let szType;
        let szTipInfo = '';
        if (event.clipboardData.files && event.clipboardData.files.length > 0){
            const files = event.clipboardData.files;
            for (let i=0;i<files.length;i++){
                const file = files[i];
                //保存到库..
                if (file.path){
                    //实际路径的图片
                    const szFileName = await ipcInvoke('copy-file', {filePath: file.path});
                    szType = 'file';
                    szTipInfo = t("FileHasAddLibrary")
                    if (isImage(file.path)){
                        szType = 'image';
                        szTipInfo = t("ImageImportToLibrary")
                    }else if (isAudio(file.path)){
                        szType = 'audio'
                        szTipInfo = t("AudioHasAddLibrary")
                    }else if (isVideo(file.path)){
                        szType = 'video';
                        szTipInfo = t("VideoHasAddLibrary");
                        const nVideoCount = await beyondFreeVideoLimit();
                        if (!hasLicense() && !hasDesktopBaseLicense() &&  nVideoCount){
                            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), ()=>{
                                window.closeProgress();
                            }, () => {
                                window.closeProgress();
                                if (isZh()) {
                                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                }else {
                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                }
                            })
                            return;
                        }
                    }else if (isPdf(file.path)){
                        szType = 'pdf';
                        szTipInfo = t("PdfHasAddLibrary");
                        let nPdfCount = await beyondFreePdfLimit();
                        if (!hasLicense() && !hasDesktopBaseLicense() && nPdfCount){
                            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                                if (isZh()) {
                                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                }else {
                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                }
                            })
                            return;
                        }
                    }

                    let libraryItem = await addImageToLibaray(szType,szFileName);
                    if (props.source == 'dialogLink'){
                        //来自link-要显示一个对话框
                        if (szType == 'image' || szType == 'video'){
                            window.showDialogAddToLibrary(libraryItem,(libraryData:any)=>{
                                //回调...
                                if (props.onItemSelectedCallback){
                                    props.onItemSelectedCallback(libraryData);
                                }
                            },szTipInfo);
                        }
                    }else{
                        if (isInPageLibrary() && (szType == 'image' || szType == 'video')){
                            window.showDialogPasteMediaAddTo(libraryItem,(libraryData:any)=>{
                                //回调...

                            },szTipInfo);
                        }
                    }
                    window.globalRefreshList('refresh_single_library_item_',libraryItem.id);
                }else{
                    document.body.focus();
                    setTimeout(()=>{
                        navigator.clipboard.read().then(async (clipboardItems) => {
                            for (const clipboardItem of clipboardItems) {
                                for (const type of clipboardItem.types) {
                                    if (type.startsWith('image/')) {
                                        const blob = await clipboardItem.getType(type);
                                        const reader = new FileReader();

                                        reader.onload = async function(event) {
                                            const szBase64 = event.target.result;
                                            if (szBase64){
                                                const szFileName = 'screenshot_'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.png';
                                                // 处理图片
                                                var item = {
                                                    fileName:szFileName,
                                                    data:szBase64.split(',')[1]
                                                }
                                                await ipcInvoke('write-base64-files',JSON.stringify([item]));
                                                let libraryItem = await addImageToLibaray('image',szFileName);
                                                postMessage(EVENT_REFRESH_LIBRARY_LIST);

                                                szType = 'image';
                                                szTipInfo = t("ImageImportToLibrary")
                                                if (props.source == 'dialogLink'){
                                                    //来自link-要显示一个对话框
                                                    if (szType == 'image' || szType == 'video'){
                                                        window.showDialogAddToLibrary(libraryItem,(libraryData:any)=>{
                                                            //回调...
                                                            if (props.onItemSelectedCallback){
                                                                props.onItemSelectedCallback(libraryData);
                                                            }
                                                        },szTipInfo);
                                                    }
                                                }else{
                                                    if (isInPageLibrary()){
                                                        window.showDialogPasteMediaAddTo(libraryItem,(libraryData:any)=>{
                                                            //回调...

                                                        },szTipInfo);
                                                    }
                                                }
                                                window.globalRefreshList('refresh_single_library_item_',libraryItem.id);
                                            }
                                        };

                                        reader.readAsDataURL(blob); // 转换图片为DataURL格式
                                    }
                                }
                            }
                        });
                    },100)

                }
            }
            //刷新库....
            if (szTipInfo){
                message.info(szTipInfo)
            }

            setTimeout(()=>{
                mPageNum.current = 0;
                updateList();
            },100);
        }
    }

    useEffect(()=>{
        //保存笔记............
        recvMessage(EVENT_UPDATE_NOTE,async (msg:any,data:any)=>{
            // const card = data.data.data;
            // const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
            // const nExist = await isCardExistInDb(data.data.data.id);
            // if (isCardEmpty(card.doc) && isEmptyTitle && !nExist){
            //     return;
            // }
            //
            // card.type = card.type || global.g_currentNoteType;
            // const item = await updateCard(card,true,true,'fromPageLibrary-EVENT_UPDATE_NOTE');
            // if (item){
            //     mPageNum.current = 0;
            // }
            updateList(false);
        });

        recvMessage(EVENT_REFRESH_LIBRARY_LIST,(msg,data)=>{
            //这里汇总，做一次刷新？
            mPageNum.current = 0;
            updateList();
        })

        recvMessage(EVENT_BOARD_CHANGED,(msg,data)=>{
            if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                mPageNum.current = 0;
                updateList();
            }
        })

        recvMessage(EVENT_REFRESH_LIBRARY_TAG_LIST,(msg,data)=>{
            updateTagList();
        })

        if (props.from != FROM_LIBRARY){
            window.refreshList['refreshCustomFilter'] = refreshCustomFilter;
        }
        window.refreshList['refreshLibraryList_'+mThisID.current] = outRefreshUpdateList;



        document.body.addEventListener('keydown',onKeyDown);
        document.body.addEventListener('mouseup',onDocumentMouseUp);
        window.addEventListener('resize',onWindowResize);

        return ()=>{
            document.body.removeEventListener('keydown',onKeyDown);
            document.body.removeEventListener('mouseup',onDocumentMouseUp);
            window.removeEventListener('resize',onWindowResize);

            unSubscribe(EVENT_UPDATE_NOTE);
            unSubscribe(EVENT_REFRESH_LIBRARY_LIST);
            unSubscribe(EVENT_REFRESH_LIBRARY_TAG_LIST);
            unSubscribe(EVENT_BOARD_CHANGED);
            if (props.from != FROM_LIBRARY){
                delete window.refreshList['refreshCustomFilter'];
            }
            delete window.refreshList['refreshLibraryList_'+mThisID.current];


        }
    })

    //只进来一次的...
    useEffect(()=>{
        mMapIdCheck = {};
        mPageNum.current = 0;
        mSearchKey.current = '';

        rect = null;
        setCardItemPointerEvent('all');//以防一直不可用....

        mSelectProjectId = localStorage.getItem(KEY_FILTER_SELECT_PROJECT) || FILTER_PROJECT_ID_ALL;

        if (props.from == FROM_LIBRARY){
            // mSelectProjectId = localStorage.getItem()
            if (props.subFromPage == FROM_DIALOG) {
                mSearchKey.current = props.searchKey || '';
            }
        }else{
            //非右侧栏，
            if (mSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                mSelectProjectId = FILTER_PROJECT_ID_ALL;
            }
            mSearchKey.current = '';
        }

        setSelectProjectValue(mSelectProjectId);

        const selectTag = localStorage.getItem(KEY_FILTER_SELECT_TAG) || t('Tags');
        setSelectTagValue(selectTag);
        refreshSelectTags(selectTag);
        mSelectTag.current = selectTag;
        // setIsClearFilterVisible(selectTag != t('Tags') || !isAllProject());

        //type switcher
        const szTypeSwitcher = localStorage.getItem(KEY_TYPE_SWITCHER);
        if (szTypeSwitcher){
            const jsonTypeSwitcher = JSON.parse(szTypeSwitcher);
            //语言问题...
            for (let i=0;i<jsonTypeSwitcher.length;i++){
                const item = jsonTypeSwitcher[i];
                const df = GET_ARRAY_LIBRARY_TYPES().find(p=>p.value == item.value);
                if (df){
                    item.label = df.label;
                }else if (item.value == 'all'){
                    item.label = t("All");
                }
            }
            setArrayTypeSwitcher(jsonTypeSwitcher);
        }else{
            setArrayTypeSwitcher(ARRAY_DEFAULT_TYPE_SWITCHER());
        }

        //保存的类型项目
        const szSelectTypes = localStorage.getItem(KEY_LIBRARY_SELECTED_TYPES);
        if (szSelectTypes){
            const arraySavedSelectTypes = JSON.parse(szSelectTypes);
            mArraySelectedTypes.current.length = 0;

            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                const array = arraySavedSelectTypes.filter(p=>p.value == ARRAY_LIBRARY_TYPES[i].value);
                if (array && array.length > 0){
                    mArraySelectedTypes.current.push({
                        ...ARRAY_LIBRARY_TYPES[i],
                        isChecked:array[0].isChecked
                    })
                }else{
                    //没有的默认添加进来.
                    mArraySelectedTypes.current.push(ARRAY_LIBRARY_TYPES[i]);
                }
            }
            setArrayLibraryTypes(mArraySelectedTypes.current);
        }else{
            var arrays = [...ARRAY_LIBRARY_TYPES];
            arrays[0].isChecked = true;
            arrays[1].isChecked = true;
            setArrayLibraryTypes(arrays);
            mArraySelectedTypes.current = arrays;

            //typeswitch取消选中.
            const arrayNewTypeSwitch = [...ARRAY_DEFAULT_TYPE_SWITCHER()];
            arrayNewTypeSwitch[0].isSelected = false;
            setArrayTypeSwitcher(arrayNewTypeSwitch);
        }

        //从这里进来的，默认只显示card
        if (props.extra?.from == "linkExistCard"){
            var arrays = [...ARRAY_LIBRARY_TYPES];
            arrays.forEach(p=>{
                if (p.value == 'card'){
                    p.isChecked = true;
                }
            })
            setArrayLibraryTypes(arrays);
            mArraySelectedTypes.current = arrays;
        }

        //只要当前过滤的不是全部项目，就不分页
        if (!isAllProject()){
            mPageNum.current = -1;
        }

        if (props.from == FROM_LIBRARY){
            mColumnCount.current = 2;
        }else if (props.from == FROM_ADD){
            mColumnCount.current = 3;
            setGridColumns('repeat(3,auto)')
        }
        else{
            mColumnCount.current = 5;
        }

        //调整大小
        onWindowResize(null);

        const arraySelectedTypes = getSelectedTypes();
        if (arraySelectedTypes.length == 1){
            // const szType = localStorage.getItem(KEY_LIBRARY_TYPE)??'card';
            const szType = arraySelectedTypes[0].value;
            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                if (ARRAY_LIBRARY_TYPES[i].value == szType){
                    mSelectType = ARRAY_LIBRARY_TYPES[i];
                    setSelectType(mSelectType);
                    setNewButtonText(mSelectType.buttonLabel)
                    break;
                }
            }
        }

        // mSelectType = ARRAY_LIBRARY_TYPES[0];

        if (props.type){
            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                const item = ARRAY_LIBRARY_TYPES[i];
                if (item.value == props.type){
                    mSelectType = item;
                    setSelectType(item);
                    if (mArraySelectedTypes.current){
                        for (let ssss =0;ssss<mArraySelectedTypes.current.length;ssss++){
                            mArraySelectedTypes.current[ssss].isChecked = (item.value == mArraySelectedTypes.current[ssss].value);
                        }
                    }
                    break;
                }
            }
            if (props.type == 'highlight'){
                mArraySelectedTypes.current = [
                    {
                        value:'cardAnno',
                        label:t("Card highlight"),
                        buttonLabel:t("Card highlight"),
                        isChecked:true,
                        icon:'library_type_anno'
                    },
                    {
                        value:'pdfAnno',
                        label:t("PDF Highlight"),
                        buttonLabel:t("PDF"),
                        ext:'.pdf',
                        isChecked:true,
                        icon:'library_type_anno'
                    },
                    {
                        value:'videoAnno',
                        label:t("Video notes"),
                        buttonLabel:t("Video"),
                        ext:'.mp4',
                        isChecked:true,
                        icon:'library_type_anno'
                    },
                    {
                        value:'audioAnno',
                        label:t("Audio notes"),
                        buttonLabel:t("Audio"),
                        ext:'.mp3',
                        isChecked:true,
                        icon:'library_type_anno'
                    }
                ]
                const szAnnoTypes = localStorage.getItem(KEY_ANNO_TYPES);
                if (szAnnoTypes){
                    mArraySelectedTypes.current = JSON.parse(szAnnoTypes);
                    mArraySelectedTypes.current.forEach(p=>{
                        p.icon = 'library_type_anno'
                    })
                }
                //只有4种注记类型可以选择.
                setArrayLibraryTypes(mArraySelectedTypes.current);
            }
        }

        //查询所有project
        getNoteList().then(res=>{
            mArrayProjects.length = 0;

            mArrayProjects.push({
                value:'all',
                label:t("Projects")
            });
            // mArrayProjects.push({
            //     value:'all-0',//allInProject
            //     label:t("All projects")
            // });
            mArrayProjects.push({
                value:FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL,
                label:t("Not in any project")
            })
            if (window.location.href.includes('/draw') || window.location.href.includes('/defaultProject')){
                //库里面，增加2个
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_PROJECT,
                    label:t("Current project")
                })
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_BOARD,
                    label:t("Current board")
                })
            }
            if (props.from == FROM_ADD){
                if (!mArrayProjects.some(p=>p.value == FILTER_PROJECT_CURRENT_PROJECT)){
                    mArrayProjects.push({
                        value:PROJECT_ID,
                        label:t("Current project")
                    })
                }
            }
            if (mArrayProjects.length > 1){
                mArrayProjects.push({
                    id:MENU_SEPARATOR,
                    label:'',
                    value:'spe0'
                })
            }

            res.forEach(p=>{
                mArrayProjects.push({
                    value:p.id,
                    label:p.name || t('Untitled')
                })
            })
            setArrayProjects(mArrayProjects);
        })

        Global.g_isCardUpdate = true;
        //查询所有tag..
        updateTagList();

        updateSortStates();

        const selCustomFilter = localStorage.getItem(KEY_FILTER_CUSTOM_FILTER);
        let jsonCustomFilter = null;
        if (selCustomFilter){
            jsonCustomFilter = JSON.parse(selCustomFilter);
            setSelectCustomFilter(jsonCustomFilter);
        }

        if (!localParams.state?.usr?.customFilter && !selCustomFilter){
            mPageNum.current = 0;
            updateList();
        }
        refreshCustomFilter(false,jsonCustomFilter);

        const resizeObserver = new ResizeObserver(entries => {
            onWindowResize();
        })
        const divContainer = document.getElementById(props.szContainerId || 'divPageLibaryContainer');
        if (divContainer){
            resizeObserver.observe(divContainer);
        }

        //刷新clear是否可见
        refreshClearFilterVisible();

        document.body.addEventListener('paste',onPaste);

        window.refreshList['updateTheme_pageLibrary'] = forceUpdate;

        return()=>{
            document.body.removeEventListener('paste',onPaste);
            mArrayProjects = [];
            mMapIdCheck = {};
            delete window.refreshList['updateTheme_pageLibrary'];
            if (props.from != FROM_LIBRARY){
                // console.log('reset---global.g_mArrayOriginSort');
                global.g_mArrayOriginSort = {};
            }
        }
    },[])

    useEffect(()=>{
        if (props.type){
            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                const item = ARRAY_LIBRARY_TYPES[i];
                if (item.value == props.type){
                    mSelectType = item;
                    setSelectType(item);
                    break;
                }
            }
            Global.g_isCardUpdate = true;
            mPageNum.current = 0;
            updateList();
        }
    },[props.type])

    useEffect(() => {
        mSliderRightWidth.current = rightSliderWidth;
    }, [rightSliderWidth]);

    useEffect(() => {
        window.refreshList['refresh_language_pageLibrary'] = ()=>{
            //刷新switcher 的语言.
            const arrayNew = [...arrayTypeSwitcher];
            for (let i=0;i<arrayNew.length;i++){
                if (arrayNew[i].value == 'all'){
                    arrayNew[i].label = t("All");
                }else{
                    const pp = GET_ARRAY_LIBRARY_TYPES().find(p=>p.value == arrayNew[i].value);
                    if (pp){
                        arrayNew[i].label = pp.label;
                    }
                }
            }
            setArrayTypeSwitcher(arrayNew);

            const arrayNewProjects = [...arrayProjects];
            for (let i=0;i<arrayNewProjects.length;i++){
                if (arrayNewProjects[i].value == 'all'){
                    arrayNewProjects[i].label = t("Projects");
                }
            }
            setArrayProjects(arrayNewProjects);

            const arrayNewTags = [...arrayTags];
            for (let i=0;i<arrayNewTags.length;i++){
                if (arrayNewTags[i].value == FILTER_TAG_NO_TAGS){
                    arrayNewTags[i].label = t("No tags")
                }
            }
            setArrayTags(arrayNewTags);

            // refreshSelectTags(null);

            let selectTag = localStorage.getItem(KEY_FILTER_SELECT_TAG) || t('Tags');
            if (isAllTag(selectTag)){
                selectTag = t("Tags");
            }
            setSelectTagValue(selectTag);
            refreshSelectTags(selectTag);
        }

        /**
         * 取这里的所有library
         */
        window.getLibraryTagsOptions = ()=>{
            const arrayOptions:any = [];
            if (mArrayDbTags.current){
                for (let i=0;i<mArrayDbTags.current.length;i++){
                    arrayOptions.push({
                        label:mArrayDbTags.current[i].name,
                        value:mArrayDbTags.current[i].name,
                    })
                }
            }
            return arrayOptions;
        }
        return ()=>{
            delete window.refreshList['refresh_language_pageLibrary'];
            delete window.getLibraryTags;
        }
    }, [arrayTypeSwitcher,arrayProjects,arrayTags,selectTagValue]);

    useEffect(() => {
        mSelectCustomFilter.current = selectCustomFilter;
    }, [selectCustomFilter]);

    useEffect(() => {
        // calculateVisibleRange();
        window.refreshList['refresh_single_library_item_'+mThisID.current] = async (id,extra)=>{
            if (!id)return;
            if ((Date.now() - mEnterTime.current) < 1000)return;
            if (extra?.onlyHomeLibrary && props.from !== FROM_HOME_LIBRARY)return;
            const newCard:any = await getCardById(id);
            //当前类型如果没选中的话就忽略..
            if(!arrayLibraryTypes.some(p=>p.isChecked && p.value == newCard?.type))return;
            const arrayNew:any = [...arrayCardList];
            const nIndex = arrayNew.findIndex(p=>p.id == id);
            if (nIndex != -1){
                if (mActiveTabItemRef.current?.id == 'published'){
                    const cardPublish = await getPublishNoteById(newCard.id);
                    if (cardPublish){
                        if (newCard.isDeleted != 0 || extra?.isDeleted == 1){
                            arrayNew.splice(nIndex,1);
                        }else{
                            arrayNew.splice(nIndex,1,newCard);
                        }
                    }else{
                        arrayNew.splice(nIndex,1);
                    }
                }else if (mActiveTabItemRef.current?.id == 'favorites'){

                }else{
                    if (newCard.isDeleted != 0 || extra?.isDeleted == 1){
                        arrayNew.splice(nIndex,1);
                    }else{
                        arrayNew.splice(nIndex,1,newCard);
                    }
                }
            }else{
                if (newCard.isDeleted == 0 && extra?.isDeleted != 1){
                    //插入到第一个...
                    if (arrayNew.length > 0 && arrayNew[0].id == -1){
                        arrayNew.splice(1,0,newCard);
                    }else{
                        arrayNew.splice(0,0,newCard);
                    }

                    global.g_mArrayOriginSort[newCard.id] = -1;
                }
            }
            setArrayCardList(arrayNew);
            setLibraryCount(arrayNew.length);
        }
        window.refreshList['removeLibraryItems_'+mThisID.current] = (szLibraryId:any)=>{
            const arrayNewCardList = [...arrayCardList];
            const nIndex = arrayNewCardList.findIndex(p=>p.id == szLibraryId);
            if (nIndex != -1){
                arrayNewCardList.splice(nIndex,1);
                setArrayCardList(arrayNewCardList);
            }
        }
        window.refreshList['refreshLibrarySingleItem_'+mThisID.current] = onRefreshSingleItem;
        window.refreshList['refreshLibraryCardAnnoList_'+mThisID.current] = onRefreshLibraryCardAnnoList;
        window.refreshList['onRemoveItemOnPublishTab_'+mThisID.current] = onRemoveItemInPublishTab;
        window.refreshList['onRemoveItemOnFavorTab_'+mThisID.current] = onRemoveItemInFavorTab;

        setTimeout(()=>{
            gridRef.current?.recomputeGridSize();
        },10)

        return ()=>{
            delete window.refreshList['refresh_single_library_item_'+mThisID.current];
            delete window.refreshList['refreshLibrarySingleItem_'+mThisID.current];
            delete window.refreshList['refreshLibraryCardAnnoList_'+mThisID.current];
            delete window.refreshList['onRemoveItemOnPublishTab_'+mThisID.current];
            delete window.refreshList['onRemoveItemOnFavorTab_'+mThisID.current];
            delete window.refreshList['removeLibraryItems_'+mThisID.current];
        }
    }, [arrayCardList]);

    useEffect(() => {
        if (localParams.state?.usr?.customFilter) {
            setSelectCustomFilter(localParams.state?.usr?.customFilter);
            //重置别的选项...
            mSelectTag.current = t('Tags');
            mSelectProjectId = 'all';
            setSelectProjectValue('all')
            setSelectTagValue(t('Tags'));

            localStorage.setItem(KEY_FILTER_SELECT_PROJECT, 'all');
            localStorage.setItem(KEY_FILTER_SELECT_TAG, t('Tags'))

            customFilterEvent(localParams.state?.usr?.customFilter);
            setIsClearFilterVisible(true);
        }
    }, [localParams]);

    function onKeyDown(e:any){
        // debugLog('keydown',e);

        // console.log(e.metaKey + '   ' + e.key);
        // if (event.key == KEYS.C){
        //     Global.g_currentNoteData = {id: generateRandomPageKey()}
        //     openEditor(Global.g_currentNoteData.id, false, false, FROM_HOME_LIBRARY);
        // }
        if (window.location.href.includes('home/library')){
            if (!e.target?.editor &&
                e.target?.type != 'text' &&
                e.target?.type != 'textarea' &&
                e.target?.className.indexOf('ql-editor') != 0 &&
                e.target.dataset?.isedit != 'true' &&
                e.target?.className.indexOf('tiptap') != 0 &&
                e.target?.tagName !== 'INPUT') {
                if (e.key == KEYS.ESCAPE){
                    onCancelCheck();
                }else if (isShortcuts(e,'newCard')){
                    Global.g_currentNoteData = {id: generateRandomPageKey()}
                    openEditor(Global.g_currentNoteData.id, false, false);
                }
            }
        }
    }


    /**
     * 语言切换时刷新标签
     */
    const refreshSelectTags = (selectTag:any)=>{
        let szTagValue = selectTag || selectTagValue;
        if (szTagValue == 'Tags' || szTagValue == '标签' || szTagValue == '標籤' || szTagValue == t('Tags')){
            setSelectTagValue(t("Tags"));
            mSelectTag.current = t("Tags");
        }
    }

    const isAllTag = (selectTag:any)=>{
        let szTagValue = selectTag || selectTagValue;
        return (szTagValue == 'Tags' || szTagValue == '标签' || szTagValue == '標籤' || szTagValue == t('Tags'));
    }

    function onDocumentMouseUp(e:any){
        onMouseUp(e);
    }

    /**
     * 是否是全部项目
     */
    const isAllProject = ()=>{
        return mSelectProjectId == FILTER_PROJECT_ID_ALL /*|| mSelectProjectId == 'all-0'*/ //all-0是所有项目，准确的描述应该叫所有项目里面包含库的
    }

    const isCheckedAllType = ()=>{
        const nCount = mArraySelectedTypes.current.filter(p=>p.isChecked).length;
        return nCount == mArraySelectedTypes.current.length;
    }

    /**
     * 选中的类型数量
     */
    const getSelectedTypes = ()=>{
        return mArraySelectedTypes.current.filter(p=>p.isChecked);
    }

    const onSearchEvent = (szSearchKey:string,hasSearch=true,searchCallback:any = null)=>{
        mSearchKey.current = szSearchKey;
        setSearchKey(szSearchKey);
        mSearchCallback.current = searchCallback;

        if (hasSearch){
            // if (szSearchKey){
            //     mPageNum = -1;
            // }else{
            //     mPageNum = 0;
            // }
            // updateList();
            //清除上一次的计时
            clearTimeout(mLastSearchTimeoutId.current);

            mLastSearchTimeoutId.current = setTimeout(()=>{
                doSearch();
                clearTimeout(mLastSearchTimeoutId.current);
            },1500);
        }
    }

    /**
     * 拖动大小
     * @param nWidth
     */
    const onSliderEvent = (nWidth:number)=>{
        if (nWidth > WIDTH_5){
            mColumnCount.current = 5;
            setGridColumns('repeat(5,auto)');
        }else if (nWidth > WIDTH_4){
            mColumnCount.current = 4;
            setGridColumns('repeat(4,auto)');
        }else if (nWidth > WIDTH_3){
            mColumnCount.current = 3;
            setGridColumns('repeat(3,auto)');
        }
        else{
            mColumnCount.current = 2;
            setGridColumns('repeat(2,auto)');
        }

        if (props.subFromPage == 'DialogLink' || props.subFromPage == FROM_DIALOG || props.from == 'card'){
            mColumnCount.current = 3;
            setGridColumns('repeat(3,auto)');
        }

        let fItemWidth = 200;
        const nMargin = (mColumnCount.current - 1)*12;
        fItemWidth = (nWidth - 12*2 - mColumnCount.current*16)/mColumnCount.current;//32为左右2边的边距
        setCardItemSize({
            width:fItemWidth,
            height:fItemWidth*0.67
        })

        resizeEvent(null);

        setTimeout(()=>{
            gridRef.current?.recomputeGridSize();
        },10)
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            localStorage.setItem(KEY_CARD_SORT_TYPE,e.key);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            localStorage.setItem(KEY_CARD_ORDER_BY,e.key);
            //更新列表
            mPageNum.current = 0;
            //删除原始排序
            global.g_mArrayOriginSort = null;
            updateList();
        }
        updateSortStates();
    }
    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (isShowChecked){
            setSortMenuOpen(false);
            return;
        }
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /**
     * 显示或隐藏卡片
     */
    const showOrHiddenCards = ()=>{
        let isShow = localStorage.getItem(KEY_SHOW_HIDIN_CARDS);
        if (isShow == 'true'){
            isShow = 'false';
        }else{
            isShow = 'true';
        }
        //显示卡片隐藏卡片 所有卡片 显示隐藏
        setIsShowHiddenCard(isShow == 'true');
        localStorage.setItem(KEY_SHOW_HIDIN_CARDS,isShow);
        setLibraryMoreMenu(getLibraryMoreMenu());

        if (isShow == 'true'){
            //只选中卡片？
            const pp = arrayLibraryTypes.find(ppp=>ppp.value == 'card');
            onCheckOneItem(pp);
        }
        //刷新列表
        mPageNum.current = 0;
        updateList();
    }

    const btnViewStyleClicked = (viewType) => {
        setViewStyle(viewType);
        localStorage.setItem(KEY_CARD_VIEW_STYLE, viewType);
    }

    //搜索更改--1s内有输入不搜索。。超过才搜索...
    const onSearchChange = (event:any)=>{
        setSearchKey(event.currentTarget.value);
        mSearchKey.current = event.currentTarget.value;
        setIsSearching(true);

        // if (mLastSearchInputTime.current == 0){
        //     mLastSearchInputTime.current = Date.now();
        // }
        //
        // if ((Date.now() - mLastSearchInputTime.current) < 1600){
        //     mLastSearchInputTime.current = Date.now();
        //     //设置一个延迟，防止后面不输入.
        //     return;
        // }

        //清除上一次的计时
        clearTimeout(mLastSearchTimeoutId.current);

        mLastSearchTimeoutId.current = setTimeout(()=>{
            doSearch();
            clearTimeout(mLastSearchTimeoutId.current);
        },1500);
    }

    /**
     * 执行搜索
     */
    const doSearch = ()=>{
        console.log('这里有个延迟用户停止输入1.5s后才开始搜索')
        if (mSearchKey.current){
            mPageNum.current = -1;
            //继续下一次的搜索，不需要等返回....
            mIsQuerying.current = false;
        }else{
            mPageNum.current = 0;//不分页
        }
        mLastSearchInputTime.current = 0;//如果执行了搜索，重置0

        updateList();
    }

    /*排序状态选中*/
    const updateSortStates = async ()=>{
        let szSortType = localStorage.getItem(KEY_CARD_SORT_TYPE);
        let szOrderBy = localStorage.getItem(KEY_CARD_ORDER_BY);

        if(!szSortType){
            szSortType = "sort by updateDate";
        }
        if(!szOrderBy){
            szOrderBy = "date desc"
        }

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /**
     * 添加图片到库....
     * @param szType
     * @param szFileName
     */
    const addImageToLibaray = async (szType:string,szFileName:string)=>{
        const item:any = {
            id:generateUUID2(),
            name:getFileNameWithoutExt(szFileName),
            fileName:szFileName,
            type:szType,
            createTime:Date.now()
        }
        let szThumbImage:any = '';
        if (szType == 'video'){
            szThumbImage = await getVideoImageThumb(getLocalFilePath(szFileName,false));
        }else if (szType == 'pdf'){
            szThumbImage = await getPdfImageThumb(getLocalFilePath(szFileName,false));
        }
        if (szThumbImage){
            //保存到本地
            const szLocalFileName = item.id + '.png';
            await ipcInvoke('write-base64-image',{fileName:szLocalFileName,imgBase64:szThumbImage});

            item.thumbImage = getScheme()+szLocalFileName;
        }

        await updateCard(item);
        return item;
    }

    /**
     * 更新排序的描述
     * @param szSortType
     */
    const updateSortTypeDesc = (szSortType)=>{
        for(var i=0;i<sortMenu[0].children.length;i++){
            var item = sortMenu[0].children[i];
            if (item.key == szSortType){
                setSortTypeDesc(item.label);
                mSortTypeDesc = item.label;
            }
        }
    }

    /**
     * 更新标签列表
     */
    const updateTagList = ()=>{
        getTagList().then(res=>{
            mArrayTags.length = 0;
            mArrayDbTags.current = res;

            if (res.length > 0){
                mArrayTags.push({
                    value:FILTER_TAG_NO_TAGS,
                    label:t("No tags")
                })

                mArrayTags.push({
                    id:MENU_SEPARATOR,
                    value:generateUUID2()
                })
            }

            res.forEach(p=>{
                mArrayTags.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayTags(mArrayTags);
        })
    }

    /**
     * 刷新custom filter....
     */
    const refreshCustomFilter = (isDelete:any,jsonCustomFilter:any = null)=>{
        const arrayItems = [...arrayCardList];
        arrayItems.forEach(p=>{
            p.isChecked = false;
            if (mMapIdCheck[p.id]){
                p.isChecked = true;
            }
        })
        setArrayCardList(arrayItems);

        getCustomFilterList().then(res=>{
            res.forEach(p=>{
                p.isHover = p.isCustomItemMoreOpened = false
            })
            setArrayFilters(res);
            let ssssscccccuuuuuufffff = selectCustomFilter || jsonCustomFilter
            if (ssssscccccuuuuuufffff){
                const newCustomFilter = res.find(p=>p.id == ssssscccccuuuuuufffff.id);
                if (newCustomFilter){
                    setSelectCustomFilter(newCustomFilter);
                    customFilterEvent(newCustomFilter);
                    setIsClearFilterVisible(true);
                }else{
                    if (isDelete){
                        setSelectCustomFilter(null);
                        //不存在了，清除..
                        mSelectTag.current = t('Tags');
                        mSelectProjectId = 'all';
                        setSelectProjectValue('all')
                        setSelectTagValue(t('Tags'));
                        setIsClearFilterVisible(false);
                        setSelectCustomFilter(null);
                        mSelectCustomFilter.current = null;

                        const arrayNewTypes = [...arrayLibraryTypes];
                        arrayNewTypes.forEach(p=>{
                            p.isChecked = true;
                        })
                        setArrayLibraryTypes(arrayNewTypes);

                        localStorage.setItem(KEY_FILTER_SELECT_PROJECT, 'all');
                        localStorage.setItem(KEY_FILTER_SELECT_TAG, t('Tags'))
                        localStorage.setItem(KEY_LIBRARY_SELECTED_TYPES,JSON.stringify(arrayNewTypes));
                        localStorage.setItem(KEY_FILTER_CUSTOM_FILTER,'');//清空保存的....

                        mPageNum.current = 0;
                        updateList(true)
                    }
                }
            }
        })
    }

    const filterByProjectNewNew = async (szSelectProjectId:any,isFavor = false,isPublished = false)=>{
        let arrayNewCards:any = [];
        const arraySelectTypes = getSelectedTypes();

        const isVideoChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'video')
        const isAudioChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'audio')
        const isPdfChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'pdf')
        const isCardChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'card')
        const isJournalChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'journal')
        const isFileChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'file')
        const isWebLinkChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'webLink')
        const isImageChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'image')

        const isVideoAnnoChecked = arraySelectTypes.some(p=>p.value == 'videoAnno');
        const isAudioAnnoChecked = arraySelectTypes.some(p=>p.value == 'audioAnno');
        const isPdfAnnoChecked = arraySelectTypes.some(p=>p.value == 'pdfAnno');
        const isCardAnnoChecked = arraySelectTypes.some(p=>p.value == 'cardAnno');
        const isLiveVideoChecked = arraySelectTypes.some(p=>p.value == 'liveVideo');

        if (szSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || szSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
            szSelectProjectId = PROJECT_ID;
        }

        const jsonObj = await getNoteDoc(szSelectProjectId);
        if (jsonObj){
            const jsonDoc = JSON.parse(jsonObj?.doc);
            //仅note...
            for (let i=0;i<jsonDoc.notes.length;i++){
                if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                    if (jsonDoc.notes[i].key != global.g_currentBoardId)continue;
                }
                const cardNote:any = await getCardById(jsonDoc.notes[i].key);
                if (isCardChecked && cardNote?.isDeleted != 1){
                    arrayNewCards.push(cardNote);
                }
                //添加下面的所有标注--如果选择了标注
                if (isCardAnnoChecked && cardNote?.isDeleted != 1){
                    //实体在，所有的标注都要在.
                    const arrayAnnos = await getCardListByLibraryId(cardNote?.id);
                    //没添加过的添加进来...
                    for (let k=0;k<arrayAnnos.length;k++){
                        const subItem = arrayAnnos[k]
                        if (!arrayNewCards.some(p=>p.id == subItem.id)){
                            arrayNewCards.push(subItem);
                        }
                    }
                }
            }

            let mapAddLibraryId:any = {};

            await loopAllNodeAsync(jsonDoc.canvas,async (canvas)=>{
                if (canvas.drawJson?.elements){
                    if (mSelectProjectId !== FILTER_PROJECT_CURRENT_BOARD || (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD && canvas.key == global.g_currentBoardId)){
                        for (let j=0;j<canvas.drawJson.elements.length;j++){
                            const element = canvas.drawJson.elements[j];
                            let szId = element?.customData?.generationData?.pdfData?.id;
                            if (!szId){
                                szId = element.customData?.generationData?.id || element.id;
                            }
                            const library:any = await getCardById(szId,false);
                            if (library && library?.isDeleted != 1){
                                if ((library.type == 'pdf' && isPdfChecked) ||
                                    (library.type == 'video' && isVideoChecked) ||
                                    ((library.type == 'youtube' || library.type == 'bilibili' || library.type == 'baidu') && isLiveVideoChecked) ||
                                    (library.type == 'audio' && isAudioChecked) ||
                                    (library.type == 'card' && isCardChecked) ||
                                    (library.type == 'journal' && isJournalChecked) ||
                                    (library.type == 'file' && isFileChecked) ||
                                    (library.type == 'webLink' && isWebLinkChecked) ||
                                    (library.type == 'image' && isImageChecked)
                                ) {
                                    if (!arrayNewCards.some(p=>p.id == library.id)){
                                        arrayNewCards.push(library);
                                    }
                                }
                                if ((library.type == 'pdfAnno' && isPdfAnnoChecked) ||
                                    (library.type == 'audioAnno' && isAudioAnnoChecked) ||
                                    (library.type == 'videoAnno' && isVideoAnnoChecked) ||
                                    (library.type == 'cardAnno' && isCardAnnoChecked)){
                                    if (!mapAddLibraryId[library.libraryId]){
                                        mapAddLibraryId[library.libraryId] = true;

                                        const arrayAnnos = await getCardListByLibraryId(library.libraryId);
                                        for (let kk=0;kk<arrayAnnos.length;kk++){
                                            let subItem = arrayAnnos[kk];
                                            if (!arrayNewCards.some(p=>p.id == subItem.id)){
                                                arrayNewCards.push(subItem);
                                            }
                                        }
                                    }
                                }

                                //如果选择了相应的标注，当前类型为pdf,video,audio,card时，把相应的标注也全部加进来
                                if ((library.type == 'pdf' && isPdfAnnoChecked) ||
                                    ((library.type == 'video' || library.type == 'youtube' || library.type == 'bilibili' || library.type == 'baidu') && isVideoAnnoChecked) ||
                                    (library.type == 'audio' && isAudioAnnoChecked) ||
                                    (library.type == 'card' && isCardAnnoChecked)){
                                    if (!mapAddLibraryId[library.id]) {
                                        mapAddLibraryId[library.id] = true;
                                        const arrayAnnos = await getCardListByLibraryId(library.id);
                                        for (let kk = 0; kk < arrayAnnos.length; kk++) {
                                            let subItem = arrayAnnos[kk];
                                            if (!arrayNewCards.some(p => p.id == subItem.id)) {
                                                arrayNewCards.push(subItem);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            })
        }

        if (mSelectTag.current && mSelectTag.current != t("Tags")){
            if (mSelectTag.current == FILTER_NO_TAGS_NO_TAGS_______){
                arrayNewCards = arrayNewCards.filter(p=>!p.tags || p.tags.length == 0);
            }else{
                arrayNewCards = arrayNewCards.filter(p=>p.tags?.includes(mSelectTag.current));
            }
        }

        let arrayNewNewNew:any = [];
        arrayNewCards = await reSearchByKeyreSearchByKeyreSearchByKeyreSearchByKeyreSearchByKey(arrayNewCards);

        if (isFavor){
            arrayNewNewNew = arrayNewCards.filter(p=>p.isFavirated);
        }else if (isPublished){
            const arrayPublished = await getPublishProjectList('card');
            for (let i=0;i<arrayNewCards.length;i++){
                const item = arrayNewCards[i];
                if (arrayPublished.find(p=>p.id == item.id)){
                    arrayNewNewNew.push(item);
                }
            }
        }else{
            arrayNewNewNew.push(...arrayNewCards);
        }

        return arrayNewNewNew;
    }

    const reSearchByKeyreSearchByKeyreSearchByKeyreSearchByKeyreSearchByKey = async (arrayResult)=>{
        if (mSearchKey.current){
            let arrayNewResult:any = [];
            let searchKey = mSearchKey.current.toLowerCase();
            for (let i=0;i<arrayResult.length;i++){
                const card = arrayResult[i];
                if (card.name && card.name.toLowerCase().indexOf(searchKey) != -1){
                    arrayNewResult.push(card);
                    continue;
                }
                if (card.type == 'card' || card.type == 'journal'){
                    let szHtml:any = await getCardDoc(card.id);
                    if (szHtml){
                        szHtml = removeHtmlTags(szHtml);
                        if (szHtml.toLowerCase().indexOf(searchKey) != -1){
                            arrayNewResult.push(card);
                        }
                    }
                }else if (card.type == 'pdfAnno'){
                    if (card.comment?.toLowerCase()?.includes(searchKey) || card.text?.toLowerCase()?.includes(searchKey)){
                        arrayNewResult.push(card);
                    }
                }else if (card.type == 'videoAnno'){
                    if (card.content?.toLowerCase()?.includes(searchKey) || card.title?.toLowerCase()?.includes(searchKey)){
                        arrayNewResult.push(card);
                    }
                }
            }
            return arrayNewResult
        }
        return arrayResult;
    }

    /**
     * 通过项目过滤
     */
    const filterByProjectId = async (arrayCards:any)=>{
        let arrayNewCards:any = [];
        const arraySelectTypes = getSelectedTypes();

        const isCard = arraySelectTypes.some(p=>p.value == 'card');

        const isVideoChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'video')
        const isAudioChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'audio')
        const isPdfChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'pdf')
        const isCardChecked = mArraySelectedTypes.current.some(p=>p.isChecked && p.value == 'card')

        const isVideoAnno = arraySelectTypes.some(p=>p.value == 'videoAnno');
        const isAudioAnno = arraySelectTypes.some(p=>p.value == 'audioAnno');
        const isPdfAnno = arraySelectTypes.some(p=>p.value == 'pdfAnno');
        const isCardAnno = arraySelectTypes.some(p=>p.value == 'cardAnno');
        const isLiveVideo = arraySelectTypes.some(p=>p.value == 'liveVideo');
        if (isLiveVideo){
            arraySelectTypes.push({
                value:'bilibili'
            })
            arraySelectTypes.push({
                value:'baidu'
            })
            arraySelectTypes.push({
                value:'youtube'
            })
        }

        let szSelectProjectId = mSelectProjectId;
        if (szSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || szSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
            szSelectProjectId = PROJECT_ID;//当前项目的ID
        }

        if (isAllProject()){
            //列表里面，有在项目的...
            return arrayCards;
        }else if (szSelectProjectId == FILTER_PROJECT_ID_ALL_IN_PROJECT || szSelectProjectId == FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL){
            var arrayNewCard = [];
            const arrayNoteLists:any = await getNoteList();

            for (let i=0;i<arrayNoteLists.length;i++){
                const item = arrayNoteLists[i];
                const jsonObj = await getNoteDoc(item.id);
                const jsonDoc = JSON.parse(jsonObj.doc);
                // if (isCard){//不要了，所有的东西都从elements中来判断
                //     //仅note...
                //     for (let j=0;j<jsonDoc.notes.length;j++){
                //         const note = jsonDoc.notes[j];
                //         const card:any = await getCardById(note.key,false);
                //         //未添加过的，添加进来
                //         if (card && !arrayNewCards.some(p=>p.id == card?.id)){
                //             arrayNewCards.push(card);
                //         }
                //     }
                // }

                await loopAllNodeAsync(jsonDoc.canvas,async (canvas)=>{
                    if (canvas.drawJson?.elements){
                        for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                            const element = canvas.drawJson.elements[j];
                            const card:any = await getCardById(element.customData?.generationData?.pdfData?.id || element.customData?.generationData?.id || element.id,false);
                            //未添加过的，添加进来
                            if (card && arraySelectTypes.some(p=>p.value == card.type) && !arrayNewCards.some(p=>p.id == card?.id)){
                                arrayNewCards.push(card);
                            }
                        }
                    }
                })

                // for (let i=0;i<jsonDoc.canvas.length;i++) {
                //     const canvas = jsonDoc.canvas[i];
                //     for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                //         const element = canvas.drawJson.elements[j];
                //         const card:any = await getCardById(element.customData?.generationData?.pdfData?.id || element.customData?.generationData?.id || element.id,false);
                //         //未添加过的，添加进来
                //         if (card && arraySelectTypes.some(p=>p.value == card.type) && !arrayNewCards.some(p=>p.id == card?.id)){
                //             arrayNewCards.push(card);
                //         }
                //     }
                // }
            }
            if (szSelectProjectId == 'notInProject'){
                //取差集...
                let arrayNew:any = [];
                for (let i=0;i<arrayCards.length;i++){
                    if (!arrayNewCards.some(p=>p.id == arrayCards[i].id)){
                        arrayNew.push(arrayCards[i]);
                    }
                }
                arrayNewCards = arrayNew;
            }
            return arrayNewCards;

        }

        const jsonObj = await getNoteDoc(szSelectProjectId);
        if (jsonObj) {
            const jsonDoc = JSON.parse(jsonObj?.doc);
            //仅note...
            for (let i = 0; i < jsonDoc.notes.length; i++) {
                if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD) {
                    if (jsonDoc.notes[i].key != global.g_currentBoardId) continue;
                }
                const cardNote = arrayCards.find(p => p.id == jsonDoc.notes[i].key);
                if (cardNote) {
                    if (isCardChecked) {
                        arrayNewCards.push(cardNote);
                    }

                    //添加下面的所有标注--如果选择了标注
                    if (isCardAnno) {
                        //实体在，所有的标注都要在.
                        const arrayAnnos = await getCardListByLibraryId(cardNote.id);
                        //没添加过的添加进来...
                        for (let k = 0; k < arrayAnnos.length; k++) {
                            const subItem = arrayAnnos[k]
                            if (!arrayNewCards.some(p => p.id == subItem.id)) {
                                arrayNewCards.push(subItem);
                            }
                        }
                    }
                }
            }


            await loopAllNodeAsync(jsonDoc.canvas, async (canvas) => {
                if (canvas.drawJson?.elements) {
                    if (mSelectProjectId !== FILTER_PROJECT_CURRENT_BOARD || (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD && canvas.key == global.g_currentBoardId)) {
                        for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                            const element = canvas.drawJson.elements[j];
                            const item = arrayCards.find(p => p.id == element.id || p.id == element.customData?.generationData?.id);
                            if (item) {
                                if (!arrayNewCards.some(p => p.id == item.id)) {
                                    if ((isVideoChecked && isFileVideoElement(element)) ||
                                        (isAudioChecked && isAudioFileElement(element)) ||
                                        (isPdfChecked && isPdfFileElement(element)) ||
                                        (isCardChecked && isNoteElement(element))) {
                                        arrayNewCards.push(item);
                                    }

                                    //下面的标注也全部显示.
                                    if ((isFileVideoElement(element) && isVideoAnno) ||
                                        (isAudioFileElement(element) && isAudioAnno) ||
                                        (isPdfFileElement(element) && isPdfAnno) ||
                                        (isNoteElement(element) && isCardAnno)) {
                                        const arrayAnnos = await getCardListByLibraryId(item.id);
                                        //没添加过的添加进来...
                                        for (let k = 0; k < arrayAnnos.length; k++) {
                                            const subItem = arrayAnnos[k]
                                            if (!arrayNewCards.some(p => p.id == subItem.id)) {
                                                arrayNewCards.push(subItem);
                                            }
                                        }
                                    }

                                    if ((isVideoAnnoElement(element) && isVideoAnno) ||
                                        (isAudioAnnoElement(element) && isAudioAnno) ||
                                        (isPdfAnnoElement(element) && isPdfAnno) ||
                                        (isCardAnnoElement(element) && isCardAnno)) {
                                        if (isAnnoType(item.type)) {
                                            if (!arrayNewCards.some(p => p.id == item.id)) {
                                                arrayNewCards.push(item);
                                            }
                                        }
                                    }

                                    if (isImageElement(element)) {
                                        if (!arrayNewCards.some(p => p.id == item.id)) {
                                            arrayNewCards.push(item);
                                        }
                                    } else if (isFileElement(element)) {
                                        if ((item.type == 'pdf' && isPdfChecked) ||
                                            (item.type == 'video' && isVideoChecked) ||
                                            (item.type == 'audio' && isAudioChecked))
                                            if (!arrayNewCards.some(p => p.id == item.id)) {
                                                arrayNewCards.push(item);
                                            }
                                    }
                                    if (isLiveVideo) {
                                        if (item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu') {
                                            if (!arrayNewCards.some(p => p.id == item.id)) {
                                                arrayNewCards.push(item);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });

            /*
            for (let i = 0; i < jsonDoc.canvas.length; i++) {
                const canvas = jsonDoc.canvas[i];
                if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD) {
                    if (canvas.key != global.g_currentBoardId) continue;
                }
                for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                    const element = canvas.drawJson.elements[j];
                    const item = arrayCards.find(p => p.id == element.id || p.id == element.customData?.generationData?.id);
                    if (item) {
                        if (!arrayNewCards.some(p => p.id == item.id)) {
                            if ((isVideoChecked && isFileVideoElement(element)) ||
                                (isAudioChecked && isAudioFileElement(element)) ||
                                (isPdfChecked && isPdfFileElement(element)) ||
                                (isCardChecked && isNoteElement(element))) {
                                arrayNewCards.push(item);
                            }

                            //下面的标注也全部显示.
                            if ((isFileVideoElement(element) && isVideoAnno) ||
                                (isAudioFileElement(element) && isAudioAnno) ||
                                (isPdfFileElement(element) && isPdfAnno) ||
                                (isNoteElement(element) && isCardAnno)) {
                                const arrayAnnos = await getCardListByLibraryId(item.id);
                                //没添加过的添加进来...
                                for (let k = 0; k < arrayAnnos.length; k++) {
                                    const subItem = arrayAnnos[k]
                                    if (!arrayNewCards.some(p => p.id == subItem.id)) {
                                        arrayNewCards.push(subItem);
                                    }
                                }
                            }

                            if ((isVideoAnnoElement(element) && isVideoAnno) ||
                                (isAudioAnnoElement(element) && isAudioAnno) ||
                                (isPdfAnnoElement(element) && isPdfAnno) ||
                                (isCardAnnoElement(element) && isCardAnno)) {
                                if (isAnnoType(item.type)) {
                                    if (!arrayNewCards.some(p => p.id == item.id)) {
                                        arrayNewCards.push(item);
                                    }
                                }
                            }

                            if (isImageElement(element)) {
                                if (!arrayNewCards.some(p => p.id == item.id)) {
                                    arrayNewCards.push(item);
                                }
                            } else if (isFileElement(element)) {
                                if ((item.type == 'pdf' && isPdfChecked) ||
                                    (item.type == 'video' && isVideoChecked) ||
                                    (item.type == 'audio' && isAudioChecked))
                                    if (!arrayNewCards.some(p => p.id == item.id)) {
                                        arrayNewCards.push(item);
                                    }
                            }
                            if (isLiveVideo) {
                                if (item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu') {
                                    if (!arrayNewCards.some(p => p.id == item.id)) {
                                        arrayNewCards.push(item);
                                    }
                                }
                            }
                        }
                    }
                }
            }*/
        }
        return arrayNewCards;
    }

    /**
     * 添加新的
     * 添加空白
     * 插入新的
     * 插入空白
     * 插入卡片
     * 插入new
     * @param arrayCards
     */
    const addNewItem = (arrayCards)=>{
        let bNewInsert = props.isInsertNewLibrary;
        if (bNewInsert && props.type != 'highlight'){
            if (arrayCards.some(p=>p.id == '-1'))return;//已经插入了。不需要再添加
            //添加一个 添加....
            let szName = t("Create a new card");
            let szCreateType = 'card';
            if (props.type == 'pdf'){
                szName = t("Add a new pdf");
                szCreateType = 'pdf';
            }else if (props.type == 'image'){
                szName = t("Add a new image");
                szCreateType = 'image';
            }else if (props.type == 'video'){
                szName = t("New video");
                szCreateType = 'video';
            }else if (props.type == 'file'){
                szName = t("New file");
                szCreateType = 'file';
            }

            if (props.subFromPage == 'DialogLink'){
                szName = t("Create a new card");
                szCreateType = 'card';
                if (props.type == 'pdf'){
                    szName = t("Add a new pdf");
                    szCreateType = 'pdf';
                }
            }
            if (props.source == 'DialogLink'){
                szName = t("Create a new card");
                szCreateType = 'card';
            }
            arrayCards.splice(0,0,{
                id:'-1',
                type:'add',
                createType:szCreateType,
                name:szName
            })
        }
    }

    /**
     * 排序列表
     * @param arrayCards
     */
    const sortCards = async (arrayCards:any)=>{
        // let szSelectProjectId = mSelectProjectId;
        // if (szSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || szSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
        //     szSelectProjectId = PROJECT_ID;//当前项目的ID
        // }

        let szSortType = localStorage.getItem(KEY_CARD_SORT_TYPE);
        let szOrderBy = localStorage.getItem(KEY_CARD_ORDER_BY);
        if(!szSortType){
            szSortType = "sort by updateDate";
        }
        if(!szOrderBy){
            szOrderBy = "date desc"
        }
        //更新排序描述文字
        updateSortTypeDesc(szSortType);

        //重新排序-------filterByProjectId后顺序被打乱了.
        if ("sort by name" === szSortType) {
            if ("a-z" === szOrderBy) {
                arrayCards.sort((a, b) => {
                    if (a.name == undefined || b.name == undefined) return 0;
                    return a.name.localeCompare(b.name);
                })
            } else if ("z-a" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    if (a.name == undefined || b.name == undefined) return 0;
                    return b.name.localeCompare(a.name);
                })
            }
        } else if ("sort by createDate" == szSortType) {
            if ("date asc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return a.createTime - b.createTime;
                })
            } else if ("date desc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return b.createTime - a.createTime;
                })
            }
        } else if ("sort by updateDate" == szSortType) {
            if ("date asc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return a.updateTime - b.updateTime;
                })
            } else if ("date desc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return b.updateTime - a.updateTime;
                })
            }
        }

        //这里再穿插一个原始的排序.
        if (global.g_mArrayOriginSort){
            arrayCards.sort((a,b)=>{
                let nA = global.g_mArrayOriginSort[a.id];
                let nB = global.g_mArrayOriginSort[b.id];
                if (nA == undefined || nA == null){
                    nA = 10000000;
                }
                if ((Date.now() - a.createTime) < 2000){
                    nA = 0;
                }

                if (nB == undefined || nB == null){
                    nB = 10000000;
                }
                if ((Date.now() - b.createTime) < 2000){
                    nB = 0;
                }
                return nA - nB;
            })
        }else{
            global.g_mArrayOriginSort = {};
        }

        for (let i=0;i<arrayCards.length;i++){
            global.g_mArrayOriginSort[arrayCards[i].id] = (i+1);
        }

        mIsQuerying.current = false;

        //选中之前选中的
        arrayCards.forEach(p=>{
            p.isChecked = false;
            if (mMapIdCheck[p.id]){
                p.isChecked = true;
            }
        })
        let arrayNewCards = [...arrayCards];
        if (mSelectAnnoSource.current){
            //又带了一层过滤....
            arrayNewCards = arrayCards.filter(p=>p.libraryId == mSelectAnnoSource.current.id)
        }
        let arrayLimitCard:any = arrayNewCards;
        if (mPageNum.current <= 0){
            //如果有搜索，有选择project/tag/filter的话再按搜索结果过滤一遍。什么都往上面加。。。
            if (mSearchKey.current){
                //带搜索的，再处理一遍标题包含的在前.
                const arrayIncludeTitles = [];
                for (let i=0;i<arrayLimitCard.length;i++){
                    const library = arrayLimitCard[i];
                    if (isAnnoType(library.type))continue;
                    if (library.name?.toLowerCase()?.includes(mSearchKey.current)){
                        arrayIncludeTitles.push(library);
                    }
                }
                arrayIncludeTitles.sort((a,b)=>{
                    return a.name.localeCompare(b.name);
                })
                const arrayNewNewLibrary:any = [...arrayIncludeTitles];
                for (let i=0;i<arrayLimitCard.length;i++){
                    const library = arrayLimitCard[i];
                    if (!arrayIncludeTitles.some(p=>p.id == library.id)){
                        arrayNewNewLibrary.push(library);
                    }
                }
                arrayLimitCard = arrayNewNewLibrary;
            }

            addNewItem(arrayLimitCard);
            setArrayCardList(arrayLimitCard);
        }else{
            arrayLimitCard = [...arrayCardList];

            let bFind = false;
            for (let j=0;j<arrayNewCards.length;j++){
                const newItem = arrayNewCards[j];
                bFind = false;

                for (let i=0;i<arrayLimitCard.length;i++){
                    const item = arrayLimitCard[i];
                    if (item.id == newItem.id){
                        arrayLimitCard[i] = newItem;
                        bFind = true;
                        break;
                    }
                }
                if (!bFind){
                    arrayLimitCard.push(newItem);
                }
            }
            addNewItem(arrayLimitCard);
            setArrayCardList(arrayLimitCard);
        }

        //这里处理所有anno
        if (mOnlyAnno.current){
            const arraySourceIds:any = [];
            for (let i=0;i<arrayLimitCard.length;i++){
                const szLibId = arrayLimitCard[i].libraryId;
                if (szLibId && !arraySourceIds.includes(szLibId)){
                    arraySourceIds.push(szLibId);
                }
            }
            //取所有
            const arrayAllSource:any = await getSourceByAnnoType(mArraySelectedTypes.current);
            const arraySource:any = [];
            //再过滤一遍，有注记的才显示.
            for (let i=0;i<arrayAllSource.length;i++){
                const item = arrayAllSource[i];
                if (arrayCards.some(p=>p.libraryId == item.id)){
                    arraySource.push(item);
                }else{
                    //去数据库找一下，这个source有没有注记...
                    const arrayAnnos = await getCardListByLibraryId(item.id);
                    if (arrayAnnos && arrayAnnos.length >0){
                        arraySource.push(item);
                    }
                }
            }
            //按查看时间排序
            arraySource.sort((a,b)=>{
                let aTime = a.viewTime || a.updateTime || a.createTime;
                let bTime = b.viewTime || b.updateTime || b.createTime;
                return bTime - aTime;
            })
            mArrayAnnoSource.current = [...arraySource];
            setArrayAnnoSource(arraySource);
        }

        setIsLoading(false);
        setIsEmptyData(arrayLimitCard.length == 0);

        return arrayLimitCard;
    }

    const outRefreshUpdateList = (data:any,extra:any)=>{
        if (extra?.id != mThisID.current){
            mPageNum.current = 0;
            updateList();
        }
    }

    /**
     * 刷新单个数据...
     * @param data
     */
    const onRefreshSingleItem = async (szId:any)=>{
        const arrayItems = [...arrayCardList];
        const nIndex = arrayItems.findIndex(p=>p.id == szId);
        if (nIndex != -1){
            const dbData = await getCardById(szId);
            if (dbData){
                arrayItems.splice(nIndex,1,dbData);
                setArrayCardList(arrayItems);
            }
        }
    }

    /**
     * 移除一个条目
     * @param szId
     */
    const onRemoveItemInPublishTab = (szId:any)=>{
        if (mActiveTabItemRef.current?.id == 'published'){
            const arrayItems = [...arrayCardList];
            const nIndex = arrayItems.findIndex(p=>p.id == szId);
            if (nIndex != -1){
                arrayItems.splice(nIndex,1);
                setArrayCardList(arrayItems);
                setLibraryCount(arrayItems.length);
            }
        }
    }

    /**
     * 移除一个条目
     * @param szId
     */
    const onRemoveItemInFavorTab = (szId:any)=>{
        if (mActiveTabItemRef.current?.id == 'favorites'){
            const arrayItems = [...arrayCardList];
            const nIndex = arrayItems.findIndex(p=>p.id == szId);
            if (nIndex != -1){
                arrayItems.splice(nIndex,1);
                setArrayCardList(arrayItems);
                setLibraryCount(arrayItems.length);
            }
        }
    }

    /**
     * 刷新有关card的所有注记
     * @param szCardId
     */
    const onRefreshLibraryCardAnnoList = async (szCardId)=>{
        const arrayAnnos = await getCardListByLibraryId(szCardId);
        const arrayNewDatas = [...arrayCardList];
        for (let i=0;i<arrayAnnos.length;i++){
            const item = arrayAnnos[i];
            const nIndex = arrayNewDatas.findIndex(p=>p.id == item.id);
            if (nIndex != -1){
                arrayNewDatas.splice(nIndex,1,item);
            }
        }
        setArrayCardList(arrayNewDatas);
    }

    /*
    更新带排序的笔记列表
    更新列表，
    刷新列表
    */
    const updateList = (isLoading:boolean = false) => {

        // if (mActiveTabItemRef.current?.id == 'published'){
        //     getPublishProjectList('card').then(async (arrayCards:any)=>{
        //         const arrayFilterDatas = await sortCards(arrayCards);
        //         setLibraryCount(arrayFilterDatas.length);
        //     })
        //     return;
        // }
        let isFavor = mActiveTabItemRef.current?.id == 'favorites';
        let isPublished = mActiveTabItemRef.current?.id == 'published';

        if (mSelectCustomFilter.current){
            customFilterEvent(mSelectCustomFilter.current);
            return;
        }
        if(mIsQuerying.current)return;
        if (mPageNum.current <= 0){
            //滚动到顶部.
            const grid = document.getElementById(props.from == FROM_HOME_LIBRARY ? 'divCardItemContainer' : 'divCardItemContainer-from-other');
            if (grid){
                grid.scrollTop = 0;
            }
        }

        console.log('update list:'+mPageNum.current);
        mIsQuerying.current = true;
        // setIsLoading((mPageNum == 0 && Global.g_isCardUpdate) || isLoading);
        // setArrayCardList(mArrayCardCache);
        return new Promise((resolve, reject) => {
            const arrayTypes:any = [];
            const arrayAnnos = ['cardAnno','pdfAnno','videoAnno','audioAnno'];
            let hasOnlyAnno = true;
            for (let i=0;i<mArraySelectedTypes.current.length;i++){
                if (mArraySelectedTypes.current[i].isChecked){
                    arrayTypes.push(mArraySelectedTypes.current[i].value);
                    if (!arrayAnnos.includes(mArraySelectedTypes.current[i].value)){
                        hasOnlyAnno = false;
                    }
                }
            }
            mOnlyAnno.current = hasOnlyAnno;
            //仅有标注类型
            setOnlyAnno(hasOnlyAnno);

            if (props.type){
                //有固定的类型
                if (props.type == 'highlight'){
                    // arrayTypes.push('cardAnno');
                    // arrayTypes.push('pdfAnno');
                    // arrayTypes.push('videoAnno');
                    // arrayTypes.push('audioAnno');
                }else{
                    arrayTypes.length = 0;
                    arrayTypes.push(props.type);
                }
            }

            // if (mSelectProjectId != 'all-0' && mSelectProjectId != FILTER_PROJECT_ID_ALL && mSelectProjectId != FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL){
            //     if (arrayTypes.includes('cardAnno') && !arrayTypes.includes('card')){
            //         arrayTypes.push('card');
            //     }
            //     if (arrayTypes.includes('pdfAnno') && !arrayTypes.includes('pdf')){
            //         arrayTypes.push('pdf');
            //     }
            //     if (arrayTypes.includes('videoAnno') && !arrayTypes.includes('video')){
            //         arrayTypes.push('video');
            //     }
            //     if (arrayTypes.includes('audioAnno') && !arrayTypes.includes('audio')){
            //         arrayTypes.push('audio');
            //     }
            // }

            // if (szSelectProjectId != 'all-0' && szSelectProjectId != FILTER_PROJECT_ID_ALL && szSelectProjectId != FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL){
            //     //只有一个项目
            //     getNoteById(szSelectProjectId).then(async (res)=>{
            //         await sortCards([res]);
            //         resolve('ok');
            //     })
            // }else{
            //
            // }

            let szSelectProjectId = mSelectProjectId;
            let isFilterByProjectId = false;
            if (szSelectProjectId && szSelectProjectId != FILTER_PROJECT_ID_ALL && szSelectProjectId != FILTER_PROJECT_ID_ALL_IN_PROJECT && szSelectProjectId != FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL && szSelectProjectId != "all-0"){
                isFilterByProjectId = true;
            }
            if (isFilterByProjectId){
                filterByProjectNewNew(mSelectProjectId,isFavor,isPublished).then(async (arrayCards)=>{
                    await sortCards(arrayCards);
                    setLibraryCount(arrayCards.length);
                    setIsSearching(false);
                    if (window.closeRightSliderSearch){
                        window.closeRightSliderSearch();
                    }
                    if (window.closeDrawSearching){
                        window.closeDrawSearching();
                    }
                    resolve('ok');
                })
            }else{
                let szTag = mSelectTag.current;
                if (isAllTag(szTag)){
                    szTag = '';
                }
                if (mSelectAnnoSource.current || hasFilterCondition() || isFavor){
                    mPageNum.current = -1;//这里不能排序了。。。不然找到的数据可能是别的注记的前一些页面
                }

                getCardList(mPageNum.current,0,arrayTypes,szTag,mSearchKey.current,(nCount:any)=>{
                    setLibraryCount(nCount);
                },isFavor,isPublished).then(async (arrayCards:any) => {
                    if (!isStringNullOrEmpty(mSelectProjectId) && mSelectProjectId != 'all-0'){
                        arrayCards = await filterByProjectId(arrayCards);
                    }
                    const arrayFilterDatas = await sortCards(arrayCards);
                    setIsSearching(false);
                    if (mSearchCallback.current){
                        mSearchCallback.current();
                    }
                    if (window.closeRightSliderSearch){
                        window.closeRightSliderSearch();
                    }
                    if (window.closeDrawSearching){
                        window.closeDrawSearching();
                    }
                    resolve('ok');

                    //这里查询数量
                    if (mPageNum.current == 0){
                        getLibraryCount(mPageNum.current,0,arrayTypes,szTag,mSearchKey.current,isFavor).then(res=>{
                            setLibraryCount(res);
                        })
                    }else if (mPageNum.current == -1){
                        setLibraryCount(arrayFilterDatas.length);
                    }
                });
            }
        })
    }

    /**
     * 刷新数量
     */
    const refreshLibraryCount = ()=>{
        getLibraryCount(mPageNum.current,0,arrayTypes,mSelectTag.current,mSearchKey.current).then(res=>{
            setLibraryCount(res);
        })
    }


    /**
     * 选中的数量
     */
    const getSelectedArray = ()=>{
        return arrayCardList.filter(p=>p.isChecked);
    }

    /**
     * 是否有选择条目
     */
    const hasCheckSelectedOk = ()=>{
        const arraySelectedItem = getSelectedArray();
        if (arraySelectedItem.length == 0){
            message.info(t("PleaseSelected"));
            return null;
        }
        return arraySelectedItem;
    }

    /**
     * 复制一个文件....
     * @param selectedFile
     * @param arrayNewDatas
     */
    const copyOneFile = async (selectedFile:any,arrayNewDatas:any)=>{
        let res = '';
        if (selectedFile.path){
            res = await ipcInvoke('copy-file',{filePath:selectedFile.path});
        }
        let szImgBase64:any = '';
        let szType = 'file';
        if (isPdf(selectedFile.path)){
            szImgBase64 = await getPdfImageThumb('localfile://'+res);
            szType = 'pdf'
        }else if (isVideo(selectedFile.path)){
            szImgBase64 = await getVideoImageThumb('localfile://'+res);
            szType = 'video'
        }else if (isImage(selectedFile.path) || selectedFile.imageBase64){
            szType = 'image'
            if (selectedFile.imageBase64){
                szImgBase64 = selectedFile.imageBase64;
                res = 'screenshot_'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.png';
            }

        }else if (isAudio(selectedFile.path)){
            szType = 'audio'
        }

        const id = generateUUID2();
        //缩略图保存为文件
        let szSrc = '';
        if (szImgBase64){
            let szFileName = id + ".png";
            if (selectedFile.imageBase64){
                szFileName = res;//使用截图的文件名....
            }
            await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:szImgBase64});
            szSrc = getScheme()+szFileName;
        }

        const item = {
            id:id,
            name:getFileNameWithoutExt(res),
            fileName:res,
            type:szType,
            thumbImage:szSrc,
            createTime:Date.now()
        }

        //仅当没有打开卡片的时候这个才有效，不然卡片添加图片，图片又打开chooseimage,里面又添加图片会走这个方法。。。。。
        if (isImage(res) && (isInJournal() || isInPageCard() || window.getDialogCardCount() > 0)){
            //这些地方不管添加的是什么，都不再自动加入到库中。。。。-----
            //删除原本需要保存到库中的图片
            ipcInvoke('delete-files-file',{fileName:res});
        }else{
            await updateCard(item);
        }
        if (mArraySelectedTypes.current.some(p=>p.isChecked && p.value == szType)){
            arrayNewDatas.push(item);
        }

        if (props.from == FROM_ADD && (props.type == 'image' || props.type == 'video' || props.type == 'file')){
            //图片的直接保存后添加...
            if (props.onItemSelectedCallback){
                props.onItemSelectedCallback(item);
            }
        }
    }

    /**
     * 选择PDF文件
     * @param event
     */
    const handleFileChange = async (event:any)=>{
        let selectedFiles = event.target.files;
        if (selectedFiles instanceof File){
            selectedFiles = [selectedFiles];
        }
        const input = document.getElementById('file-input-page-library');
        if (selectedFiles.length > 10){
            message.info(t("YouCanUploadUp10"));
            input.value = '';
            return;
        }
        var arrayNewDatas:any = [];

        if (selectedFiles.length == 1){
            const selectedFile = selectedFiles[0];
            if (isVideo(selectedFile.path)){
                let nVideoCount = await beyondFreeVideoLimit();
                if (!hasLicense() && !hasDesktopBaseLicense() && nVideoCount){
                    window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), null, () => {
                        if (isZh()) {
                            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                        }else {
                            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                        }
                    })
                    input.value = '';
                    return;
                }
            }else if (isPdf(selectedFile.path)){
                let nPdfCount = await beyondFreePdfLimit();
                if (!hasLicense() && !hasDesktopBaseLicense() && nPdfCount){
                    window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                        if (isZh()) {
                            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                        }else {
                            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                        }
                    })
                    input.value = '';
                    return;
                }
            }
            if (props.from != FROM_ADD && isMarkdown(selectedFile.path)){
                window.importMarkdown(selectedFile,()=>{
                    //刷新列表
                    mPageNum.current = 0;
                    updateList();
                });
                input.value = '';
                return;
            }
            //检测重复文件，取消了，省得慢。本来用途也不大，老是提这种问题。
            const szExistFileName = false;//不再检测重复的文件了。老是提慢。。。。await ipcInvoke('cmp-file-md5', {filePath:selectedFile.path});
            if (szExistFileName){
                window.showMessageBox(t("DuplicateFileFound"),t("TheSameFileAlreadyExists"),t("CreateNewCopy"),t("Ok"),async ()=>{
                    //create new copy-----------
                    await copyOneFile(selectedFile,arrayNewDatas);

                    arrayNewDatas.push(...arrayCardList);
                    setArrayCardList(arrayNewDatas);
                },()=>{

                })
            }else{
                //单个文件copy----------------
                await copyOneFile(selectedFile,arrayNewDatas);

                arrayNewDatas.push(...arrayCardList);
                setArrayCardList(arrayNewDatas);
            }
        }else{
            for (let i=0;i<selectedFiles.length;i++){
                const selectedFile = selectedFiles[i];

                if (isWebApp()){
                    //region
                    let item = {
                        id:generateUUID2(),
                        name:getFileNameWithoutExt(getFileNameWithoutExt(selectedFile.name)),
                        type:selectType.value,
                        createTime:Date.now()
                    }
                    let szImgBase64:any = '';
                    //上传，保存...
                    window.showProgress();
                    uploadS3File(item.id,selectedFile,'file').then(async (res)=>{
                        window.closeProgress();
                        //save...
                        if (selectType.value == 'pdf'){
                            const blobUrl = URL.createObjectURL(selectedFile);
                            szImgBase64 = await getPdfImageThumb(blobUrl);
                            URL.revokeObjectURL(blobUrl);
                        }else if (selectType.value == 'video'){
                            szImgBase64 = await getVideoImageThumb(res);
                        }
                        if (szImgBase64){
                            //缩略图搞小点
                            try{
                                let file = new File([base64ToBlob(szImgBase64)],'preview',{ type: MIME_TYPES.png });
                                const newImageFile = await resizeImageFile(file,
                                    {
                                        outputType: MIME_TYPES.jpg,
                                        maxWidthOrHeight: 200,
                                    });
                                szImgBase64 = await fileToBase64(newImageFile);
                            }catch (e){
                                console.log('thumb resize err...'+e);
                            }
                        }
                        item.thumbImage = szImgBase64;
                        item.url = res;

                        updateCard(item);

                        var arrayNewDatas:any = [item];
                        arrayNewDatas.push(...arrayCardList);
                        setArrayCardList(arrayNewDatas);

                        const input = document.getElementById('file-input-page-library');
                        input.value = '';

                    });
                    //endregion
                }
                else{
                    const res = await ipcInvoke('copy-file',{filePath:selectedFile.path});
                    let szImgBase64:any = '';
                    let szType = 'file';
                    if (isPdf(selectedFile.path)){
                        szImgBase64 = await getPdfImageThumb('localfile://'+res);
                        szType = 'pdf'
                        let nPdfCount = await beyondFreePdfLimit();
                        if (!hasLicense() && !hasDesktopBaseLicense() && nPdfCount){
                            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                                if (isZh()) {
                                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                }else {
                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                }
                            })
                            continue;
                        }
                    }else if (isVideo(selectedFile.path)){
                        szImgBase64 = await getVideoImageThumb('localfile://'+res);
                        szType = 'video'
                        let nVideoCount = await beyondFreeVideoLimit();
                        if (!hasLicense() && !hasDesktopBaseLicense() && nVideoCount){
                            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), null, () => {
                                if (isZh()) {
                                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                }else {
                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                }
                            })
                            continue;
                        }

                    }else if (isImage(selectedFile.path)){
                        szType = 'image'
                    }else if (isAudio(selectedFile.path)){
                        szType = 'audio'
                    }

                    const id = generateUUID2();
                    //缩略图保存为文件
                    let szSrc = '';
                    if (szImgBase64){
                        const szFileName = id + ".png";
                        await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:szImgBase64});
                        szSrc = getScheme()+szFileName;
                    }

                    const item = {
                        id:id,
                        name:getFileNameWithoutExt(res),
                        fileName:res,
                        type:szType,
                        thumbImage:szSrc,
                        createTime:Date.now()
                    }

                    await updateCard(item);

                    if (mArraySelectedTypes.current.some(p=>p.isChecked && p.value == szType)){
                        arrayNewDatas.push(item);
                    }

                    if (props.from == FROM_ADD && (props.type == 'image' || props.type == 'video' || props.type == 'file')){
                        //图片的直接保存后添加...
                        if (props.onItemSelectedCallback){
                            props.onItemSelectedCallback(item);
                        }
                    }
                }
            }

            arrayNewDatas.push(...arrayCardList);
            setArrayCardList(arrayNewDatas);
        }

        input.value = '';

    }

    /**
     * 添加到项目
     */
    const addToProjectEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        window.showDialogChooseProject(arraySelectItem);
    }
    /**
     * 管理标签
     */
    const managerTagsEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        mMapIdCheck = {};
        arraySelectItem.forEach(p=>{
            mMapIdCheck[p.id] = true;
        })
        dialogTagManagerRef.current?.onShowDialog(arraySelectItem);
    }
    /**
     * 更改source
     */
    const changeSourceEvent = (item:any)=>{
        //选择的
        const arrayChecked:any = arrayCardList.filter(p=>p.isChecked);
        if (item){
            arrayChecked.push(item);
        }
        let bPdf = arrayChecked.some(p=>(p.type == 'pdf' || p.type == 'pdfAnno'));
        let bVideo = arrayChecked.some(p=>(p.type == 'video' || p.type == 'videoAnno'));
        let bAudio = arrayChecked.some(p=>(p.type == 'audio' || p.type == 'audioAnno'));
        if ((bPdf && bVideo) || (bPdf && bAudio) || (bVideo && bAudio)){
            message.error(t("PleaseChooseOnlyType"));
            return;
        }

        if (bVideo){
            //视频.
            window.showDialogLibraryImport('video',async (data)=>{
                let mapIds:any = {};
                if (!item){
                    for (let i=0;i<arrayChecked.length;i++){
                        const itemChecked = arrayChecked[i];
                        if (isAnnoType(itemChecked.type) && itemChecked.libraryId && !mapIds[itemChecked.libraryId]){
                            mapIds[itemChecked.libraryId] = true;
                            const librayItem = await getCardById(itemChecked.libraryId);
                            if (!librayItem){
                                //条目被删除，然后又从回收站中清空了。然后又来更改标注的source ????
                                data.isDeleted = 0;
                                data.id = itemChecked.libraryId;
                                //更新highlight中的
                                const highlight = await dbGetHighlight(itemChecked.libraryId);
                                if (highlight){
                                    highlight.isDeleted = 0;
                                    await updateHighlight(highlight);
                                }
                                await updateCard(data);
                            }
                            await updateChangeSourceVideo(itemChecked.libraryId,data);
                        }
                        if (itemChecked.type == 'video' || itemChecked.type == 'audio' || itemChecked.type == 'pdf'){
                            if (!mapIds[itemChecked.id]){
                                mapIds[itemChecked.id] = true;
                                await updateChangeSourceVideo(itemChecked.id,data);
                            }
                        }
                    }
                    //取消选中
                    setIsShowChecked(false);
                    mMapIdCheck = {};
                    //刷新列表
                    mPageNum.current = 0;
                    updateList();
                }else{
                    if (item.type == 'videoAnno'){
                        const librayItem = await getCardById(item.libraryId);
                        if (!librayItem){
                            //条目被删除，然后又从回收站中清空了。然后又来更改标注的source ????
                            data.isDeleted = 0;
                            data.id = item.libraryId;
                            //更新highlight中的
                            const highlight = await dbGetHighlight(item.libraryId);
                            if (highlight){
                                highlight.isDeleted = 0;
                                await updateHighlight(highlight);
                            }
                            await updateCard(data);
                            updateChangeSourceVideo(data.id,data).then(res=>{
                                //取消选中
                                setIsShowChecked(false);
                                mMapIdCheck = {};
                                //刷新列表
                                mPageNum.current = 0;
                                updateList();
                            });
                        }else{
                            updateChangeSourceVideo(librayItem.id,data).then(res=>{
                                //取消选中
                                setIsShowChecked(false);
                                mMapIdCheck = {};
                                //刷新列表
                                mPageNum.current = 0;
                                updateList();
                            });
                        }
                    }else{
                        updateChangeSourceVideo(item.id,data).then(res=>{
                            //取消选中
                            setIsShowChecked(false);
                            mMapIdCheck = {};
                            //刷新列表
                            mPageNum.current = 0;
                            updateList();
                        });
                    }
                }

            })
            return;
        }

        let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
        if (bPdf){
            filter = [{ name: 'pdf', extensions: ['pdf'] }];
        }else if (bAudio){
            filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
        }
        // window.showDialogChooseCardPdf(async (library:any)=>{
        //     for (let i=0;i<arrayChecked.length;i++){
        //         let item = arrayChecked[i];
        //         await updateChangeSourcePdfAudio20260126(item.id,library);
        //     }
        //     //取消选中
        //     setIsShowChecked(false);
        //     mMapIdCheck = {};
        //     //刷新列表
        //     mPageNum.current = 0;
        //     updateList();
        // },'pdf');
        //20260126 换成直接在库里面选择..
        ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
            if (res){
                for (let i=0;i<arrayChecked.length;i++){
                    let item = arrayChecked[i];
                    if (item.type == 'video' || item.type == 'pdf' || item.type == 'audio' || item.type == 'videoAnno' || item.type == 'pdfAnno' || item.type == 'audioAnno'){
                        if (item.type == 'pdfAnno' || item.type == 'videoAnno' || item.type == 'audioAnno'){
                            item = await getCardById(item.libraryId);
                        }
                        if (!item){
                            //条目被删除，然后又从回收站中清空了。然后又来更改标注的source ????
                            window.importFileToLibrary({name:getFileNameWithoutExt(res),path:res},IMPORT_FILE_MODE_IMPORTMODE,async (data:any)=>{
                                item = data;
                                item.isDeleted = 0;
                                item.id = arrayChecked[i].libraryId;
                                await updateCard(item);
                                if (item.type == 'pdf' || item.type == 'video' || item.type == 'audio'){
                                    await updateChangeSource(item.id,res);
                                    //刷新库...
                                    outRefreshUpdateList(null,null);
                                }
                            },false)
                        }else{
                            if (item.type == 'pdf' || item.type == 'video' || item.type == 'audio'){
                                await updateChangeSource(item.id,res);
                            }
                        }
                    }
                }
                //取消选中
                setIsShowChecked(false);
                mMapIdCheck = {};
                //刷新列表
                mPageNum.current = 0;
                updateList();
            }
        })
    }
    /**
     * 删除选择的
     */
    const deleteSelectedEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        dialogMessageRef.current?.onShowDialog(t("Tips"),t("ConfirmDeleteLibraryItems").replace('{0}',selectType.value+'s'),t("Delete"), async ()=>{

            const arrayNewDatas = [...arrayCardList];
            for (let i=0;i<arraySelectItem.length;i++){
                const item = arraySelectItem[i];
                arraySelectItem[i].isDeleted = 1;
                await updateCard(item);
                //移除这个.----
                const nIndex = arrayNewDatas.findIndex(p=>p.id == item.id);
                arrayNewDatas.splice(nIndex,1);


                //1.***删除相关联的一些数据*********
                //也删除highlight中的..
                dbGetHighlight(item.id).then(res=>{
                    if (res){
                        res.isDeleted = 1;
                        res.deleteTime = item.deleteTime;
                        updateHighlight(res);
                    }
                })

                //删除这个card所关联的项目
                // deleteAllCardFromRefProject(item);

                //如果是视频注记，高亮删除也要更新
                if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                    const r = await dbGetHighlight(item.libraryId || item.id);
                    if (r){
                        //删除这个注记
                        const nIndex = r.data.findIndex(p=>p.id == item.id);
                        if (nIndex != -1){
                            r.data.splice(nIndex,1);
                            await updateHighlight(r);
                        }
                    }
                }

                //pdf注记删除，高亮删除也更新.
                if (item.type == 'pdfAnno'){
                    ipcInvoke('remove-one-annotations',{id:item.id,pdfId:item.libraryId})
                }else if (item.type == 'cardAnno'){
                    await window.removeCardHighlight(item,()=>{
                        // postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    });
                }
                //***删除相关联的一些数据---end---*********
            }

            postMessage(EVENT_FAVIRIATE_CHANGE);
            postMessage(EVENT_REFRESH_RECENTS);

            setIsShowChecked(false);
            mMapIdCheck = {};
            setArrayCardList(arrayNewDatas);

            //全局的别的地方的刷新...
            window.globalRefreshList('refreshLibraryList_',null,{id:mThisID.current});
            let nCount = libraryCount;
            nCount -= arraySelectItem.length;
            if (nCount < 0){
                nCount = 0;
            }
            setLibraryCount(nCount);

            mPageNum.current = 0;
            // //刷新列表
            updateList();
        })
    }


    //鼠标多选，点击
    const onMouseDown = (event:any)=>{
        if (props.from != FROM_HOME_LIBRARY)return;//仅首页的允许多选
        if (event.button == 2)return;//右键不多选
        // 鼠标按下时才允许处理鼠标的移动事件
        select = true;
        mMouseDownTime = new Date().getTime();

        if (rect) {
            document.getElementById('divCardItemContainer').removeChild(rect);
        }

        rect = document.createElement("div");
        // 框选div 样式
        rect.style.cssText = "position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;z-index:1000;filter:alpha(opacity:60);opacity:0.6;display:none;";
        rect.id = "selectDiv";
        // 添加到lay1下
        document.getElementById('divCardItemContainer').appendChild(rect);

        const boundRect = event.currentTarget.getBoundingClientRect();
        const divItemContainer = document.getElementById('divCardItemContainer');
        let nScrollY = divItemContainer?.scrollTop;
        // 取得鼠标按下时的坐标位置
        downX = event.clientX - boundRect.left;
        downY = event.clientY - boundRect.top + nScrollY;
        rect.style.left = downX + "px";
        rect.style.top = downY + "px";
    }

    const onMouseUp = (event)=>{
        // var lis =document.getElementsByClassName('carditem');
        // var arrayNewList = [...arrayCardList];
        //
        // for (let i = 0; i < lis.length; i++) {
        //     //将移动的div的四个点和和div元素的四个点进行比较
        //     const arrayFilters = arrayNewList.filter(p=>p.id == lis[i].dataset.id);
        //     let item = null;
        //     if (arrayFilters.length > 0){
        //         item = arrayFilters[0];
        //     }
        //     if (
        //         //判断div元素 右边框的位置大于移动div的左起始点
        //         rect.offsetLeft < (lis[i].offsetLeft + lis[i].offsetWidth ) &&
        //         //判断div元素 下边框的位置大于移动div的上起始点
        //         (lis[i].offsetTop + lis[i].offsetHeight) >rect.offsetTop
        //         &&
        //         // 判断div元素左边框的位置小于移动div的右起始点
        //         rect.offsetLeft + rect.offsetWidth > lis[i].offsetLeft&&
        //         // 判断div元素上边框的位置小于移动div的下起始点
        //         rect.offsetTop + rect.offsetHeight > lis[i].offsetTop
        //     ) {
        //         //将已选中的样式改变
        //         // if (lis[i].className.indexOf("seled") == -1) {
        //         //     lis[i].className = lis[i].className + " seled";
        //         // }
        //         item.isChecked = true;
        //     } else {
        //         //如果没有选中则清除样式
        //         // if (lis[i].className.indexOf("seled") != -1) {
        //         //     lis[i].className = "listItem";
        //         // }
        //         item.isChecked = false;
        //     }
        // }

        //鼠标抬起,就不允许在处理鼠标移动事件
        select = false;
        //隐藏图层
        if (rect) {
            try{
                document.getElementById('divCardItemContainer').removeChild(rect);
            }catch (e){

            }

            rect = null;
        }
    }

    const onMouseMove = (event:any)=>{
        //如果有打开的对话框，这个不要处理了。。。。
        if(window.getDialogCardsCount() > 0)return;
        /*
                        这个部分,根据你鼠标按下的位置,和你拉框时鼠标松开的位置关系,可以把区域分为四个部分,根据四个部分的不同,
                        我们可以分别来画框,否则的话,就只能向一个方向画框,也就是点的右下方画框.

                        */
        const boundRect = event.currentTarget.getBoundingClientRect();
        const divItemContainer = document.getElementById('divCardItemContainer');
        let nScrollY = divItemContainer?.scrollTop;
        // 取得鼠标移动时的坐标位置
        mouseX2 = event.clientX - boundRect.left;
        mouseY2 = event.clientY - boundRect.top + nScrollY;


        const time = new Date().getTime();

        if (Math.abs(mouseX2 - downX) < 8 && Math.abs(mouseY2 - downY) < 8 && (time - mMouseDownTime) < 500){
            // select = false;
            return;
        }

        if(select)
        {

            //自动滚动
            // console.log('scrollY:'+nScrollY);
            // console.log('clientY:'+event.clientY);
            // console.log('pageY:'+event.pageY);
            // console.log('screenY:'+event.screenY);
            // console.log('height:'+divItemContainer.clientHeight);
            // console.log('**********:**********:');

            // 显示框选元素
            if (rect.style.display == "none") {
                rect.style.display = "";
            }
            rect.style.left =Math.min(mouseX2, downX) + "px";

            rect.style.top = Math.min(mouseY2, downY) + "px";

            rect.style.width = Math.abs(mouseX2 - downX) + "px";

            rect.style.height = Math.abs(mouseY2 - downY) + "px";
            // A part
            if( mouseX2 < downX && mouseY2 < downY ){
                rect.style.left = mouseX2;
                rect.style.top = mouseY2 ;
            }

            // B part
            if( mouseX2 > downX && mouseY2 < downY){
                rect.style.left = downX ;
                rect.style.top = mouseY2;
            }

            // C part
            if( mouseX2 < downX && mouseY2 > downY){
                rect.style.left = mouseX2;
                rect.style.top = downY ;
            }

            // D part
            if( mouseX2 > downX && mouseY2 > downY ){
                rect.style.left = downX ;
                rect.style.top = downY;
            }


            //待选中的列表....
            var lis = document.querySelectorAll('[role="gridcell"]')//document.getElementsByClassName('carditem');
            var arrayNewList = [...arrayCardList];
            let nCheckedCount = 0;

            for (let i = 0; i < lis.length; i++) {
                //将移动的div的四个点和和div元素的四个点进行比较
                const cardItem = lis[i].firstChild;
                if (!cardItem)continue;
                const arrayFilters = arrayNewList.filter(p=>p.id == cardItem.dataset.id);
                let item:any = null;
                if (arrayFilters.length > 0){
                    item = arrayFilters[0];
                }
                if (!item || props.from != FROM_HOME_LIBRARY)continue;

                let nItemOffsetTop = lis[i].offsetTop;
                let nRectOffsetTop = rect.offsetTop //+ nScrollY;
                if (
                    //判断div元素 右边框的位置大于移动div的左起始点
                    rect.offsetLeft < (lis[i].offsetLeft + lis[i].offsetWidth ) &&
                    //判断div元素 下边框的位置大于移动div的上起始点
                    (nItemOffsetTop + lis[i].offsetHeight) >nRectOffsetTop
                    &&
                    // 判断div元素左边框的位置小于移动div的右起始点
                    rect.offsetLeft + rect.offsetWidth > lis[i].offsetLeft&&
                    // 判断div元素上边框的位置小于移动div的下起始点
                    nRectOffsetTop + rect.offsetHeight > nItemOffsetTop
                ) {
                    //将已选中的样式改变
                    item.isChecked = true;
                    nCheckedCount ++;
                    // mLastSelectedIds.current[item.id] = true;
                } else {
                    //如果没有选中则清除样式
                    // item.isChecked = false;
                }
            }

            if (props.from == FROM_HOME_LIBRARY){
                if (nCheckedCount > 0){
                    if (!isShowChecked){
                        setIsShowChecked(true);
                    }

                    let szSelectedTitle = t("Items selected").replace('{0}',arrayNewList.filter(p=>p.isChecked).length+'');
                    setShowCheckedTitle(szSelectedTitle)
                }
                setArrayCardList(arrayNewList);
            }
        }

        // 阻止事件上传
        // window.event.cancelBubble = true;
        // // 阻止默认事件
        // window.event.returnValue = false;
    }

    /**
     * 侧栏打开PDF
     * @param item
     */
    const openPdfInSidebar = (item:any,isFullscreen:any)=>{
        let szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
        if (checkIfAbsolute(item.fileName)){
            szFilePath = item.fileName;
        }
        ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=> {
            const blob = new Blob([res]);
            const url = URL.createObjectURL(blob);
            if (isGlobalRightSlider()){
                window.openRightSlider(item,item.type);
            }else{
                postMessage(EVENT_PDF_ON_SLIDER_RIGHT,{pdfPath:url,fileId:item.id,fileName:item.name,pdfFileName:item.name,isFullscreen:isFullscreen, breadcrumb:createBreadcrumb("library", item.name)});
            }
        })
    }

    const cellRenderer = ({columnIndex, key, rowIndex, style})=>{
        const item = arrayCardList[rowIndex*mColumnCount.current+columnIndex];
        return <div key={key} style={{...style,}}>
            {
                item?<CardItem key={key} data={item} searchKey={searchKey}
                               itemWidth={cardItemSize.width}
                               itemHeight={cardItemSize.height}
                               withPropertyHeight = {getRowHeight(rowIndex)}
                               isTrash={false} from={props.from}
                               subFrom={props.subFromPage}
                               isShowChecked={isShowChecked}
                               margin={'8px'}
                               onCheckedCallback={(item:any)=>{
                                   const nSelectCount = getSelectedArray().length;
                                   let szSelectedTitle = t("Items selected").replace('{0}',nSelectCount+'');
                                   setShowCheckedTitle(szSelectedTitle)
                               }} onActionCallback={async (szAction:string,item:any)=>{
                    onCardItemCallback(szAction,item);
                }} onMouseUpCallback={(event:any)=>{
                    select = false;
                }} onGetCheckedData={()=>{
                    return arrayCardList.filter(p=>p.isChecked);
                }} onRefreshList={()=>{
                    mPageNum.current = 0;
                    updateList();
                }}/>:<></>
            }

        </div>
    }

    const getRowCount = ()=>{
        let nRowCount = arrayCardList.length / mColumnCount.current;
        nRowCount = Math.ceil(nRowCount);
        return nRowCount;
    }


    const getRowHeight = (rowIndex)=>{
        let nHeight = cardItemSize.height;
        const arrayThisRowData:any = arrayCardList.slice(rowIndex*mColumnCount.current,rowIndex*mColumnCount.current+mColumnCount.current);
        let nTitleHeight = 0;
        for (let i=0;i<arrayThisRowData.length;i++){
            const data = arrayThisRowData[i];
            let nWidth = cardItemSize.width - 38 - 17;
            if (props.from == FROM_LIBRARY){
                nWidth = cardItemSize.width - 54;
            }
            if (data.type == 'videoAnno' || data.type == 'audioAnno'){
                nWidth -= 48;//时间的宽度
            }
            let szName = data.name;
            if (data.type == 'journal'){
                nWidth -= 60;//星期的宽度
                szName = getJournalName(data.journalTime)
            }else if (data.type == 'card'){
                szName = getCardTitle(data);
            }
            const nH = measureTitleHeight(szName,nWidth);
            if (nH > nTitleHeight){
                nTitleHeight = nH;
            }
        }
        nHeight += nTitleHeight;

        nHeight += 20;
        return nHeight;
    }

    const renderCardList1 = ()=>{
        const div = divGridContainerRef.current;//document.getElementById('div-grid-container-'+mThisID.current);
        let nWidth = div?.clientWidth || 0;
        let nHeight = div?.clientHeight;//document.body.clientHeight - 46 - 32 - 20;
        // if (props.from == FROM_LIBRARY){
        //     nHeight -= 12;
        // }
        if (nWidth == 0){
            if (props.from == FROM_LIBRARY){
                nWidth = rightSliderWidth;
            }
        }
        if (cardItemSize.width == 0 || cardItemSize.height == 0)return <></>
        return arrayCardList.length == 0?<></>:<Grid
            ref={gridRef}
            id={props.from == FROM_HOME_LIBRARY ? 'divCardItemContainer' : 'divCardItemContainer-from-other'}
            style={{padding:'0 12px',position:'relative',outline:'none'}}
            cellRenderer={cellRenderer}
            columnCount={mColumnCount.current}
            rowCount={getRowCount()}
            rowHeight={({index})=>getRowHeight(index) + 16}
            columnWidth={cardItemSize.width + 16}
            height={nHeight}
            width={nWidth - (props.from == FROM_LIBRARY?1:0)}
            onScroll={({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth })=>{
                if (searchKey)return;//带搜索的不分页.
                if (mPageNum.current == -1)return;
                const isBottom = Math.floor(scrollTop + clientHeight) >= Math.floor(scrollHeight);
                // console.log(he);
                if (isBottom && scrollTop > 0) {
                    if (!mIsLoadingMore.current){
                        mIsLoadingMore.current = (true)

                    }
                    console.log('inbottom.....')

                    mPageNum.current++;
                    //不是全部的项目了，不分页....
                    if (!isAllProject()) {
                        mPageNum.current = -1;
                    }

                    console.log('pageNum:'+mPageNum.current);

                    if (mPageNum.current != -1){
                        updateList()?.then(res=>{
                            mIsLoadingMore.current = (false);
                        })
                    }
                }
            }}
        >

        </Grid>
    }

    /**
     * 条目点击回调
     * @param szAction
     * @param item
     */
    const onCardItemCallback = async (szAction:string,item:any)=>{
        if (props.subFromPage == FROM_DIALOG){
            if (props.onItemSelectedCallback){
                props.onItemSelectedCallback(item);
                return;
            }
        }
        if (szAction == 'delete') {
            let szMsg = t("ConfirmDeleteLibraryItem");
            if (item.type == 'card'){
                szMsg = t("SureToDeleteTheCard")
            }
            dialogMessageRef.current?.onShowDialog(t("Tips"),szMsg,t("Delete"),()=>{
                item.isDeleted = 1;
                item.deleteTime = Date.now();
                updateCard(item).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                    postMessage(EVENT_REFRESH_RECENTS);
                    postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:item.id});
                    window.globalRefreshList();
                });
                //也删除highlight中的..
                dbGetHighlight(item.id).then(res=>{
                    if (res){
                        res.isDeleted = 1;
                        res.deleteTime = item.deleteTime;
                        updateHighlight(res);
                    }
                })

                //删除这个card所关联的项目
                deleteAllCardFromRefProject(item);

                //如果是视频注记，高亮删除也要更新
                if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                    dbGetHighlight(item.libraryId || item.id).then(r=>{
                        if (r){
                            //删除这个注记
                            const nIndex = r.data.findIndex(p=>p.id == item.id);
                            if (nIndex != -1){
                                r.data.splice(nIndex,1);
                                updateHighlight(r);
                            }
                        }
                    })
                }

                //pdf注记删除，高亮删除也更新.
                if (item.type == 'pdfAnno'){
                    ipcInvoke('remove-one-annotations',{id:item.id,pdfId:item.libraryId})
                }else if (item.type == 'cardAnno'){
                    window.removeCardHighlight(item,()=>{
                        postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    });
                }

                const nIndex = arrayCardList.indexOf(item);
                var arrayNewCards = [...arrayCardList];
                arrayNewCards.splice(nIndex,1);

                setArrayCardList(arrayNewCards);
                //刷新数量
                const nNewCount = libraryCount - 1;
                setLibraryCount(nNewCount);
            })
        }else if (szAction == 'rename'){
            dialogCommonInputRef.current?.onShowDialogAll(getCardTitle(item),t("Rename"),t("Cancel"),t("Save"),(szContent:string)=>{
                dialogCommonInputRef.current?.onCloseDialog();

                item.name = szContent;
                renameCard(item).then(res=>{
                    //不知道啥排序，直接刷新列表。。
                    mPageNum.current = 0;
                    updateList();
                    postMessage(EVENT_RENAME_LIBRARY_ITEM,{...item})
                });
            });
        }else if (szAction == 'exportCardPdf'){
            //card to pdf
            const szHtmlDoc:any = await getCardDoc(item.id);
            editDoc(item.id,szHtmlDoc,item.name).then(res=>{
                setTimeout(() => {
                    ipcSend('save-pdf-to-system', item.id, item.name)
                }, 10);
            })
        }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
            //导出文件
            const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
            ipcSend('saveFile', {
                filters: [{name: "All file", extensions: ['*']}],
                filePath: szFilePath,
                fileName: item.name+'.'+getFileNameExt(item.fileName)
            })
        }else if (szAction == 'managerTags'){
            //管理标签
            dialogTagManagerRef.current?.onShowDialog([item]);
        }else if (szAction == 'addToProject'){
            //添加到project.
            window.showDialogChooseProject([item]);
        }else if (szAction == 'makeACopy'){
            const szHtml = await getCardDoc(item.id);
            const newItem = {
                ...item,
                id:generateUUID2(),
                name:item.name+"("+t("Copy")+")",
                doc:szHtml
            }
            updateCard(newItem).then(res=>{
                mPageNum.current = 0;
                // updateList();
                message.info(t("Duplicated"));
                window.globalRefreshList('refresh_single_library_item_',newItem.id);
            });
        }else if (szAction == 'viewAllHighlights'){
            window.showPdfPreview(item.name,item.id,item.fileName,true,true)
        }else if (szAction == 'addToProjectChecked'){
            addToProjectEvent();
        }else if (szAction == 'managerTagsChecked'){
            managerTagsEvent();
        }else if (szAction == 'deleteChecked'){
            deleteSelectedEvent();
        }else if (szAction == 'favor'){
            if (item.isFavirated){
                item.isFavirated = 0;
            }else{
                item.isFavirated = 1;
            }
            item.favirateTime = Date.now();
            item.sort = 0;
            updateCard(item,false).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                // updateList();//刷新列表...
                // const arrayFavors = [...arrayCardList];
                // setArrayCardList(arrayFavors);
                if (item.isFavirated == 0){
                    //取消收藏了。
                    onRemoveItemInFavorTab(item.id);
                }
            });
        }else if (szAction == 'showInfo'){
            window.showInfo('library',item);
        }else if (szAction == 'versionHistory'){
            window.showDialogCardHistory(item.id);
        }
        else if (szAction == 'copyLink'){
            createCopyLinkByLibraryItem(item);
        }else if (szAction == 'select'){
            //选择这一个...
            if (item.type == 'add' && props.type == 'image'){
                //添加图片
                setIsShowDialogChooseImage(true);
                setTimeout(()=>{
                    dialogChooseImageRef.current?.onShowDialog();
                },150);
            }else if (item.type == 'add' && props.type == 'video'){
                setAcceptExt('.mp4,.mov');
                setTimeout(()=>{
                    fileSelectRef.current?.click();
                },100)
            }else if (item.type == 'add' && props.type == 'file'){
                setAcceptExt('*');
                setTimeout(()=>{
                    fileSelectRef.current?.click();
                },100)
            }
            else{
                if (props.onItemSelectedCallback){
                    if (item.type == 'card'){
                        item.doc = await getCardDoc(item.id);
                    }
                    props.onItemSelectedCallback(item);
                }
            }
        }else if (szAction == 'exportMarkdown'){
            onExportSingleMd(item);
        }else if (szAction == 'shareCard'){
            window.showDialogPublishCardToWeb(item.id,(szId,dialogPublishToWebRef)=>{
                if (szId == 'exportPdf') {
                    onCardItemCallback('exportCardPdf',item);
                }else if (szId == 'exportMarkdown'){
                    onCardItemCallback('exportMarkdown',item)
                }
                else {
                    shareCardData(item,null,dialogPublishToWebRef);
                }
            })
        }
        else if (szAction == 'add'){
            onAddNewItem(item);
        }else if (szAction == 'edit'){
            const doc = await getCardDoc(item.id);
            Global.g_currentNoteData = {...item, doc};
            openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
        }else if (szAction == 'showInSystemExporler'){
            ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
        }else if (szAction == 'locateHighlight'){
            if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                const highlight = await dbGetHighlightByLibraryId(item.libraryId);
                if (highlight) {
                    window.showVideoNotes(highlight,item.id)
                }
            }else if (item.type == 'pdfAnno'){
                const library = await getCardById(item.libraryId);
                if (library) {
                    window.showPdfPreview(library.name,library.id,library.fileName,false,true,true,{highlightId:item.id});
                }else {
                    message.error(t("Open error"))
                }
            }else if (item.type == 'cardAnno'){
                openEditor(item.libraryId,true,false,'','card',item.id);
            }

        }else if (szAction == 'changeSource'){
            changeSourceEvent(item);
        }else if (szAction == 'openInPopup'){
            if (item.type == 'video' || item.type == 'audio' || item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu'){
                let highlight:any = await dbGetHighlight(item.id);
                if (!highlight){
                    highlight = {...item};
                }
                window.showVideoNotes(highlight,null);
            }else if (item.type == 'pdf'){
                window.showPdfPreview(item.name,item.id,item.fileName,false);
            }else if (item.type == 'card'){
                const doc = await getCardDoc(item.id);
                item.doc = doc;
                window.showDialogCard(item);
            }
        }else if (szAction == 'openInFullscreen'){
            if (item.type == 'video' || item.type == 'audio' || item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu'){
                let highlight:any = await dbGetHighlight(item.id);
                if (!highlight){
                    highlight = {...item};
                }
                window.showVideoNotes(highlight,null,'fullScreen');
            }else if (item.type == 'pdf'){
                window.showPdfPreview(item.name,item.id,item.fileName,true);
            }else if (item.type == 'card'){
                window.navigate(getCardPath(),{cardId:item.id});
            }
        }else if (szAction == "importHighlights"){
            //导入--笔记
            window.showDialogImportHighlight(async (file,content)=>{
                let highlight:any = await dbGetHighlight(item.id);
                if (!highlight){
                    highlight = {...item,data:[]};
                }
                onImportHighlights(file,content,highlight);
            });
        }else if (szAction == "exportHighlights"){
            //导出注记
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item,data:[]};
            }
            saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(highlight));
        }else if (szAction == "copyToClipboard"){
            //导出注记
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item,data:[]};
            }
            const text = getCurrentElementVideoNotes(highlight);
            await navigator.clipboard.writeText(text);
            message.info(t('Notes copied to clipboard'))
        }else if (szAction == 'copyOriginLink'){
            clipboard.write(item.fileName);
            message.info(t("Link copied to clipboard"));
        }else if (szAction == 'openLink'){
            ipcSend('open-url',item.fileName);
        }else if (szAction == 'copyHighlightText'){
            const library = await getCardById(item.id);
            let szNote = '';
            if (library.comment){
                szNote = '\n' + t("Note")+":"+library.comment
            }
            copyTextToSystemClipboard(library.text + szNote);
        }
    }

    /**
     * 渲染列表
     */
    const renderCardList = () => {
        // if (arrayCardList.length == 0) {
        //     return <Empty className='empty'/>
        // }

        return <div ref={divPageLibraryContainerRef} id={props.from == FROM_HOME_LIBRARY ? 'divCardItemContainer' : 'divCardItemContainer-from-other'}
                    style={{
                        display: "grid", flexWrap: 'wrap', overflowX: 'hidden', overflowY: 'auto',
                        gridTemplateColumns: gridColumns,
            gap:props.from == FROM_ADD?'12px 32px':'12px',
            flexDirection: "row",padding:'0 20px'}} onScroll={(e)=>{
                if (searchKey)return;//带搜索的不分页.
                let he = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - e.currentTarget.scrollTop
                // console.log(he);
                if (he > -20 && he < 20) {
                    if (!mIsLoadingMore.current){
                        mIsLoadingMore.current = (true)
                        mPageNum.current++;
                        //不是全部的项目了，不分页....
                        if (!isAllProject()) {
                            mPageNum.current = -1;
                        }

                        console.log('pageNum:'+mPageNum.current)
                        updateList()?.then(res=>{
                            mIsLoadingMore.current = (false);
                        })
                    }
                }
                // calculateVisibleRange();
        }}>
            {
                arrayCardList.map((item, i) =>
                        <CardItem key={i} data={item} searchKey={searchKey} itemWidth={cardItemSize.width} itemHeight={props.from == FROM_LIBRARY?(cardItemSize.width*0.77):cardItemSize.width*0.77} isTrash={false} from={props.from} subFrom={props.subFromPage} isShowChecked={isShowChecked} onCheckedCallback={(item:any)=>{
                            const nSelectCount = getSelectedArray().length;
                            let szSelectedTitle = t("Items selected").replace('{0}',nSelectCount+'');
                            setShowCheckedTitle(szSelectedTitle)
                        }} onActionCallback={async (szAction:string,item:any)=>{
                            onCardItemCallback(szAction,item)
                        }} onMouseUpCallback={(event:any)=>{
                            select = false;
                        }} onGetCheckedData={()=>{
                            return arrayCardList.filter(p=>p.isChecked);
                        }} onRefreshList={()=>{
                            mPageNum.current = 0;
                            updateList();
                        }}/>
                )
            }
        </div>
    }

    /**
     * 忽略类型选择的保存..
     */
    const isIngoreSelectSave = ()=>{
        if (props.source == 'dialogLink'){
            return true;
        }
        return false;
    }

    /**
     * 取消选择
     */
    const onCancelCheck = ()=>{
        setIsShowChecked(false);
        var arrayNewCards = [...arrayCardList];
        arrayNewCards.forEach(p=>{
            p.isChecked = false;
        })
        setArrayCardList(arrayNewCards);
    }

    //导出配置.
    let importConfig = {};
    if (!isWeb()){
        importConfig = window.IPC.getConvertToken();
    }
    const editor = useEditor({
        autofocus:false,
        injectCSS: true,
        extensions: [
            ...getTiptapExtension(null,'')
        ],
        editorProps: {
            attributes: {
                // class: '',
            },
        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    const exportMarkdown = async ()=>{
        const arraySelectCards = getSelectedArray();
        if (arraySelectCards.length == 0){
            message.info(t("Please select"));
            return;
        }

        // window.showProgress(t("Exporting"));

        const arrayBuffers:any = [];
        let zip = new JSZip();

        await recursionNext(0,arraySelectCards,arrayBuffers,zip);
        window.closeProgress();

        // for (let i=0;i<arrayBuffers.length;i++){
        //     const item = arrayBuffers[i];
        //     zip.file(item.name + Date.now() +'.md',item.bufs,{});
        // }
        zip.generateAsync({type:"blob"}).then(function (content){
            saveAs(content,getCardTitle(arraySelectCards[0]) +'.zip');
            message.info(t('Markdown exported successfully'))
        });

        // ipcSend('save-markdown-to-system', arrayBuffer, item.name)
    }

    const recursionNext = async (nIndex:number,arrayCards:any,arrayBufs:any,zip)=>{
        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            const doc:any = await getCardDoc(item.id);
            item.doc = doc;
            const szName = getCardTitle(item);
            const hasEqual = arrayCards.some(p=>p.id != item.id && getCardTitle(p) == szName);
            await onExportMd(item,arrayBufs,zip,hasEqual);
        }
    }

    const onExportMd = (item:any,arrayBufs:any,zip:any,hasEqual:any)=>{
        return new Promise(async (resolve, reject) => {
            editor?.commands.setContent(item.doc);

            /*
            editor?.chain().export({
                format: 'md',
                onExport(context) {
                    const { blob, error } = context
                    if(error){
                        noteServer.openTip("error", t("ExportMarkdownFail"));
                    }
                    blob?.arrayBuffer().then(async (bufs) => {
                        arrayBufs.push({
                            name:item.name,
                            bufs:bufs
                        });

                        resolve('');
                    });
                },
            })*/

            // 使用自定义的序列化器将 ProseMirror 文档转换为 Markdown
            const { markdown:md, images } = serializeProseMirrorToMarkdown(editor?.state.doc);
            let markdown = md;

            let dtNow = '';
            //如果是否有重名的名称...
            if (hasEqual){
                dtNow = '-'+Date.now();
            }
            if (images && images.length > 0){
                const assetFolderName = `${getCardTitle(item)}${dtNow}-assets`;
                const assetFolder = zip.folder(assetFolderName);

                // 下载并添加所有图片
                for (const img of images) {
                    markdown = markdown.replace(
                        `asset/${img.filename}`,
                        `${assetFolderName}/${img.filename}`
                    );
                    try {
                        const blob = await downloadImageAsBlob(img.src);
                        if (blob && assetFolder) {
                            assetFolder.file(img.filename, blob);
                        }
                    } catch (error) {
                        console.error(`Failed to download image: ${img.src}`, error);
                    }
                }

                const encoder = new TextEncoder();
                const arrayBuffer = encoder.encode(markdown).buffer;
                // arrayBufs.push({
                //     name:item.name,
                //     bufs:arrayBuffer
                // });

                zip.file(getCardTitle(item) + dtNow +'.md',arrayBuffer,{});

            }else{
                // 如果没有图片,直接导出 markdown 文件
                const encoder = new TextEncoder();
                const arrayBuffer = encoder.encode(markdown).buffer;
                // arrayBufs.push({
                //     name:item.name,
                //     bufs:arrayBuffer
                // });
                zip.file(getCardTitle(item) + dtNow +'.md',arrayBuffer,{});
            }

            resolve('');
        })
    }

    /**
     * 导出单个md
     * @param item
     */
    const onExportSingleMd = async (item:any)=>{
        // window.showProgress(t("Exporting"))
        if (!item.doc){
            item.doc = await getCardDoc(item.id);
        }
        window.exportMarkdown(item);

        // editor?.commands.setContent(item.doc);
        // editor?.chain().export({
        //     format: 'md',
        //     onExport(context) {
        //         const { blob, error } = context
        //         if(error){
        //             noteServer.openTip("error", t("ExportMarkdownFail"));
        //             return;
        //         }
        //         blob.arrayBuffer().then(arrayBuffer => {
        //             window.closeProgress();
        //
        //             ipcSend('save-markdown-to-system', arrayBuffer, item.name)
        //         });
        //     },
        // })
    }

    /**
     * 退出显示隐藏卡片模式
     */
    const exitShowHiddenCard = ()=>{
        let isShow = localStorage.getItem(KEY_SHOW_HIDIN_CARDS);
        if (isShow == 'true'){
            isShow = 'false';
        }else{
            isShow = 'true';
        }
        //显示卡片隐藏卡片 所有卡片 显示隐藏
        if (isShow){
            setIsShowHiddenCard(false);
            localStorage.setItem(KEY_SHOW_HIDIN_CARDS,false);
            setLibraryMoreMenu(getLibraryMoreMenu());
        }


        // if (isShow == 'true'){
        //     //只选中卡片？
        //     const pp = arrayLibraryTypes.find(ppp=>ppp.value == 'card');
        //     onCheckOneItem(pp);
        // }
        // //刷新列表
        // mPageNum = 0;
        // updateList();
    }

    /**
     * 读取空白的提示
     */
    const getEmptyTips = ()=>{
        let szTips = t("LibraryIsEmptyTips");
        if (activeTabItem?.id == 'favorites'){
            szTips = t('NoFavorYet')
        }else if (activeTabItem?.id == 'published'){
            szTips = t('NoPublishedCards');
        }
        return szTips;
    }

    /**
     * 渲染标题行
     */
    const renderTitleRow = ()=>{
        return <div style={{width:'100%'}}>
            <div className={'div-header-1 flex-row-vertical-center'} style={{height:'32px'}}>
                {/*标题名称*/}
                {
                    !isShowChecked &&
                    <div className={'flex-row-vertical-center'}>
                    <span className='header-title font-family-semi-bold'
                          style={{marginBottom: '1px'}}>{(isShowHiddenCard ? t('Hidden cards') : t("Library")) + ((libraryCount > 0 && false) ? `(${libraryCount})` : '')}</span>
                        {
                            libraryCount > 0 &&
                            <span style={{
                                marginLeft: '6px',
                                background: 'var(--project-count-backround-color)',
                                border: '0px solid var(--project-count-border-color)',
                                borderRadius: '20px',
                                padding: '1.2px 10px',
                                fontSize: '13px',
                                color: 'var(--project-count-text-color)'
                            }}>{libraryCount}</span>
                        }

                        {
                            isShowHiddenCard &&
                            <span className={'cursor-pointer button-border-gray-style flex-center ml-16 cancel-0'}
                                  style={{height: '32px', padding: '0 16px', minWidth: '76px', marginLeft: '22px',color:'var(--text-dark-gray-color)'}}
                                  onClick={() => {
                                      //取消隐藏卡片
                                      showOrHiddenCards();
                                  }}>{t("Cancel")}</span>
                        }
                    </div>
                }


                {
                    isShowChecked &&
                    <>
                    <span className='header-title font-family-semi-bold'
                          style={{marginBottom: '1px'}}>{showCheckedTitle}</span>
                        {/*<div style={{height:'16px',width:'1px',background:'var(--line-color)',margin:'0 16px'}}></div>*/}
                        <span className={'cursor-pointer button-border-gray-style flex-center ml-16 cancel-1'}
                              style={{height: '32px', marginLeft: '22px', padding: BUTTON_PADDING,color:'var(--text-dark-gray-color)'}} onClick={() => {
                            onCancelCheck();
                            mMapIdCheck = {};
                        }}>{t("Cancel")}</span>

                        <div style={{flexGrow: '1'}}></div>

                        <div className={'flex-row-vertical-center'}>

                            <Select style={{}}
                                    className={'select-padding-right'}
                                    dropdownStyle={{minWidth: '168px'}}
                                    dropdownClassName={'shadow'}
                                    value={exportValue} options={ARRAY_CARD_EXPORT}
                                    onChange={async (value, option) => {
                                        if (option.value == 'exportPdf') {
                                            const arraySelect = getSelectedArray();
                                            if (arraySelect.length == 0) {
                                                message.info(t("Please select"));
                                                return;
                                            }
                                            //
                                            const isOk = await ipcInvoke('save-pdf-zip-to-system', JSON.stringify(arraySelect));
                                            if (isOk) {
                                                window.showProgress('Exporting');
                                            }
                                        } else if (option.value == 'exportMarkdown') {
                                            exportMarkdown();
                                        }
                                    }}
                                    suffixIcon={<IconDropdownSelected/>}/>
                            {/*add to project*/}
                            <div style={{height: '32px', marginLeft: '16px', padding: BUTTON_PADDING,color:'var(--text-dark-gray-color)'}} onClick={() => {
                                addToProjectEvent();
                            }}
                                 className={'button-border-gray-style flex-center font-family-regular'}>{t("Add to project")}</div>

                            {/*manage tags*/}
                            <div style={{marginLeft: '16px', height: '32px', padding: BUTTON_PADDING,color:'var(--text-dark-gray-color)'}} onClick={() => {
                                managerTagsEvent();
                            }}
                                 className={'button-border-gray-style flex-center  font-family-regular'}>{t("Manage tags")}</div>

                            {
                                //change source
                                arrayCardList.some(p => p.isChecked && (p.type == 'pdf' || p.type == 'pdfAnno' || p.type == 'video' || p.type == 'videoAnno')) &&
                                <div style={{marginLeft: '16px', height: '32px', padding: BUTTON_PADDING}} onClick={() => {
                                    changeSourceEvent(null);
                                }}
                                     className={'button-border-gray-style flex-center  font-family-regular'}>{t("Change source")}</div>
                            }

                            {/*remove*/}
                            {
                                // !arrayCardList.some(p=>p.isChecked && p.type == 'journal') &&
                                <div style={{
                                    marginLeft: '16px', height: '32px', padding: BUTTON_PADDING,
                                    background: 'transparent',
                                    color: arrayCardList.some(p => p.isChecked && p.type == 'journal') ? 'var(--disable-text-color)' : '#DC463F',
                                    border: arrayCardList.some(p => p.isChecked && p.type == 'journal') ? '1px solid var(--button-no-fill-border-color)' : '1px solid #DC463F'
                                }} onClick={() => {
                                    if (arrayCardList.some(p => p.isChecked && p.type == 'journal')) {
                                        message.error(t("CannotBeDeleteBecauseJournal"));
                                        return;
                                    }
                                    deleteSelectedEvent();
                                }}
                                     className={'button-border-danger-style flex-center'}>{t("Delete")}</div>
                            }

                        </div>
                    </>
                }
            </div>
            <div className={'div-header-2 flex-row-vertical-center '} style={{width:'100%',marginTop:'14px'}}>
                <>
                    <LibraryTab ref={mLibraryTabRef} onActiveItem={(activeItem) => {
                        setActiveTabItem(activeItem);
                        mActiveTabItemRef.current = activeItem;
                    }} onSwitchItem={(switchItem)=>{
                        setActiveTabItem(switchItem);
                        mActiveTabItemRef.current = switchItem;
                        //重置条件
                        if (switchItem.id == 'favorites'){
                            resetFilterExcludeLibraryType();
                        }else if (switchItem.id == 'published'){
                            resetFilter();
                            setIsClearFilterVisible(true);
                            //只选择card
                            const arrayNewTypes = [...arrayLibraryTypes];
                            arrayNewTypes.forEach(p => {
                                p.isChecked = (p.value == 'card');
                            })
                            setArrayLibraryTypes(arrayNewTypes);

                            //switch type选中all
                            const arrayTypeSwitchNew = [...arrayTypeSwitcher];
                            arrayTypeSwitchNew.forEach(p => {
                                p.isSelected = (p.value == 'card')
                            })
                            setArrayTypeSwitcher(arrayTypeSwitchNew);
                        }else if (switchItem.id == 'all'){

                        }
                        refreshClearFilterVisible();
                        updateList();
                    }} isShowChecked={isShowChecked}/>

                    <div style={{flexGrow: '1'}}></div>

                    <div className={style.right}>
                        <div className={'flex-row-vertical-center'}
                             style={{
                                 border: '0px solid var(--border-color)',
                                 borderRadius: '8px',
                                 height: '32px',
                                 gap: '6px',
                                 background: 'var(--library-switcher-type-container-backgroundcolor)'
                             }}>
                            {
                                //type switcher
                                arrayTypeSwitcher.map(p => {
                                    return (
                                        //p.isSelected?style.switchItemSelect:''
                                        <div className={''} style={{
                                            cursor: 'pointer',
                                            margin: '0 0px',
                                            padding: '0 10px',
                                            height: '100%',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            position: 'relative',
                                        }} onClick={(e) => {
                                            if (isShowChecked){
                                                message.info(t('PleaseExitSelectStatus'));
                                                return;
                                            }
                                            const arrayNew = [...arrayTypeSwitcher];
                                            arrayNew.forEach(pppppp => {
                                                pppppp.isSelected = false;
                                            })
                                            p.isSelected = true;
                                            //如果是hidden模式则退出
                                            exitShowHiddenCard();
                                            //save
                                            localStorage.setItem(KEY_TYPE_SWITCHER, JSON.stringify(arrayNew));
                                            setArrayTypeSwitcher(arrayNew);
                                            //这里选中select 中的单个类型。。。
                                            if (p.value == 'all') {
                                                onCheckedItemClicked({...p, value: CHECK_ALL}, true);
                                            } else {
                                                const pp = arrayLibraryTypes.find(ppp => ppp.value == p.value);
                                                onCheckOneItem(pp);
                                            }
                                        }}>
                                        <span className={'span-single-line flex-center'} style={{
                                            textAlign: 'center',
                                            color: p.isSelected ? 'var(--primary-color)' : 'var(--text-dark-gray-color)'
                                        }}>{p.label}</span>
                                            {
                                                p.isSelected &&
                                                <div style={{
                                                    height: '2px',
                                                    left: '50%',
                                                    transform: 'translate(-50%,-50%)',
                                                    bottom: '0',
                                                    background: 'var(--primary-color)',
                                                    position: 'absolute'
                                                }}>
                                                <span style={{
                                                    opacity: '0',
                                                    display: 'block',
                                                    height: '2px'
                                                }}>{p.label}</span>
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={'flex-center ml-12 hovered'} style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            border: '0px solid var(--border-color)',
                        }} onClick={() => {
                            if (isShowChecked){
                                message.info(t('PleaseExitSelectStatus'));
                                return;
                            }
                            window.showDialogTypeSwitcherSetting((arraySelected: any) => {
                                arraySelected.forEach(p => {
                                    p.isSelected = false;
                                })
                                let arrayCheckedTypes = arrayLibraryTypes.filter(p => p.isChecked);
                                if (arrayCheckedTypes.length == 1) {
                                    let cur = arraySelected.find(p => p.value == arrayCheckedTypes[0].value);
                                    if (cur) {
                                        cur.isSelected = true;
                                    }
                                }

                                //设置选择的...
                                arraySelected.splice(0, 0, {
                                    value: 'all',
                                    label: t("All"),
                                    isSelected: arrayCheckedTypes.length == arrayLibraryTypes.length
                                })
                                localStorage.setItem(KEY_TYPE_SWITCHER, JSON.stringify(arraySelected));
                                setArrayTypeSwitcher(arraySelected);
                            });
                        }}>
                            <img className={'img-16  cursor-pointer'}
                                 src={getImagePathWithTheme('type_switch_setting.svg')}/>
                        </div>

                        <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                                  menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                                  onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                            {/*<span className='hovered' onClick={(e) => e.preventDefault()}>*/}
                            {/*    <div className='flex-row-vertical-center' style={{height: '28px', padding: '0px 8px'}}>*/}
                            {/*        <span className='text-color'>{sortTypeDesc}</span>*/}
                            {/*        */}
                            {/*        <img className='img-mini-small ml-6' style={{width: '10px', height: '10px'}}*/}
                            {/*             src={getImagePathWithTheme("library_dropdown")}/>*/}
                            {/*    </div>*/}
                            {/*</span>*/}
                            <div className={'flex-center ml-12 hovered'} style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '8px',
                                border: '0px solid var(--border-color)',
                            }} onClick={(e)=>{
                                if (isShowChecked){
                                    message.info(t('PleaseExitSelectStatus'));
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                            }}>
                                <img className={'img-16  cursor-pointer'}
                                     src={getImagePathWithTheme('library_filter.svg')} onClick={(e)=>{
                                    if (isShowChecked){
                                        message.info(t('PleaseExitSelectStatus'));
                                        e.stopPropagation();
                                    }
                                }}/>
                            </div>

                        </Dropdown>
                        {/*<Button type={"text"} className="small-button hovered" style={{marginLeft: '16px'}}*/}
                        {/*        onClick={() => btnViewStyleClicked(VIEW_STYLE.VIEW_STYLE_GRID)}>*/}
                        {/*    <img className="img-mini-small-18" src={getImagePathWithTheme('grid')}/>*/}
                        {/*</Button>*/}
                        {/*<Button type={"text"} className="small-button hovered" style={{marginLeft: '6px'}}*/}
                        {/*        onClick={() => btnViewStyleClicked(VIEW_STYLE.VIEW_STYLE_LIST)}>*/}
                        {/*    <img className="img-mini-small-18" src={getImagePathWithTheme('list')}/>*/}
                        {/*</Button>*/}
                    </div>
                </>
            </div>
        </div>
    }


    const getSelectProjectMarginLeft = ()=>{
        if (props.from == FROM_LIBRARY){
            return '0px';
        }else if (props.from == FROM_ADD){
            return '0px';
        }
        return '0px';
    }

    /**
     * 添加新的什么 什么
     */
    const onAddNewItem = (item)=>{
        if (item.createType == 'card' || getSelectedTypes().some(p=>p.value == 'card')) {
            if (props.from == FROM_LIBRARY){
                //侧栏新建卡片...
                const data = {id:generateRandomPageKey(),type:'card'}
                if (rightSliderWidth > 0){
                    //全局的右侧栏
                    window.openRightSlider(data,'card');
                }else{
                    postMessage(EVENT_NOTE_ON_SLIDER_RIGHT,{data:data,breadcrumb:createBreadcrumb("library", '')})
                }
            }else{
                Global.g_currentNoteData = {id: generateRandomPageKey()}
                openEditor(Global.g_currentNoteData.id, false, props.from == FROM_LIBRARY, FROM_HOME_LIBRARY);
            }

        } else if (selectType.value == 'image') {
            setIsShowDialogChooseImage(true);
            setTimeout(() => {
                dialogChooseImageRef.current?.onShowDialog();
            }, 150)
        } else {
            fileSelectRef.current?.click();
        }
    }

    /**
     * 刷新清空搜索条件是否需要显示...
     */
    const refreshClearFilterVisible = ()=>{
        // refreshSelectTags(mSelectTag.current);
        setTimeout(()=>{
            setIsClearFilterVisible(!isAllProject() || !isAllTag(mSelectTag.current) || !isCheckedAllType() || mSelectCustomFilter.current);
        },100)
    }

    /**
     * 有筛选条件
     */
    const hasFilterCondition = ()=>{
        return !isAllProject() || !isAllTag(mSelectTag.current) || mSelectCustomFilter.current
    }

    /**
     * 类型条目点击....
     * @param p
     * @param isChecked
     */
    const onCheckedItemClicked = (p,isChecked)=>{
        setSelectCustomFilter(null);
        mSelectCustomFilter.current = null;

        if (props.type == 'highlight'){
            var arrayNew = [...arrayLibraryTypes];
            p.isChecked = isChecked;
            mSelectType = p;
            setSelectType(p);//when update?????????setselecttype?????

            mArraySelectedTypes.current = arrayNew;
            setArrayLibraryTypes(arrayNew);

            //保存到文件...
            if (!isIngoreSelectSave()){
                localStorage.setItem(KEY_ANNO_TYPES,JSON.stringify(arrayNew));
            }

            //刷新列表
            mPageNum.current = 0;
            updateList()
        }else{
            var arrayNew = [...arrayLibraryTypes];

            if (p.value == CHECK_ALL) {
                arrayNew.forEach(pp => pp.isChecked = isChecked);
            }else {
                p.isChecked = isChecked;
                mSelectType = p;
                setSelectType(p);//when update?????????setselecttype?????

                if (p.isChecked) {
                    arrayLibraryTypes.forEach(p => {
                        if (p.value == mSelectType.value) {
                            setNewButtonText(p.buttonLabel);
                            setLeftTitle(p.label);
                        }
                    })
                }else {
                    const arraySelected = mArraySelectedTypes.current.filter(pp=>pp.isChecked && pp.value != p.value);
                    if (arraySelected.length >0) {
                        setSelectType(arraySelected[0]);
                    }else {
                        setSelectType({});
                    }
                }

                //判断all
                const itemAll = arrayNew[arrayNew.length -1];
                itemAll.isChecked = arrayNew.filter(pp=>pp.isChecked && pp.value != MENU_SEPARATOR && pp.value != CHECK_ALL).length == (arrayNew.length - 2);
            }

            mArraySelectedTypes.current = arrayNew;
            setArrayLibraryTypes(arrayNew);
            if (!isIngoreSelectSave()) {
                localStorage.setItem(KEY_LIBRARY_SELECTED_TYPES, JSON.stringify(arrayNew));
            }

            const nCheckedCount = arrayNew.filter(p=>p.isChecked).length;
            if (nCheckedCount != arrayNew.length){
                setIsClearFilterVisible(true);

                if (nCheckedCount == 1){
                    //取选中的第一个...

                    const arrayNewTypeSwitcher = [...arrayTypeSwitcher];
                    arrayNewTypeSwitcher.forEach(p=>{
                        p.isSelected = false;
                    })
                    const selectedItem = arrayNew.find(p=>p.isChecked);
                    if (selectedItem){
                        const typeSwitcher = arrayNewTypeSwitcher.find(p=>p.value == selectedItem.value);
                        if (typeSwitcher){
                            typeSwitcher.isSelected = true;
                        }
                    }
                    localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNewTypeSwitcher));
                    setArrayTypeSwitcher(arrayNewTypeSwitcher);

                }else{
                    //清空侧边需要选择的...
                    const arrayNew = [...arrayTypeSwitcher];
                    arrayNew.forEach(p=>{
                        p.isSelected = false;
                    })
                    localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNew));
                    setArrayTypeSwitcher(arrayNew);
                }
            }else{
                //判断是否要显示这个图标--根据别的筛选...
                //这里全选了...
                const arrayNew = [...arrayTypeSwitcher];
                arrayNew.forEach(p=>{
                    p.isSelected = false;
                })
                const allType = arrayNew.find(p=>p.value == 'all');
                if (allType){
                    allType.isSelected = true;
                }
                localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNew));
                setArrayTypeSwitcher(arrayNew);
            }

            //还要判断需不需要显示clear
            refreshClearFilterVisible();

            //如果当前选择的类型不再有当前过滤的source 类型，那么清空这个类型.
            if (mSelectAnnoSource.current){//又转回来。。。。
                let szAnnoType = '';
                if (mSelectAnnoSource.current.type == 'card'){
                    szAnnoType = 'cardAnno'
                }else if (mSelectAnnoSource.current.type == 'pdf'){
                    szAnnoType = 'pdfAnno'
                }else if (mSelectAnnoSource.current.type == 'video'){
                    szAnnoType = 'videoAnno'
                }else if (mSelectAnnoSource.current.type == 'audio'){
                    szAnnoType = 'audioAnno'
                }
                if (!mArraySelectedTypes.current.some(p=>p.isChecked && p.value == szAnnoType)){
                    //清空
                    setSelectSourceValue(t("Source"));
                    mSelectAnnoSource.current = null;
                }
            }

            // localStorage.setItem(KEY_LIBRARY_TYPE,mSelectType.value);

            //刷新列表
            mPageNum.current = 0;
            updateList()
        }
    }

    /**
     * 只选择一种类型.
     * @param p
     */
    const onCheckOneItem = (p)=>{
        setIsOpenProjectType(false);
        setSelectCustomFilter(null);
        mSelectCustomFilter.current = null;
        setIsClearFilterVisible(true);
        //只显示这一种类型..
        if (props.type == 'highlight') {
            const arrayNewType = [...arrayLibraryTypes];
            arrayNewType.forEach(item => {
                item.isHoverd = false;
                item.isChecked = false;
            });
            p.isChecked = true;

            mArraySelectedTypes.current = arrayNewType;
            setArrayLibraryTypes(arrayNewType);
            if (!isIngoreSelectSave()) {
                localStorage.setItem(KEY_ANNO_TYPES, JSON.stringify(arrayNewType));
            }

            //刷新列表
            mPageNum.current = 0;
            updateList()
        } else {
            const arrayNewType = [...arrayLibraryTypes];
            arrayNewType.forEach(item => {
                item.isHoverd = false;
                item.isChecked = false;
            });
            p.isChecked = true;

            mArraySelectedTypes.current = arrayNewType;
            setArrayLibraryTypes(arrayNewType);
            if (!isIngoreSelectSave()) {
                localStorage.setItem(KEY_LIBRARY_SELECTED_TYPES, JSON.stringify(arrayNewType));
            }

            //type switcher 部分
            const arrayNewTypeSwitcher = [...arrayTypeSwitcher];
            arrayNewTypeSwitcher.forEach(p=>{
                p.isSelected = false;
            })
            const typeSwitcher = arrayNewTypeSwitcher.find(pp=>pp.value == p.value);
            if (typeSwitcher){
                typeSwitcher.isSelected = true;
            }
            localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNewTypeSwitcher));
            setArrayTypeSwitcher(arrayNewTypeSwitcher);
            //end....


            //如果当前选择的类型不再有当前过滤的source 类型，那么清空这个类型.
            if (mSelectAnnoSource.current){//又转回来。。。。
                let szAnnoType = '';
                if (mSelectAnnoSource.current.type == 'card'){
                    szAnnoType = 'cardAnno'
                }else if (mSelectAnnoSource.current.type == 'pdf'){
                    szAnnoType = 'pdfAnno'
                }else if (mSelectAnnoSource.current.type == 'video'){
                    szAnnoType = 'videoAnno'
                }else if (mSelectAnnoSource.current.type == 'audio'){
                    szAnnoType = 'audioAnno'
                }
                if (!mArraySelectedTypes.current.some(p=>p.isChecked && p.value == szAnnoType)){
                    //清空
                    setSelectSourceValue(t("Source"));
                    mSelectAnnoSource.current = null;
                }
            }

            //刷新列表
            mPageNum.current = 0;
            updateList()
        }
    }

    /**
     * 自定义过滤...--------
     * @param customFilter
     */
    const customFilterEvent = async (customFilter:any)=>{
        let isFavor = mActiveTabItemRef.current?.id == 'favorites';
        let isPublished = mActiveTabItemRef.current?.id == 'published';

        const arrayConditions = customFilter.arrayConditions.filter(p=>p.type != 'properties');
        let arrayProjects:any = [];
        const arrayLibrarys:any = [];
        const arrayLibraryTypes:any = [];
        const arrayTags:any = [];
        //first  取project....
        for (let i=0;i<arrayConditions.length;i++){
            const item = arrayConditions[i];
            if (item.value == 'project'){
                const project:any = await getNoteById(item.secondValue,false);
                project.doc = await getNoteJsonDoc(item.secondValue);
                arrayProjects.push(project);
            }else if (item.value == 'type'){
                arrayLibraryTypes.push(item.secondValue);
            }else if (item.value == 'tag'){
                arrayTags.push(item.secondName);
            }
        }
        if (arrayLibraryTypes.length == 0){
            //没有选择类型，那么就是全部类型..
            arrayLibraryTypes.push('card');
            arrayLibraryTypes.push('pdf');
            arrayLibraryTypes.push('journal');
            arrayLibraryTypes.push('image');
            arrayLibraryTypes.push('liveVideo');
            arrayLibraryTypes.push('video');
            arrayLibraryTypes.push('audio');
            arrayLibraryTypes.push('file');
            arrayLibraryTypes.push('webLink');
            arrayLibraryTypes.push('cardAnno');
            arrayLibraryTypes.push('pdfAnno');
            arrayLibraryTypes.push('videoAnno');
            arrayLibraryTypes.push('audioAnno');
        }
        if (arrayLibraryTypes.includes('card')){
            arrayLibraryTypes.push('note');
        }
        if (arrayLibraryTypes.includes('liveVideo')){
            arrayLibraryTypes.push('youtube');
            arrayLibraryTypes.push('bilibili');
            arrayLibraryTypes.push('baidu');
        }
        //second  取library....
        if (arrayProjects.length > 0){
            for (let i=0;i<arrayProjects.length;i++){
                const doc = arrayProjects[i].doc;
                for (let j=0;j<doc.canvas.length;j++){
                    const canvas = doc.canvas[j];
                    for (let k=0;k<canvas.drawJson.elements.length;k++){
                        const element = canvas.drawJson.elements[k];
                        if (isPdfFileElement(element)){
                            element.customData.generationData.type = 'pdf';
                        }else if (isFileVideoElement(element)){
                            element.customData.generationData.type = 'video';
                        }else if (isAudioFileElement(element)){
                            element.customData.generationData.type = 'audio';
                        }
                        if (isImageElement(element)){
                            if (element.customData?.generationData){
                                element.customData.generationData.type = 'image';
                            }
                        }else if (isEmbeddableElement(element)){
                            if (element.customData?.generationData){
                                element.customData.generationData.type = 'liveVideo';
                            }
                        }
                        if (arrayLibraryTypes.includes(element.customData?.generationData?.type)){
                            let szId = element.customData?.generationData?.pdfData?.id || element.customData?.generationData?.videoData?.id || element.customData?.generationData?.id
                            const library = await getCardById(szId,false);
                            if (library){
                                arrayLibrarys.push(library);
                            }
                        }
                        if (arrayLibraryTypes.includes('webLink')){
                            if (isEmbedableBookmarkElement(element)){
                                const library = await getCardById(element.id,false);
                                if (library){
                                    arrayLibrarys.push(library);
                                }
                            }
                        }
                    }
                }
            }
        }else{
            //没有项目--那么就是库里面的所有...
            const arrayDbLibs:any = await getCardList(-1,0,arrayLibraryTypes,'','');
            arrayLibrarys.push(...arrayDbLibs);
        }

        let arrayNewLibrary:any = [];
        //third  取tag
        if (arrayTags.length > 0){
            arrayLibrarys.forEach(p=>{
                if (p.tags){
                    const intersection = p.tags.filter(x=>arrayTags.includes(x));
                    if (intersection.length == arrayTags.length){
                        arrayNewLibrary.push(p);
                    }
                }
            })
        }else{
            arrayNewLibrary.push(...arrayLibrarys);
        }

        //是否有keywords关键字。取第一个.
        const arrayKeys:any = [];
        for (let i=0;i<arrayConditions.length;i++){
            const condition = arrayConditions[i];
            if (condition.value == 'keyword'){
                arrayKeys.push(condition.secondValue);
            }
        }
        if (arrayKeys.length > 0){
            arrayNewLibrary = arrayNewLibrary.filter(p=>nameInKeywords(arrayKeys,p));
        }

        //这里再应用property------
        arrayNewLibrary = applyFilterProperty(arrayNewLibrary,customFilter.arrayConditions);
        arrayNewLibrary = await reSearchByKeyreSearchByKeyreSearchByKeyreSearchByKeyreSearchByKey(arrayNewLibrary);

        //这里再过滤------------------------------------------------------------------------
        if (isFavor){
            arrayNewLibrary = arrayNewLibrary.filter(p=>p.isFavirated == 1);
        }else if (isPublished){
            const arrayPublished = await getPublishProjectList('card');
            const arrayNewNewNew:any = [];
            for (let i=0;i<arrayNewLibrary.length;i++){
                const item = arrayNewLibrary[i];
                if (arrayPublished.find(p=>p.id == item.id)){
                    arrayNewNewNew.push(item);
                }
            }
            arrayNewLibrary = arrayNewNewNew;
        }

        setLibraryCount(arrayNewLibrary.length);
        await sortCards(arrayNewLibrary);
        setIsSearching(false);
        if (window.closeRightSliderSearch){
            window.closeRightSliderSearch();
        }
    }

    /**
     * 应用属性过滤---
     * @param arrayLibrary
     */
    const applyFilterProperty = (arrayLibrary:any,arrayConditions:any)=>{
        const arrayPropertiesConditions = arrayConditions.filter(p=>p.type == 'properties');
        if (arrayPropertiesConditions.length == 0){
            return arrayLibrary;
        }

        const arrayNewData = [];
        for (let k=0;k<arrayLibrary.length;k++){
            const data = arrayLibrary[k];
            let bOk = true;
            for (let i=0;i<arrayPropertiesConditions.length;i++){
                const condition = arrayPropertiesConditions[i];
                let propertyData = data[condition.value];//value 就是columnId
                if (propertyData == undefined){
                    //本身不带这个属性---------
                    bOk = false;
                    break;
                }

                let propertyValue:any = propertyData;
                if (isObject(propertyData)){
                    //如果是文本
                    if (propertyData.type == 'select' || propertyData.type == 'multiSelect'){
                        propertyValue = propertyData.data;
                    }else{
                        propertyValue = (propertyData.text || '') + '';//变成字符串。。。。。
                    }
                }
                //如果条件没有值，并且不是empty,notempty 忽略这个条件
                if (!condition.secondValue && (condition?.operator != 'isEmpty' || condition?.operator != 'isNotEmpty')){
                    if (condition.operator == 'isEmpty'){
                        if (propertyData && propertyData?.text){
                            //有值
                            bOk = false;
                            break;
                        }
                    }else if (condition.operator == 'isNotEmpty'){
                        if (!propertyValue){
                            bOk = false;
                            break;
                        }
                    }
                    continue;
                }


                if (propertyValue || isArray(propertyData)){
                    if (condition.operator == 'isEmpty'){
                        if (propertyData){
                            bOk = false;
                            break;
                        }
                    }

                    if (condition.secondValue){
                        if (propertyData?.type == 'number' || propertyData?.type == 'rating'){
                            //region 数字类型
                            const fNumberValue = getSafeFloat(propertyValue);
                            const fConditionValue = getSafeFloat(condition.secondValue);
                            if (condition.operator == '='){
                                if (fConditionValue != fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≠'){
                                if (fConditionValue == fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '>'){
                                if (fNumberValue <= fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≥'){
                                if (fNumberValue < fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '<'){
                                if (fNumberValue >= fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≤'){
                                if (fConditionValue < fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (condition.type == 'date' || propertyData?.type == 'date' || condition.value == 'createTime' || condition.value == 'updateTime'){

                            let nPropertyDate:any = formatDate(propertyData?.text || propertyData,'yyyyMMdd');
                            nPropertyDate = parseInt(nPropertyDate);
                            let nConditionDate:any = formatDate(condition.secondValue,'yyyyMMdd');
                            nConditionDate = parseInt(nConditionDate);

                            if (condition.operator == 'equals'){
                                if (nPropertyDate != nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'before'){
                                if (nPropertyDate >= nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'after'){
                                if (nPropertyDate <= nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }
                        }else if (propertyData?.type == 'checkbox'){
                            //只有一个操作符 is
                            if (condition.secondValue == 'checked'){
                                if (propertyData?.text != true){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.secondValue == 'unchecked'){
                                if (propertyData?.text){
                                    bOk = false;
                                    break;
                                }
                            }
                        }else if (isArray(propertyData) || propertyData?.type == 'select' || propertyData?.type == 'multiSelect'){
                            //region 多选----
                            let arrayConditionValue = condition.secondValue;
                            const arrayStrData:any = [];
                            propertyData.forEach(ppp=>{
                                arrayStrData.push(ppp.text || ppp);
                            })
                            if (condition.operator == 'is'){
                                if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (condition?.type == 'type' || propertyData?.type == 'type'){
                            //region 多选----
                            let arrayConditionValue = condition.value;
                            const arrayStrData:any = [propertyData];//这个是类型...
                            if (condition.operator == 'is'){
                                if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }
                        else{
                            //region 字符串类型
                            propertyValue = propertyValue?.toLowerCase();
                            let szConditionValue = condition.secondValue.toLowerCase();
                            if (condition.operator == 'is'){
                                if (szConditionValue != propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (szConditionValue == propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }
                    }else{
                        //region 没有条件值

                        //endregion
                    }
                } else{
                    //region 没有数据值
                    if (condition.operator == 'isNotEmpty'){
                        bOk = false;
                        break;
                    }else if (condition.operator == 'isEmpty'){

                    }else{
                        if (condition?.type == 'number' || condition?.type == 'rating'){
                            if (condition.operator == '≠'){

                            }else{
                                bOk = false;
                                break;
                            }
                        }else if (condition?.type == 'date'){
                            bOk = false;
                            break;
                        }else if (condition?.type == 'checkbox'){
                            if (condition.secondValue == 'checked'){
                                bOk = false;
                                break;
                            }
                        }else{
                            if (condition?.operator == 'isNot' || condition.operator == 'doesNotContain'){

                            }else{
                                bOk = false;
                                break;
                            }
                        }
                    }
                    //endregion
                }
            }
            if (bOk){
                arrayNewData.push(data);
            }
        }

        return arrayNewData;

    }

    const nameInKeywords = (arrayKeys:any,library:any)=>{
        let bContainer = false;
        for (let i=0;i<arrayKeys.length;i++){
            const szKey = arrayKeys[i].toLowerCase();
            if (library.name?.toLowerCase().includes(szKey)){
                bContainer = true;
            }else{
                return false;
            }
        }
        return bContainer;
    }

    /**
     * 仅显示过滤的文字，
     * 右侧栏打开，又筛选了project,只显示文字，不显示icon。
     * 正常情况显示icon又显示文字
     */
    const hasOnlyShowProjectFilterText = ()=>{
        if (props.source == 'dialogLink'){
            return false;
        }

        if (rightSliderWidth > 0 || isInDraw()){
            if (selectProjectValue != FILTER_PROJECT_ID_ALL && selectProjectValue != 'all-0' && selectProjectValue != t("All projects") && selectProjectValue != t("Projects")){
                return true;
            }
        }
        return false;
    }

    /**
     * 仅显示tag的文字
     */
    const hasOnlyShowTagFilterText = ()=>{
        if (props.source == 'dialogLink'){
            return false;
        }

        if (rightSliderWidth >0 || isInDraw()){
            if (selectTagValue != null && selectTagValue != 'tags' && selectTagValue != t('Tags')){
                return true;
            }
        }
        return false;
    }

    const hasOnlyShowFilterFilterText = ()=>{
        if (props.source == 'dialogLink'){
            return false;
        }

        if (rightSliderWidth >0 || isInDraw()){
            if (selectCustomFilter != null){
                return true;
            }
        }
        return false;
    }

    const hasOnlyShowFilterSourceText = ()=>{
        if (props.source == 'dialogLink'){
            return false;
        }

        if (rightSliderWidth >0 || isInDraw()){
            if (mSelectAnnoSource.current != null && selectSourceValue != t("Source")){
                return true;
            }
        }
        return false;
    }

    /**
     * 选择的宽度
     */
    const getSelectWidth = ()=>{
        if (props.from == FROM_LIBRARY){
            return '110px';
        }
        return '118px';
    }

    /**
     * 重置所有过滤条件.
     */
    const resetFilter = ()=>{
        mSelectTag.current = t('Tags');
        mSelectProjectId = 'all';
        setSelectProjectValue('all')
        setSelectTagValue(t('Tags'));
        setIsClearFilterVisible(false);
        setSelectCustomFilter(null);
        mSelectCustomFilter.current = null;
        setSelectSourceValue(t("Source"));
        setOnlyAnno(false);
        mOnlyAnno.current = false;
        mSelectAnnoSource.current = null;
        exitShowHiddenCard();
        //选择所有类型
        const arrayNewTypes = [...arrayLibraryTypes];
        arrayNewTypes.forEach(p => {
            p.isChecked = true;
        })
        setArrayLibraryTypes(arrayNewTypes);

        //switch type选中all
        const arrayTypeSwitchNew = [...arrayTypeSwitcher];
        arrayTypeSwitchNew.forEach(p => {
            p.isSelected = (p.value == 'all')
        })
        setArrayTypeSwitcher(arrayTypeSwitchNew);
    }

    const resetFilterExcludeLibraryType = ()=>{
        mSelectTag.current = t('Tags');
        mSelectProjectId = 'all';
        setSelectProjectValue('all')
        setSelectTagValue(t('Tags'));
        // setIsClearFilterVisible(false);
        setSelectCustomFilter(null);
        mSelectCustomFilter.current = null;
        setSelectSourceValue(t("Source"));
        setOnlyAnno(false);
        mOnlyAnno.current = false;
        mSelectAnnoSource.current = null;
        exitShowHiddenCard();
        //选择所有类型
        // const arrayNewTypes = [...arrayLibraryTypes];
        // arrayNewTypes.forEach(p => {
        //     p.isChecked = true;
        // })
        // setArrayLibraryTypes(arrayNewTypes);
        //
        // //switch type选中all
        // const arrayTypeSwitchNew = [...arrayTypeSwitcher];
        // arrayTypeSwitchNew.forEach(p => {
        //     p.isSelected = (p.value == 'all')
        // })
        // setArrayTypeSwitcher(arrayTypeSwitchNew);
    }

    /**
     * customfilter 添加到收藏
     */
    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = async function (event:any){
                        event.stopPropagation();
                        favorCustomFilter(mCurrentHoveredCustomFilter.current,null);
                    }
                }
            }
        },100)
    }

    /**
     * 添加到收藏，一种新类型.
     * @param p
     * @param szKey
     */
    const favorCustomFilter = async (p,szKey:any,favaratedValue:any)=>{
        if (p.isFavirated == 1){
            p.isFavirated = 0;
        }else{
            p.isFavirated = 1;
        }
        if (favaratedValue){
            p.isFavirated = favaratedValue;
        }
        p.type = 'customFilter';
        p.favirateTime = new Date().getTime();
        //把这个data插入到文件夹下...
        if (szKey){
            await updateFavorToFolder(szKey,p);
        }

        updateCustomFilter(p).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE);
        })
    }


    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            mPageNum.current = 0;
                            updateList();
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    /**
     * 取选择类型的描述....
     */
    const getSelectTypeDesc = ()=>{
        const arrayChecked = arrayLibraryTypes.filter(p=>p.isChecked);
        if (arrayChecked.length == 1){
            return arrayChecked[0].label;
        }
        if (arrayChecked.length == arrayLibraryTypes.length){
            return t("All type");
        }
        return t("Type");
    }

    const getExtraStyle = ()=>{
        let style:any;
        if (props.from == FROM_LIBRARY){
            style = {
                // height: `${HEADER_HEIGHT}px`,
                gap:'12px 12px',
            }
        }else{
            style = {
                // paddingTop:'0px',
                gap:'12px 10px',//y,x
                flexWrap:'wrap',
                overflow:'hidden'
            }
        }
        return style;
    }

    return (
        <div style={{height: props.from == FROM_LIBRARY ? `${isMac()?'calc(100% - 0px)':'calc(100% - 10px)'}` : '100%',pointerEvents: props.pointerEvent || 'all',display:'flex',flexDirection:'row'}}>
            <div id={props.szContainerId || 'divPageLibaryContainer'} className={style.pageIndex}
                 style={{
                     height: props.from == FROM_LIBRARY ? 'calc(100% - 0px)' : '100%',
                     paddingBottom: '16px',
                     pointerEvents: props.pointerEvent || 'all',
                     width: `calc(100% - ${(props.from == FROM_LIBRARY || props.source === 'dialogLink')?0:rightSliderWidth}px)`
                 }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    // height: `${HEADER_HEIGHT}px`,
                    flexShrink: '0',
                    overflowX: 'hidden',
                    padding: '7px 19px 7px 20px',
                    position: 'relative',
                    // minHeight:`${HEADER_HEIGHT}px`,
                    ...getExtraStyle(),
                }}>
                    {
                        props.from == FROM_HOME_LIBRARY &&
                        <HomeNavigator margin={'0 0px 0 -4px'}/>
                    }

                    {
                        props.from != FROM_LIBRARY && props.from != FROM_ADD &&

                        <div style={{marginLeft:'5px'}}>
                            <Input className={'input-border'} prefix={<IconHomeSearch/>} suffix={renderSuffix()}
                                   variant={"borderless"}
                                   style={{
                                       width: `${searchWidth}px`,//getSearchWidth(),
                                       height: '32px',
                                       background:'transparent',
                                       // backgroundColor: 'var(--input-background-color)'
                                   }}
                                   placeholder={t("Search") + (isZh() ? "" : " ") + t("Library")} value={searchKey}
                                   onChange={onSearchChange}/>

                            {
                                // isSearching &&
                                // <Spin indicator={<img className={'img-16 rotating-image'}
                                //                       src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
                            }
                        </div>
                    }

                    {/*分类类型切换...card - pdf image  video audio 类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择类型选择*/}
                    {
                        //region
                        (!props.type || props.type == 'highlight') &&
                        <div className={'flex-row-vertical-center select-popup-class'} style={{
                            width: getSelectWidth(),
                            marginLeft: (props.from == FROM_LIBRARY || props.type == 'highlight') ? '0px' : '10px',
                            borderRadius: '8px',
                            paddingLeft: '12px',
                            position: 'relative',
                            height: '32px',
                            border: '1px solid var(--input-border-color)',
                            marginRight: props.type == 'highlight' ? '0px' : '0px'
                        }}>
                            <img className={'img-18'} src={getImagePathWithTheme('filter_type.svg')}/>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            /* 这里是你的组件 token */
                                            colorBorder: 'transparent',
                                            colorPrimaryHover: 'transparent',
                                            colorPrimary: 'transparent',
                                        },
                                    },
                                }}>
                                <Select
                                    showSearch={false}
                                    dropdownClassName={'shadow'}
                                    onKeyDownCapture={(e) => {
                                        //showSearch={false}是干什么吃的呢？
                                        if (isShortcuts(e,'newCard')) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            Global.g_currentNoteData = {id: generateRandomPageKey()}
                                            openEditor(Global.g_currentNoteData.id, false, false);
                                        }
                                    }}
                                    open={isOpenProjectType}
                                    value={((rightSliderWidth>0 || isInDraw()) && props.source != 'dialogLink')?'':getSelectTypeDesc()}
                                    style={{width: '100%', position: 'absolute', left: '0', paddingLeft: '0px',marginTop:'0px',}}
                                    options={ARRAY_LIBRARY_TYPES}
                                    onDropdownVisibleChange={(e) => setIsOpenProjectType(e)}
                                    onChange={(value, option) => {

                                    }}

                                    dropdownRender={(menu) => {
                                        return (
                                            <div key={'pagelibrary-' + props.from}
                                                 style={{overflowX: 'hidden', maxHeight: '620px', overflowY: 'auto'}}>
                                                <>
                                                    {
                                                        arrayLibraryTypes.map(p =>
                                                            <>
                                                                {
                                                                    p.value == MENU_SEPARATOR &&
                                                                    <div key={p.value + p.ext} className={'line'}
                                                                         style={{margin: '4px 0'}}></div>
                                                                }
                                                                {
                                                                    p.value !== MENU_SEPARATOR &&
                                                                    <div key={p.value} className={'dropdown-item'}
                                                                         onMouseEnter={() => {
                                                                             const arrayNewType = [...arrayLibraryTypes];
                                                                             arrayNewType.forEach(p => p.isHoverd = false);
                                                                             p.isHoverd = true;
                                                                             mArraySelectedTypes.current = arrayNewType;
                                                                             setArrayLibraryTypes(arrayNewType);
                                                                         }} onMouseLeave={() => {
                                                                        const arrayNewType = [...arrayLibraryTypes];
                                                                        arrayNewType.forEach(p => p.isHoverd = false);
                                                                        mArraySelectedTypes.current = arrayNewType;
                                                                        setArrayLibraryTypes(arrayNewType);
                                                                    }} onClick={(event) => {
                                                                        // setIsOpenProjectType(false);
                                                                        // mSelectType = p;
                                                                        // setSelectType(p);//when update?????????setselecttype?????
                                                                        // ARRAY_LIBRARY_TYPES.forEach(p=>{
                                                                        //     if (p.value == mSelectType.value){
                                                                        //         setNewButtonText(p.buttonLabel);
                                                                        //         setLeftTitle(p.label);
                                                                        //     }
                                                                        // })
                                                                        // localStorage.setItem(KEY_LIBRARY_TYPE,mSelectType.value);
                                                                        //
                                                                        // //刷新列表
                                                                        // mPageNum = 0;
                                                                        // updateList()
                                                                        exitShowHiddenCard();

                                                                        onCheckedItemClicked(p, !p.isChecked);
                                                                    }} style={{
                                                                        background: 'transparent',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        <img className={'img-16'}
                                                                             style={{filter: 'none', marginLeft: '8px'}}
                                                                             src={getImagePathWithTheme(p.icon)}/>

                                                                        <span className={'span-single-line'} style={{
                                                                            paddingLeft: '12px',
                                                                            paddingRight: '12px',
                                                                            color: 'var(--text-color)'
                                                                        }}>{p.label}</span>

                                                                        <div className={'flex-row-vertical-center'}
                                                                             style={{marginLeft: 'auto'}}>
                                                                            {
                                                                                p.isHoverd && p.value != CHECK_ALL &&
                                                                                <Tooltip title={t("ShowOnlyThis")}
                                                                                         arrow={false}>
                                                                                    <img style={{marginLeft: 'auto'}}
                                                                                         className={'img-16 no-filter mr-6'}
                                                                                         src={getImagePathWithTheme('library_eye_this')}
                                                                                         onClick={(e) => {
                                                                                             e.stopPropagation();
                                                                                             e.preventDefault();
                                                                                             exitShowHiddenCard();
                                                                                             onCheckOneItem(p);
                                                                                         }}/>
                                                                                </Tooltip>
                                                                            }

                                                                            <Checkbox style={{
                                                                                marginLeft: '4px',
                                                                                marginRight: '8px',
                                                                                pointerEvents: 'none'
                                                                            }} checked={p.isChecked} onChange={(e) => {
                                                                                // onCheckedItemClicked(p,e.target.checked)
                                                                            }}></Checkbox>
                                                                        </div>

                                                                    </div>
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            </div>
                                        )
                                    }}
                                    suffixIcon={<img className='img-16' onClick={() => {
                                        setIsOpenProjectType(true)
                                    }}
                                                     src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                    dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                                </Select>
                            </ConfigProvider>

                        </div>

                        //endregion
                    }


                    {/*project 按所在项目过滤..all  all in project  not in project*/}
                    <div className={'flex-row-vertical-center '+(hasOnlyShowProjectFilterText()?'':'select-popup-class')} style={{
                        width: getSelectWidth(),
                        paddingLeft: '12px',
                        borderRadius: '8px',
                        position: 'relative',
                        height: '32px',
                        border: '1px solid var(--input-border-color)',
                        marginLeft: getSelectProjectMarginLeft(),
                    }}>
                        {
                            !hasOnlyShowProjectFilterText() &&
                            <img className={'img-18'} src={getImagePathWithTheme('filter_project.svg')}/>
                        }

                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        /* 这里是你的组件 token */
                                        colorBorder: 'transparent',
                                        colorPrimaryHover: 'transparent',
                                        colorPrimary: 'transparent',
                                    },
                                },
                            }}>
                            <Select
                                showSearch={true}
                                dropdownClassName={'shadow'}
                                open={isOpenProjectSelect}
                                onDropdownVisibleChange={(e) => {
                                    // const arrayDivs = document.getElementsByClassName('ant-select-dropdown-placement-bottomLeft');
                                    // if (arrayDivs.length > 0) {
                                    //     arrayDivs[0].style.marginLeft = '-22px';
                                    // }
                                    setIsOpenProjectSelect(e);
                                }}
                                value={(hasOnlyShowProjectFilterText() || (rightSliderWidth == 0 && !isInDraw()) || props.source == 'dialogLink')?selectProjectValue:''}
                                style={{
                                    width: '100%',
                                    position: 'absolute',
                                    left: '0',
                                    marginTop:'1px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                popupClassName={'select-popup-class'}
                                options={arrayProjects}
                                onChange={value => {
                                    setSelectProjectValue(value);
                                }}
                                onSearch={value => {
                                    value = value.toLowerCase();
                                    if (isStringNullOrEmpty(value)) {
                                        setArrayProjects(mArrayProjects);
                                    } else {
                                        var arrayNewProject = mArrayProjects.filter((p) => {
                                            return p.label?.toLowerCase().indexOf(value) != -1;
                                        });
                                        setArrayProjects(arrayNewProject);
                                    }
                                }}
                                dropdownRender={(menu) => {
                                    return (
                                        <div style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                                            {
                                                arrayProjects.map(p =>
                                                    <>
                                                        {
                                                            p.id == MENU_SEPARATOR &&
                                                            <div key={p.id} className={'line'}
                                                                 style={{margin: '4px -6px'}}></div>
                                                        }
                                                        {
                                                            p.id !== MENU_SEPARATOR && p.value != 'all' &&
                                                            <div key={p.value} className={'dropdown-item'}
                                                                 onClick={async () => {
                                                                     mSelectCustomFilter.current = null;
                                                                     setSelectCustomFilter(null);

                                                                     setIsOpenProjectSelect(false);
                                                                     setSelectProjectValue(p.label);
                                                                     mSelectProjectId = p.value;
                                                                     //获取这个项目下的所有条目.card
                                                                     mPageNum.current = 0;
                                                                     //不是全部的项目了，不分页....
                                                                     if (!isAllProject()) {
                                                                         mPageNum.current = -1;
                                                                     }

                                                                     //如果选择了当前项目-当前board 要保存一下..
                                                                     if (mSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD) {
                                                                         if (window.saveNotes) {
                                                                             await window.saveNotes();
                                                                         }
                                                                     }
                                                                     updateList(true);

                                                                     //记忆
                                                                     if (!isIngoreSelectSave()) {
                                                                         localStorage.setItem(KEY_FILTER_SELECT_PROJECT, p.value);
                                                                     }

                                                                     refreshClearFilterVisible();
                                                                 }}>
                                                            <span className={'span-single-line'} style={{
                                                                paddingLeft: '12px',
                                                                paddingRight: '12px'
                                                            }}>{p.label}</span>
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    )
                                }}
                                suffixIcon={<img className='img-16'
                                                 onClick={() => setIsOpenProjectSelect(true)}
                                                 src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                dropdownStyle={{width: '228px', overflowY: 'auto',boxShadow: 'var(--dialog-box-shadow)'}}>
                            </Select>
                            {/*<span style={{position:'absolute',pointerEvents:'none',height:'100%',marginLeft:'6px',marginRight:'16px'}}>{selectProjectValue}</span>*/}
                        </ConfigProvider>

                    </div>


                    {/*//标签  标签下拉*/}
                    <div className={'flex-row-vertical-center '+ (hasOnlyShowTagFilterText()?'':'select-popup-class')} style={{
                        width: getSelectWidth(),
                        marginLeft: props.from == FROM_LIBRARY ? '0px' : '0px',
                        paddingLeft: '12px',
                        borderRadius: '8px',
                        position: 'relative',
                        height: '32px',
                        border: '1px solid var(--input-border-color)',
                    }}>
                        {
                            !hasOnlyShowTagFilterText() &&
                            <img className={'img-18'} src={getImagePathWithTheme('filter_tag.svg')}/>
                        }


                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        /* 这里是你的组件 token */
                                        colorBorder: 'transparent',
                                        colorPrimaryHover: 'transparent',
                                        colorPrimary: 'transparent',
                                    },
                                },
                            }}>
                            <Select
                                showSearch={true}
                                open={isOpenTagSelect}
                                dropdownClassName={'shadow'}
                                onDropdownVisibleChange={(e) => setIsOpenTagSelect(e)}
                                value={(hasOnlyShowTagFilterText() || (rightSliderWidth == 0 && !isInDraw()) || props.source == 'dialogLink')?selectTagValue:''}
                                style={{
                                    width: '100%',
                                    position: 'absolute',
                                    left: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop:'1px',
                                }}
                                options={arrayTags}
                                onSearch={value => {
                                    if (isStringNullOrEmpty(value)) {
                                        setArrayTags(mArrayTags);
                                    } else {
                                        var arrayNewTag = mArrayTags.filter((p) => {
                                            return p.label?.toLowerCase()?.indexOf(value.toLowerCase()) != -1;
                                        });
                                        setArrayTags(arrayNewTag);
                                    }
                                }}
                                dropdownRender={(menu) => {
                                    return (
                                        <>
                                            {
                                                // props.from == FROM_LIBRARY && arrayTags.length == 0 &&
                                                // <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />

                                            }
                                            {/*<div key={'no-tags'} className={'dropdown-item'} onClick={()=>{*/}
                                            {/*    let szValue =*/}
                                            {/*    setIsOpenTagSelect(false);*/}
                                            {/*    setSelectTagValue(FILTER_TAG_NO_TAGS);*/}
                                            {/*    mSelectTag = FILTER_TAG_NO_TAGS;*/}
                                            {/*    mPageNum = -1;*/}
                                            {/*    //更新列表...*/}
                                            {/*    updateList();*/}

                                            {/*    localStorage.setItem(KEY_FILTER_SELECT_TAG, FILTER_TAG_NO_TAGS);*/}
                                            {/*    setIsClearFilterVisible(true)*/}
                                            {/*}}>*/}
                                            {/*    <span className={'span-single-line'} style={{*/}
                                            {/*        paddingLeft: '12px',*/}
                                            {/*        paddingRight: '12px',*/}
                                            {/*        display: 'block',*/}
                                            {/*    }}>{t("No tags")}</span>*/}
                                            {/*</div>*/}

                                            {/*<div className={'line'} style={{*/}
                                            {/*    margin: '3px -6px',*/}
                                            {/*    background: 'var(--vertical-line-color)',*/}
                                            {/*    flexShrink: '0'*/}
                                            {/*}}></div>*/}

                                            <div style={{
                                                overflowX: 'hidden',
                                                maxHeight: '320px',
                                                overflowY: 'auto',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}>
                                                {
                                                    arrayTags.map(p =>
                                                            <>
                                                                {
                                                                    p.id == MENU_SEPARATOR &&
                                                                    <div key={p.value} className={'line'}
                                                                         style={{margin: '4px 0'}}></div>
                                                                }
                                                                {
                                                                    p.id !== MENU_SEPARATOR &&
                                                                    <div key={p.value} className={'dropdown-item'}
                                                                         onClick={() => {
                                                                             mSelectCustomFilter.current = null;
                                                                             setSelectCustomFilter(null);
                                                                             setIsOpenTagSelect(false);
                                                                             setSelectTagValue(p.label);
                                                                             if (p.value == FILTER_TAG_NO_TAGS) {
                                                                                 mSelectTag.current = FILTER_TAG_NO_TAGS + '-----';//没有tag的标题
                                                                             } else {
                                                                                 mSelectTag.current = p.label;
                                                                             }

                                                                             mPageNum.current = -1;
                                                                             //更新列表...
                                                                             updateList();
                                                                             if (!isIngoreSelectSave()) {
                                                                                 localStorage.setItem(KEY_FILTER_SELECT_TAG, p.label);
                                                                             }

                                                                             refreshClearFilterVisible()
                                                                         }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{(p.value == FILTER_TAG_NO_TAGS ? '' : '#') + p.label}</span>
                                                                    </div>
                                                                }
                                                            </>
                                                    )
                                                }
                                                {
                                                    arrayTags.length == 0 && //默认有个no tags 和横线....
                                                    <span
                                                        style={{margin: '6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                                                }

                                                <div style={{flexGrow: '1'}}></div>

                                                {
                                                    props.from != FROM_LIBRARY &&
                                                    <>
                                                        <div className={'line'} style={{
                                                            margin: '6px -6px',
                                                            background: 'var(--vertical-line-color)',
                                                            flexShrink: '0'
                                                        }}></div>
                                                        {/*添加manager*/}
                                                        <div className={'flex-row-vertical-center cursor-pointer'}
                                                             style={{padding: '6px 12px'}}
                                                             onClick={() => {
                                                                 // dialogAllTagManagerRef.current?.onShowDialog();
                                                                 postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'tags'});
                                                             }}>
                                                            <img className={'img-16'}
                                                                 src={getImagePathWithTheme('go_to_tags')}/>
                                                            <span className={'ml-8'}
                                                                  style={{marginTop: '1px'}}>{t("Go to tags")}</span>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </>
                                    )
                                }}
                                suffixIcon={<img className='img-16' onClick={() => setIsOpenTagSelect(true)}
                                                 src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                            </Select>
                        </ConfigProvider>
                    </div>

                    {/*customfilter customfilter customfiltercustomfiltercustomfiltercustomfiltercustomfiltercustomfilter*/}
                    {
                        //region 原来的不用
                        false &&
                        <Popover open={isOpenFilter} placement={'bottom'}
                                 onOpenChange={(e) => {
                                     // setIsOpenFilter(e);
                                 }}
                                 arrow={false} overlayInnerStyle={{margin: '0px', padding: '6px 16px', minWidth: '240px'}}
                                 align={{offset: [(props.from == FROM_LIBRARY ? 80 : 50), 4]}}
                                 content={<div className={'default-font-size'}>
                                     <div onClick={(event) => {
                                         event.stopPropagation();
                                     }}>
                                         {
                                             arrayFilters.map(p => {
                                                 return <div className={'flex-row-vertical-center cursor-pointer'}
                                                             style={{height: '32px'}} onClick={(event) => {
                                                     setSelectCustomFilter(p);
                                                     setIsOpenFilter(false);

                                                     //重置别的选项...
                                                     mSelectTag.current = t("Tags");
                                                     mSelectProjectId = 'all';
                                                     setSelectProjectValue('all')
                                                     setSelectTagValue(t('Tags'));

                                                     localStorage.setItem(KEY_FILTER_SELECT_PROJECT, 'all');
                                                     localStorage.setItem(KEY_FILTER_SELECT_TAG, t('Tags'))

                                                     customFilterEvent(p);
                                                     setIsClearFilterVisible(true);

                                                     event.stopPropagation();
                                                 }} onMouseEnter={() => {
                                                     const arrayNews = [...arrayFilters];
                                                     arrayNews.forEach(item => {
                                                         item.isHover = false;
                                                     })
                                                     p.isHover = true;
                                                     setArrayFilters(arrayNews);
                                                 }} onMouseLeave={() => {
                                                     const arrayNews = [...arrayFilters];
                                                     arrayNews.forEach(item => {
                                                         item.isHover = false;
                                                     })
                                                     setArrayFilters(arrayNews);
                                                 }}>
                                                     <span>{p.name}</span>
                                                     {
                                                         props.from != FROM_LIBRARY && p.isHover &&
                                                         <img className={'img-16 cursor-pointer'}
                                                              style={{marginLeft: 'auto'}}
                                                              src={getImagePathWithTheme('filter_edit')}
                                                              onClick={(event) => {
                                                                  window.showDialogCreateNewFilter(p.id);
                                                                  event.stopPropagation();
                                                              }}/>
                                                     }

                                                 </div>
                                             })
                                         }
                                     </div>

                                     {
                                         arrayFilters.length == 0 && //默认有个no tags 和横线....
                                         <span
                                             style={{
                                                 margin: '8px 0 10px 0',
                                                 display: 'block',
                                                 cursor: 'default'
                                             }}>{t("NoFilterYet")}</span>
                                     }

                                     {
                                         props.from != FROM_LIBRARY &&
                                         <>
                                             <div className={'line'} style={{margin: '0 -16px'}}></div>
                                             <div className={'flex-row-vertical-center cursor-pointer mt-2'}
                                                  style={{height: '32px'}}
                                                  onClick={(event) => {
                                                      window.showDialogCreateNewFilter();
                                                      setIsOpenFilter(false);
                                                      event.stopPropagation();
                                                  }}>
                                                 <img className={'img-16'} src={getImagePath('add_blue_filter')}/>
                                                 <span className={'ml-6'}
                                                       style={{color: 'var(--primary-color)'}}>{t("CreateNewFilter")}</span>
                                             </div>
                                         </>
                                     }
                                 </div>}>
                            <div className={'flex-row-vertical-center select-popup-class'} style={{
                                width: props.from == FROM_LIBRARY ? '80px' : '138px',
                                maxWidth: props.from == FROM_LIBRARY ? '80px' : '138px',
                                marginLeft: props.from == FROM_LIBRARY ? '12px' : '22px',
                                paddingLeft: '12px',
                                borderRadius: '8px',
                                position: 'relative',
                                height: '32px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                border: '1px solid var(--input-border-color)',
                            }} onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                            }}>
                                <img className={'img-14 mt-2'} src={getImagePathWithTheme('filter_filter')}/>
                                <span
                                    className={'default-font-size span-single-line ml-6 mr-4'}>{props.from == FROM_LIBRARY ? '' : (rightSliderWidth > 0 ? '' : (selectCustomFilter?.name || t("Filter")))}</span>
                                <img className='img-16 mr-12' style={{marginLeft: 'auto'}}
                                     onClick={() => setIsOpenTagSelect(true)}
                                     src={getImagePathWithTheme('drop_down_select.svg')}/>
                            </div>
                        </Popover>
                        //endregion
                    }


                    {/*customfilter customfilter customfiltercustomfiltercustomfiltercustomfiltercustomfiltercustomfilter*/}
                    <div className={'flex-row-vertical-center '+(hasOnlyShowFilterFilterText()?'':'select-popup-class')} style={{
                        width: getSelectWidth(),
                        marginLeft: props.from == FROM_LIBRARY ? '0px' : '0px',
                        paddingLeft: '12px',
                        paddingRight:'0px',
                        borderRadius: '8px',
                        position: 'relative',
                        height: '32px',
                        border: '1px solid var(--input-border-color)',
                    }}>
                        {
                            !hasOnlyShowFilterFilterText() &&
                            <img className={'img-18 mt-2'} src={getImagePathWithTheme('filter_filter.svg')}/>
                        }


                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        /* 这里是你的组件 token */
                                        colorBorder: 'transparent',
                                        colorPrimaryHover: 'transparent',
                                        colorPrimary: 'transparent',
                                    },
                                },
                            }}>
                            <Select
                                showSearch={false}
                                open={isOpenFilter}
                                dropdownClassName={'shadow'}
                                onKeyDownCapture={(e) => {
                                    //showSearch={false}是干什么吃的呢？
                                    if (isShortcuts(e,'newCard')) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        Global.g_currentNoteData = {id: generateRandomPageKey()}
                                        openEditor(Global.g_currentNoteData.id, false, false);
                                    }
                                }}
                                onDropdownVisibleChange={(e) => {
                                    if (!e) {
                                        setTimeout(()=>{
                                            // setIsCustomItemMoreOpened(false);
                                            var arrayNew = [...arrayFilters];
                                            arrayNew.forEach(p=>{
                                                p.isCustomItemMoreOpened = false;
                                            })
                                            setArrayFilters(arrayNew);

                                            setTimeout(()=>{
                                                setIsOpenFilter(e);
                                            },100)
                                        },100)
                                    }else {
                                        setIsOpenFilter(e);
                                    }
                                }}
                                value={(hasOnlyShowFilterFilterText() || (rightSliderWidth == 0 && !isInDraw()) || props.source == 'dialogLink')?(selectCustomFilter?.name || t("Filter")):''}
                                style={{
                                    width: '100%',
                                    position: 'absolute',
                                    left: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop:'1px',
                                }}
                                options={arrayTags}
                                dropdownRender={(menu) => {
                                    return (
                                        <>
                                            <div style={{
                                                overflowX: 'hidden',
                                                maxHeight: '320px',
                                                overflowY: 'auto',
                                                display: 'flex',
                                                padding:'0 12px',
                                                flexDirection: 'column'
                                            }}>
                                                {
                                                    arrayFilters.map(p => {
                                                        return <div className={'flex-row-vertical-center cursor-pointer'}
                                                                    style={{height: '32px'}} onClick={(event) => {
                                                            setSelectCustomFilter(p);

                                                            setTimeout(()=>{
                                                                setIsOpenFilter(false);
                                                            },100)
                                                            // setIsCustomItemMoreOpened(false);
                                                            var arrayNew = [...arrayFilters];
                                                            arrayNew.forEach(p=>{
                                                                p.isCustomItemMoreOpened = false;
                                                            })
                                                            setArrayFilters(arrayNew);

                                                            //重置别的选项...
                                                            mSelectTag.current = t("Tags");
                                                            mSelectProjectId = 'all';
                                                            setSelectProjectValue('all')
                                                            setSelectTagValue(t('Tags'));

                                                            if (!isIngoreSelectSave()) {

                                                                localStorage.setItem(KEY_FILTER_SELECT_PROJECT, 'all');
                                                                localStorage.setItem(KEY_FILTER_SELECT_TAG, t('Tags'))
                                                                localStorage.setItem(KEY_FILTER_CUSTOM_FILTER, JSON.stringify(p));
                                                            }

                                                            customFilterEvent(p);
                                                            setIsClearFilterVisible(true);

                                                            event.stopPropagation();
                                                        }} onMouseEnter={() => {
                                                            const arrayNews = [...arrayFilters];
                                                            arrayNews.forEach(item => {
                                                                item.isHover = false;
                                                            })
                                                            p.isHover = true;
                                                            setArrayFilters(arrayNews);
                                                        }} onMouseLeave={() => {
                                                            const arrayNews = [...arrayFilters];
                                                            arrayNews.forEach(item => {
                                                                item.isHover = false;
                                                            })
                                                            setArrayFilters(arrayNews);
                                                        }}>
                                                            <span className={'span-single-line'}>{p.name}</span>
                                                            {
                                                                props.from != FROM_LIBRARY && (p.isHover || p.isCustomItemMoreOpened) &&
                                                                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto',flexShrink:'0'}}>
                                                                    <img className={'img-16 cursor-pointer'}
                                                                         src={getImagePathWithTheme('filter_edit')}
                                                                         onClick={(event) => {
                                                                             window.showDialogCreateNewFilter(p.id);
                                                                             event.stopPropagation();
                                                                         }}/>
                                                                    <Dropdown overlayClassName='default-dropdown-style' open={p.isCustomItemMoreOpened} overlayStyle={{minWidth: '232px'}}
                                                                              placement={'rightBottom'} menu={{items:arrayCustomFilterMore}} align={{offset:[16,12]}}
                                                                              onOpenChange={(e)=>{
                                                                                  p.isCustomItemMoreOpened = e;
                                                                        // setIsCustomItemMoreOpened(e);
                                                                                                                                        mCurrentHoveredCustomFilter.current = p;

                                                                        if (e) {
                                                                            patchMenuFavor();
                                                                            const arrayMenus: any = [];
                                                                            const item = {
                                                                                label: p?.isFavirated == 1 ? t('Cancel favor') : t("Add to Favorites"),
                                                                                key: 'favor',
                                                                                icon: p?.isFavirated == 1 ?
                                                                                    <IconRemoveFavor/> :
                                                                                    <IconAddToFavor/>,
                                                                                children: getFavorChildrenMenu(p?.isFavirated, async (key) => {
                                                                                    mIsCustomFilterChildrenClicked.current = true;
                                                                                    favorCustomFilter(p,key)
                                                                                }),
                                                                                onClick:(event:any)=> {
                                                                                    event.domEvent.stopPropagation();
                                                                                    if (mIsCustomFilterChildrenClicked.current) {
                                                                                        mIsCustomFilterChildrenClicked.current = false;
                                                                                        return;
                                                                                    }
                                                                                    favorCustomFilter(p,null);
                                                                                }
                                                                            }
                                                                            arrayMenus.push(item);
                                                                            setArrayCustomFilterMore(arrayMenus);
                                                                        }
                                                                    }}>
                                                                        <img className={'img-16 ml-8'}
                                                                             src={getImagePathWithThemeSvg('custom_filter_more')} onClick={(e)=>{
                                                                                 e.stopPropagation();
                                                                        }}/>
                                                                    </Dropdown>

                                                                </div>
                                                            }

                                                        </div>
                                                    })
                                                }

                                                {
                                                    arrayFilters.length == 0 && //默认有个no tags 和横线....
                                                    <span
                                                        style={{
                                                            margin: '8px 0 10px 0',
                                                            display: 'block',
                                                            cursor: 'default'
                                                        }}>{t("NoFilterYet")}</span>
                                                }


                                                {
                                                    props.from != FROM_LIBRARY &&
                                                    <>
                                                        <div className={'line'} style={{margin: '0 -16px'}}></div>
                                                        <div className={'flex-row-vertical-center cursor-pointer mt-2'}
                                                             style={{height: '32px'}}
                                                             onClick={(event) => {
                                                                 window.showDialogCreateNewFilter();
                                                                 setIsOpenFilter(false);
                                                                 event.stopPropagation();
                                                             }}>
                                                            <img className={'img-16'} src={getImagePath('add_blue_filter')}/>
                                                            <span className={'ml-6'}
                                                                  style={{color: 'var(--primary-color)'}}>{t("CreateNewFilter")}</span>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </>
                                    )
                                }}
                                suffixIcon={<img className='img-16' onClick={() => setIsOpenTagSelect(true)}
                                                 src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                            </Select>
                        </ConfigProvider>
                    </div>


                    {
                        onlyAnno &&
                        //source--------source--------source--------source--------source--------source--------source--------
                        <div
                            className={'flex-row-vertical-center ' + (hasOnlyShowTagFilterText() ? '' : 'select-popup-class')}
                            style={{
                                width: getSelectWidth(),
                                marginLeft: props.from == FROM_LIBRARY ? '0px' : '0px',
                                paddingLeft: '12px',
                                borderRadius: '8px',
                                position: 'relative',
                                height: '32px',
                                border: '1px solid var(--input-border-color)',
                            }}>
                            {
                                !hasOnlyShowTagFilterText() &&
                                <img className={'img-14'} src={getImagePathWithTheme('filter_source')}/>
                            }


                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            /* 这里是你的组件 token */
                                            colorBorder: 'transparent',
                                            colorPrimaryHover: 'transparent',
                                            colorPrimary: 'transparent',
                                        },
                                    },
                                }}>
                                <Select
                                    showSearch={true}
                                    open={isOpenSource}
                                    dropdownClassName={'shadow'}
                                    onDropdownVisibleChange={(e) => setIsOpenSource(e)}
                                    value={(hasOnlyShowFilterSourceText() || (rightSliderWidth == 0 && !isInDraw()) || props.source == 'dialogLink') ? selectSourceValue : ''}
                                    style={{
                                        width: '100%',
                                        position: 'absolute',
                                        left: '0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: '1px',
                                    }}
                                    options={arrayAnnoSource}
                                    onSearch={value => {
                                        if (isStringNullOrEmpty(value)) {
                                            setArrayAnnoSource(mArrayAnnoSource.current);
                                        } else {
                                            var arrayNewAnnoSource = mArrayAnnoSource.current.filter((p) => {
                                                return p.name?.toLowerCase()?.indexOf(value.toLowerCase()) != -1;
                                            });
                                            setArrayAnnoSource(arrayNewAnnoSource);
                                        }
                                    }}
                                    dropdownRender={(menu) => {
                                        return (
                                            <>
                                                <div style={{
                                                    overflowX: 'hidden',
                                                    maxHeight: '320px',
                                                    overflowY: 'auto',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}>
                                                    {
                                                        arrayAnnoSource.map(p =>
                                                                <>
                                                                    {
                                                                        p.id == MENU_SEPARATOR &&
                                                                        <div key={p.id} className={'line'}
                                                                             style={{margin: '4px 0'}}></div>
                                                                    }
                                                                    {
                                                                        p.id !== MENU_SEPARATOR &&
                                                                        <div key={p.id} className={'dropdown-item'}
                                                                             onClick={() => {
                                                                                 mSelectCustomFilter.current = null;
                                                                                 setSelectCustomFilter(null);
                                                                                 setIsOpenSource(false);
                                                                                 setSelectSourceValue(p.name);
                                                                                 mSelectAnnoSource.current = p;

                                                                                 mPageNum.current = -1;
                                                                                 //更新列表...
                                                                                 updateList();
                                                                                 // if (!isIngoreSelectSave()) {
                                                                                 //     localStorage.setItem(KEY_FILTER_SELECT_TAG, p.label);
                                                                                 // }

                                                                                 refreshClearFilterVisible()
                                                                             }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{p.type == 'card'?getCardTitle0(p):(p.name || t("Untitled"))}</span>
                                                                        </div>
                                                                    }
                                                                </>
                                                        )
                                                    }
                                                    {
                                                        // arrayAnnoSource.length == 0 && //默认有个no tags 和横线....
                                                        // <span
                                                        //     style={{margin: '6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                                                    }
                                                </div>
                                            </>
                                        )
                                    }}
                                    suffixIcon={<img className='img-16'
                                                     onClick={() => setIsOpenTagSelect(true)}
                                                     src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                    dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                                </Select>
                            </ConfigProvider>
                        </div>
                    }


                    {/*清空 过滤条件*/}
                    {
                        isClearFilterVisible &&
                        <img style={{marginLeft: '10px', visibility: isClearFilterVisible ? 'visible' : 'hidden',opacity:isDarkMode()?'0.5':'1'}}
                             className={'img-16 cursor-pointer'}
                             src={getImagePathWithTheme('reset_search')}
                             onClick={() => {
                                 mSelectTag.current = t('Tags');
                                 mSelectProjectId = 'all';
                                 setSelectProjectValue('all')
                                 setSelectTagValue(t('Tags'));
                                 setIsClearFilterVisible(false);
                                 setSelectCustomFilter(null);
                                 mSelectCustomFilter.current = null;
                                 setSelectSourceValue(t("Source"));
                                 setOnlyAnno(false);
                                 mOnlyAnno.current = false;
                                 mSelectAnnoSource.current = null;
                                 exitShowHiddenCard();
                                 //选择所有类型
                                 const arrayNewTypes = [...arrayLibraryTypes];
                                 arrayNewTypes.forEach(p => {
                                     p.isChecked = true;
                                 })
                                 setArrayLibraryTypes(arrayNewTypes);

                                 //switch type选中all
                                 const arrayTypeSwitchNew = [...arrayTypeSwitcher];
                                 arrayTypeSwitchNew.forEach(p => {
                                     p.isSelected = (p.value == 'all')
                                 })
                                 setArrayTypeSwitcher(arrayTypeSwitchNew);

                                 if (!isIngoreSelectSave()) {
                                     localStorage.setItem(KEY_FILTER_SELECT_PROJECT, 'all');
                                     localStorage.setItem(KEY_FILTER_SELECT_TAG, t('Tags'))
                                     localStorage.setItem(KEY_FILTER_CUSTOM_FILTER, '');
                                     localStorage.setItem(KEY_LIBRARY_SELECTED_TYPES, JSON.stringify(arrayNewTypes));
                                     localStorage.setItem(KEY_TYPE_SWITCHER, JSON.stringify(arrayTypeSwitchNew));
                                 }

                                 mPageNum.current = 0;
                                 updateList(true)
                             }}/>
                    }


                    {/*选择---new card/pdf/video/audio/image*/}
                    {
                        props.from != FROM_LIBRARY && props.from != FROM_ADD && !isShowChecked &&
                        <>
                            <div style={{padding: '0 0px', marginLeft: '12px', flexShrink: '0', marginRight: '16px',color:'var(--text-dark-gray-color)'}}
                                 className={'flex-center cursor-pointer default-font-size hovered-text-main-blue-color no-drag'}
                                 onClick={() => {
                                     setIsShowChecked(!isShowChecked);
                                     let szSelectedTitle = t("Items selected").replace('{0}', '0');
                                     setShowCheckedTitle(szSelectedTitle)
                                 }}>{t("Select1")}</div>


                            {/*<div style={{flexGrow: '1'}}></div>*/}

                            {/*//  new card  new card   new card*/}
                            {
                                false &&
                                // arrayLibraryTypes.filter(p=>p.isChecked && p.value != 'journal').length == 1 &&
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div
                                        className='button-max-height newcard-border-gray-style flex-center font-size-12'
                                        onClick={() => {
                                            // onAddNewItem();
                                            Global.g_currentNoteData = {id: generateRandomPageKey()}
                                            openEditor(Global.g_currentNoteData.id, false, props.from == FROM_LIBRARY, FROM_HOME_LIBRARY);
                                        }}
                                        onMouseEnter={() => setIsNewCardHover(true)}
                                        onMouseLeave={() => setIsNewCardHover(false)}
                                        style={{
                                            marginLeft: '1px',
                                            height: '32px',
                                            borderRadius: '8px',
                                            minWidth: '105px'
                                        }}>
                                        <img className='img-mini-small-12'
                                             src={imgPathPerfix() + (isNewCardHover ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add_black.png'))}/>
                                        <span className='ml-6'>{t("New card")}</span>
                                    </div>
                                </div>
                            }


                            {/*导入 import*/}
                            {
                                // selectType?.value == 'card' &&
                                <div style={{display: 'flex', alignItems: 'center',marginLeft:'auto'}}>
                                    {/*<div*/}
                                    {/*    className='button-max-height newcard-border-gray-style flex-center font-size-12'*/}
                                    {/*    onClick={() => {*/}
                                    {/*        // importMarkdown();*/}
                                    {/*        fileSelectRef.current?.click();*/}
                                    {/*    }}*/}
                                    {/*    style={{*/}
                                    {/*        marginLeft: '12px',*/}
                                    {/*        height: '32px',*/}
                                    {/*        borderRadius: '8px',*/}
                                    {/*        minWidth: '78px'*/}
                                    {/*    }}>*/}
                                    {/*    <span>{t("Import")}</span>*/}
                                    {/*</div>*/}

                                    {/*<img className={'img-32 ml-10 cursor-pointer'} src={getImagePathWithTheme('library_import')} onClick={()=>{*/}
                                    {/*    fileSelectRef.current?.click();*/}
                                    {/*}}/>*/}

                                    <Dropdown overlayClassName='default-dropdown-style'
                                              overlayStyle={{minWidth: '160px'}}
                                              menu={{items: getLibraryMoreMenu()}} trigger={['click']}>
                                        <img className={'img-32 ml-10 cursor-pointer'}
                                             onClick={(e) => e.preventDefault()}
                                             src={getImagePathWithTheme('library_more_1.svg')}/>
                                    </Dropdown>

                                    {
                                        rightSliderWidth == 0 &&
                                        <img className='img-32 hovered-gray-radius'
                                             style={{
                                                 marginLeft: APP_WEB_WWW ? '8px' : '8px',
                                                 marginRight: '-7px',
                                                 marginTop: '0px'
                                             }}
                                             src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                            window.openRightSlider(null, 'card');
                                        }}/>
                                    }
                                </div>
                            }

                        </>
                    }

                    {
                        props.from == FROM_LIBRARY &&
                        <>
                            {/*<div style={{flexGrow: '1'}}></div>*/}
                            <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                                      menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                                      onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                                <div className={'flex-center'} style={{
                                    width: '16px',
                                    height: '32px',
                                    marginLeft:'auto',
                                    borderRadius: '8px',
                                    flexShrink:'0px',
                                    border: '0px solid var(--border-color)',
                                }}>
                                    <img className={'img-16  cursor-pointer'}
                                         src={getImagePathWithTheme('library_filter.svg')}
                                         onClick={(e) => e.preventDefault()}/>
                                </div>
                                {/*<img className={'img-16 cursor-pointer ml-12'} style={{flexShrink: '0'}}*/}
                                {/*     onClick={(e) => e.preventDefault()}*/}
                                {/*     src={getImagePathWithTheme('icon_sort')}/>*/}
                            </Dropdown>

                        </>
                    }

                    {
                        isShowSearch &&
                        <Input prefix={<IconHomeSearch/>} id={'input-library-search-1'}
                               suffix={renderSuffix()}
                               variant={"borderless"}
                               style={{
                                   position: 'absolute',
                                   width: 'calc(100% - 42px)',
                                   height: '32px',
                                   backgroundColor: 'var(--input-background-color)',
                               }}
                               placeholder={t("Search library")} value={searchKey} onChange={(event) => {
                            mSearchKey.current = event.currentTarget.value;
                            setSearchKey(mSearchKey.current);
                            setIsSearching(true);

                            //清除上一次的计时
                            clearTimeout(mLastSearchTimeoutId.current);
                            mLastSearchTimeoutId.current = setTimeout(() => {
                                doSearch();
                                clearTimeout(mLastSearchTimeoutId.current);
                            }, 1500);
                        }}
                        />
                    }

                    {
                        props.from == FROM_ADD &&
                        <>
                            <div style={{flexGrow: '1'}}></div>
                            <img className={'img-16 mr-4 cursor-pointer'} src={getImagePathWithTheme('note_search')}
                                 onClick={() => {
                                     setIsShowSearch(true);
                                     setSearchKey('');
                                     setTimeout(() => {
                                         document.getElementById('input-library-search-1')?.focus();
                                     }, 200)

                                 }}/>
                        </>

                    }

                </div>

                {/*{*/}
                {/*    props.from != FROM_LIBRARY &&*/}
                {/*    <div className={style.homeLine} style={{marginLeft: '-320px', marginRight: '-20px'}}/>*/}
                {/*}*/}


                {/*标题*/}
                {
                    props.from != FROM_LIBRARY && props.from != FROM_ADD &&
                    <div className={style.title} style={{marginTop: `${PAGE_TITLE_MARGIN_TOP}px`, padding: '0 20px 0 20px'}}>
                        {
                            renderTitleRow()
                        }
                    </div>
                }

                <div className={'line'} style={{marginTop:'6px'}}></div>

                {/*grid列表*/}
                <div id={'div-grid-container-'+mThisID.current} ref={divGridContainerRef} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: '1',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    padding: '0 0px',
                    marginTop: '8px',
                }} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove}>
                    {
                        renderCardList1()
                    }
                </div>

                <DialogTagManager ref={dialogTagManagerRef} from={"library"}
                                  onDismissCallback={(isTagChange: boolean) => {
                                      //标签更改了，需要刷新数据....
                                      //加了个确定按钮，必须要全部刷新了。。
                                      mPageNum.current = 0;
                                      updateList();
                                      updateTagList();
                                  }}/>

                {/*隐藏的文件选择*/}
                <div className="file-selector">
                    <input
                        ref={fileSelectRef}
                        type="file"
                        id="file-input-page-library"
                        multiple={selectType?.value == 'image'}
                        // accept={selectType?.ext}
                        accept={acceptExt}
                        style={{display: 'none'}}
                        onChange={handleFileChange}
                    />
                </div>

                <DialogMessageBox ref={dialogMessageRef}/>

                <DialogCommonInput ref={dialogCommonInputRef}/>

                <DialogAllTagManager ref={dialogAllTagManagerRef} onDismissCallback={() => {
                    //关闭后刷新数据........
                    mPageNum.current = 0;
                    updateList();
                    updateTagList()
                }}/>

                {
                    isShowDialogChooseImage &&
                    <DialogChooseImage ref={dialogChooseImageRef} onOkClicked={(obj: any) => {
                        if (obj.action == 'uploadImage') {
                            setAcceptExt(getImageExt());
                            setTimeout(()=>{
                                fileSelectRef.current?.click();
                            },100)
                        } else {
                            var event = {target: {files: obj.file}};
                            handleFileChange(event)
                        }
                    }} from={FROM_LIBRARY}/>
                }

                {
                    tipsInfo &&
                    <div className={'flex-center'} style={{
                        position: 'absolute',
                        zIndex: '11',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        top: '80px',
                        height: '36px',
                        borderRadius: '8px',
                        padding: '0 26px',
                        minWidth: '180px',
                        boxShadow: 'var(--dialog-box-shadow)'
                    }}>
                        <span>{tipsInfo}</span>
                        <span style={{textDecoration: 'none', marginLeft: '22px'}}
                              className={'link-color cursor-pointer'} onClick={() => {
                            //打开这个project....
                            if (mProjectInfo) {
                                window.navigateOrigin(getDrawPath(), {state: {noteData: mProjectInfo, searchKey: ''}})
                            }
                        }}>{t("View")}</span>
                    </div>
                }

                {
                    isEmptyData && isStringNullOrEmpty(searchKey) &&
                    <span style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%,-50%)', color: 'var(--text-color-66666)',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '22px',
                        textAlign: 'center'
                    }}>{getEmptyTips()}</span>
                }

                {/*搜索结果*/}
                {
                    arrayCardList.length == 0 && !isStringNullOrEmpty(searchKey) &&
                    <div style={{
                        position: 'absolute',
                        left: '50%',
                        top: '10%',
                        transform: 'translateX(-50%)',
                        display: isStringNullOrEmpty(searchKey) ? 'none' : 'inline'
                    }}>
                        <div className={'flex-column-center'}
                             style={{
                                 display: arrayCardList.length === 0 ? 'flex' : 'none',
                                 zIndex: '100',
                                 marginTop: '36px'
                             }}>
                            <img style={{height: '294px', width: '294px'}}
                                 src={getImagePathWithTheme("search_no_result")}></img>
                            <span className='description-color ml-8' style={{
                                textAlign: 'center',
                                lineHeight: '22px'
                            }}>{t("No results found").replace('%s', searchKey)}</span>
                        </div>
                    </div>
                }

                {
                    isLoading &&
                    <div style={{
                        position: 'absolute',
                        zIndex: '2004',
                        left: LEFT_MENU_WIDTH + 'px',
                        top: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 'calc(100% - ' + LEFT_MENU_WIDTH * 2 + 'px)',
                        height: '100%'
                    }}>
                        <Spin indicator={IconIndicatorBlue} spinning={isLoading}>

                        </Spin>
                    </div>

                }

                {
                    // <div style={{background:'transparent',
                    //     width:`calc(100% - ${44}px)`,
                    //     position:'absolute',
                    //     left:'22px',top:'50px',
                    //     height:'32px',display:'flex',
                    //     alignItems:'center',
                    //     borderRadius:'2px',
                    //     boxShadow:'var(--dialog-box-shadow)',
                    //     padding:'0 6px'}}>
                    //     <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('window_close_black')}/>
                    // </div>
                }

            </div>

            {/*right*/}
            {
                props.from != FROM_LIBRARY && props.source != 'dialogLink' &&
                <div style={{width: `${rightSliderWidth}px`}}></div>
            }

        </div>
    )
})

export default PageLibrary;














